"use es6";

function _mergeNamespaces(n, m) {
  m.forEach(function (e) {
    e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function (k) {
      if (k !== 'default' && !(k in n)) {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  });
  return Object.freeze(n);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign$ = function __assign$1() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign$.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __values$1(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$1(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var IdentifyOperation;
(function (IdentifyOperation) {
  // Base Operations to set values
  IdentifyOperation["SET"] = "$set";
  IdentifyOperation["SET_ONCE"] = "$setOnce";
  // Operations around modifying existing values
  IdentifyOperation["ADD"] = "$add";
  IdentifyOperation["APPEND"] = "$append";
  IdentifyOperation["PREPEND"] = "$prepend";
  IdentifyOperation["REMOVE"] = "$remove";
  // Operations around appending values *if* they aren't present
  IdentifyOperation["PREINSERT"] = "$preInsert";
  IdentifyOperation["POSTINSERT"] = "$postInsert";
  // Operations around removing properties/values
  IdentifyOperation["UNSET"] = "$unset";
  IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));
/**
 * Strings that have special meaning when used as an event's type
 * and have different specifications.
 */
var SpecialEventType;
(function (SpecialEventType) {
  SpecialEventType["IDENTIFY"] = "$identify";
  SpecialEventType["GROUP_IDENTIFY"] = "$groupidentify";
  SpecialEventType["REVENUE"] = "revenue_amount";
})(SpecialEventType || (SpecialEventType = {}));
var DEFAULT_INSTANCE_NAME = '$default_instance';
var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
var EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
var AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
var EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch';

/** The status of an event. */
var Status;
(function (Status) {
  /** The status could not be determined. */
  Status["Unknown"] = "unknown";
  /** The event was skipped due to configuration or callbacks. */
  Status["Skipped"] = "skipped";
  /** The event was sent successfully. */
  Status["Success"] = "success";
  /** A user or device in the payload is currently rate limited and should try again later. */
  Status["RateLimit"] = "rate_limit";
  /** The sent payload was too large to be processed. */
  Status["PayloadTooLarge"] = "payload_too_large";
  /** The event could not be processed. */
  Status["Invalid"] = "invalid";
  /** A server-side error ocurred during submission. */
  Status["Failed"] = "failed";
  /** a server or client side error occuring when a request takes too long and is cancelled */
  Status["Timeout"] = "Timeout";
  /** NodeJS runtime environment error.. E.g. disconnected from network */
  Status["SystemError"] = "SystemError";
})(Status || (Status = {}));

/* eslint-disable no-restricted-globals */
/* Only file allowed to access to globalThis, window, self */
var getGlobalScope = function getGlobalScope() {
  // This should only be used for integrations with Amplitude that are not running in a browser environment
  //   We need to specify the name of the global variable as a string to prevent it from being minified
  var ampIntegrationContextName = 'ampIntegrationContext';
  if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') {
    return globalThis[ampIntegrationContextName];
  }
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  return undefined;
};

/**
 * Source: [jed's gist's comment]{@link https://gist.github.com/jed/982883?permalink_comment_id=3223002#gistcomment-3223002}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */
var legacyUUID = function legacyUUID(a) {
  return a // if the placeholder was passed, return
  ?
  // a random number from 0 to 15
  (a ^
  // unless b is 8,
  Math.random() *
  // in which case
  16 >>
  // a random number from
  a / 4 // 8 to 11
  ).toString(16) // in hexadecimal
  :
  // or otherwise a concatenated string:
  (String(1e7) +
  // 10000000 +
  String(-1e3) +
  // -1000 +
  String(-4e3) +
  // -4000 +
  String(-8e3) +
  // -80000000 +
  String(-1e11) // -100000000000,
  ).replace(
  // replacing
  /[018]/g,
  // zeroes, ones, and eights with
  UUID);
};
var hex = __spreadArray([], __read$1(Array(256).keys()), false).map(function (index) {
  return index.toString(16).padStart(2, '0');
});
var UUID = function UUID(a) {
  var _a;
  var globalScope = getGlobalScope();
  /* istanbul ignore next */
  if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues)) {
    // Fallback to legacy UUID generation if crypto is not available
    return legacyUUID(a);
  }
  var r = globalScope.crypto.getRandomValues(new Uint8Array(16));
  r[6] = r[6] & 0x0f | 0x40;
  r[8] = r[8] & 0x3f | 0x80;
  return __spreadArray([], __read$1(r.entries()), false).map(function (_a) {
    var _b = __read$1(_a, 2),
      index = _b[0],
      int = _b[1];
    return [4, 6, 8, 10].includes(index) ? "-".concat(hex[int]) : hex[int];
  }).join('');
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var safeJsonStringify$1 = {
  exports: {}
};
var hasRequiredSafeJsonStringify;
function requireSafeJsonStringify() {
  if (hasRequiredSafeJsonStringify) return safeJsonStringify$1.exports;
  hasRequiredSafeJsonStringify = 1;
  var hasProp = Object.prototype.hasOwnProperty;
  function throwsMessage(err) {
    return '[Throws: ' + (err ? err.message : '?') + ']';
  }
  function safeGetValueFromPropertyOnObject(obj, property) {
    if (hasProp.call(obj, property)) {
      try {
        return obj[property];
      } catch (err) {
        return throwsMessage(err);
      }
    }
    return obj[property];
  }
  function ensureProperties(obj) {
    var seen = []; // store references to objects we have seen before

    function visit(obj) {
      if (obj === null || typeof obj !== 'object') {
        return obj;
      }
      if (seen.indexOf(obj) !== -1) {
        return '[Circular]';
      }
      seen.push(obj);
      if (typeof obj.toJSON === 'function') {
        try {
          var fResult = visit(obj.toJSON());
          seen.pop();
          return fResult;
        } catch (err) {
          return throwsMessage(err);
        }
      }
      if (Array.isArray(obj)) {
        var aResult = obj.map(visit);
        seen.pop();
        return aResult;
      }
      var result = Object.keys(obj).reduce(function (result, prop) {
        // prevent faulty defined getter properties
        result[prop] = visit(safeGetValueFromPropertyOnObject(obj, prop));
        return result;
      }, {});
      seen.pop();
      return result;
    }
    return visit(obj);
  }
  safeJsonStringify$1.exports = function (data, replacer, space) {
    return JSON.stringify(ensureProperties(data), replacer, space);
  };
  safeJsonStringify$1.exports.ensureProperties = ensureProperties;
  return safeJsonStringify$1.exports;
}
var safeJsonStringifyExports = requireSafeJsonStringify();
var index$1 = /*@__PURE__*/getDefaultExportFromCjs(safeJsonStringifyExports);
var safeJsonStringifyModule = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  default: index$1
}, [safeJsonStringifyExports]);

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* istanbul ignore next */
var safeJsonStringify = index$1 || safeJsonStringifyModule;
var returnWrapper = function returnWrapper(awaitable) {
  return {
    promise: awaitable || Promise.resolve()
  };
};
var LogLevel;
(function (LogLevel) {
  LogLevel[LogLevel["None"] = 0] = "None";
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Warn"] = 2] = "Warn";
  LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
  LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));
var PREFIX = 'Amplitude Logger ';
var Logger = /** @class */function () {
  function Logger() {
    this.logLevel = LogLevel.None;
  }
  Logger.prototype.disable = function () {
    this.logLevel = LogLevel.None;
  };
  Logger.prototype.enable = function (logLevel) {
    if (logLevel === void 0) {
      logLevel = LogLevel.Warn;
    }
    this.logLevel = logLevel;
  };
  Logger.prototype.log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Verbose) {
      return;
    }
    console.log("".concat(PREFIX, "[Log]: ").concat(args.join(' ')));
  };
  Logger.prototype.warn = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Warn) {
      return;
    }
    console.warn("".concat(PREFIX, "[Warn]: ").concat(args.join(' ')));
  };
  Logger.prototype.error = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Error) {
      return;
    }
    console.error("".concat(PREFIX, "[Error]: ").concat(args.join(' ')));
  };
  Logger.prototype.debug = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Debug) {
      return;
    }
    // console.debug output is hidden by default in chrome
    console.log("".concat(PREFIX, "[Debug]: ").concat(args.join(' ')));
  };
  return Logger;
}();
var normalizeInstanceName = function normalizeInstanceName(instanceName) {
  return instanceName === undefined || instanceName === '' ? DEFAULT_INSTANCE_NAME : instanceName;
};
var getDefaultConfig$1 = function getDefaultConfig$1() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 10000,
    instanceName: DEFAULT_INSTANCE_NAME,
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    offline: false,
    optOut: false,
    serverUrl: AMPLITUDE_SERVER_URL,
    serverZone: 'US',
    useBatch: false
  };
};
var Config = /** @class */function () {
  function Config(options) {
    var _a, _b, _c, _d;
    this._optOut = false;
    var defaultConfig = getDefaultConfig$1();
    this.apiKey = options.apiKey;
    this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
    this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
    this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
    this.instanceName = normalizeInstanceName(options.instanceName);
    this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
    this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
    this.minIdLength = options.minIdLength;
    this.plan = options.plan;
    this.ingestionMetadata = options.ingestionMetadata;
    this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
    this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
    this.serverUrl = options.serverUrl;
    this.serverZone = options.serverZone || defaultConfig.serverZone;
    this.storageProvider = options.storageProvider;
    this.transportProvider = options.transportProvider;
    this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
    this.loggerProvider.enable(this.logLevel);
    var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
    this.serverZone = serverConfig.serverZone;
    this.serverUrl = serverConfig.serverUrl;
  }
  Object.defineProperty(Config.prototype, "optOut", {
    get: function () {
      return this._optOut;
    },
    set: function (optOut) {
      this._optOut = optOut;
    },
    enumerable: false,
    configurable: true
  });
  return Config;
}();
var getServerUrl$1 = function getServerUrl$1(serverZone, useBatch) {
  if (serverZone === 'EU') {
    return useBatch ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL;
  }
  return useBatch ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL;
};
var createServerConfig = function createServerConfig(serverUrl, serverZone, useBatch) {
  if (serverUrl === void 0) {
    serverUrl = '';
  }
  if (serverZone === void 0) {
    serverZone = getDefaultConfig$1().serverZone;
  }
  if (useBatch === void 0) {
    useBatch = getDefaultConfig$1().useBatch;
  }
  if (serverUrl) {
    return {
      serverUrl: serverUrl,
      serverZone: undefined
    };
  }
  var _serverZone = ['US', 'EU'].includes(serverZone) ? serverZone : getDefaultConfig$1().serverZone;
  return {
    serverZone: _serverZone,
    serverUrl: getServerUrl$1(_serverZone, useBatch)
  };
};

/**
 * Checks if an HTTP status code indicates success (2xx range)
 * @param code - The HTTP status code to check
 * @returns true if the status code is in the 2xx range, false otherwise
 */
function isSuccessStatusCode(code) {
  return code >= 200 && code < 300;
}
var getStacktrace = function getStacktrace(ignoreDepth) {
  var trace = new Error().stack || '';
  return trace.split('\n').slice(2 + ignoreDepth).map(function (text) {
    return text.trim();
  });
};
var debugWrapper = function debugWrapper(fn, fnName, getLogConfig, getStates, fnContext) {
  if (fnContext === void 0) {
    fnContext = null;
  }
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _a = getLogConfig(),
      logger = _a.logger,
      logLevel = _a.logLevel;
    // return early if possible to reduce overhead
    if (logLevel && logLevel < LogLevel.Debug || !logLevel || !logger) {
      return fn.apply(fnContext, args);
    }
    var debugContext = {
      type: 'invoke public method',
      name: fnName,
      args: args,
      stacktrace: getStacktrace(1),
      time: {
        start: new Date().toISOString()
      },
      states: {}
    };
    var result = fn.apply(fnContext, args);
    if (result && result.promise) {
      // if result is a promise, add the callback
      result.promise.then(function () {
        if (debugContext.time) {
          debugContext.time.end = new Date().toISOString();
        }
        logger.debug(JSON.stringify(debugContext, null, 2));
      });
    } else {
      if (debugContext.time) {
        debugContext.time.end = new Date().toISOString();
      }
      logger.debug(JSON.stringify(debugContext, null, 2));
    }
    return result;
  };
};
var ApplicationContextProviderImpl = /** @class */function () {
  function ApplicationContextProviderImpl() {}
  ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
    return {
      versionName: this.versionName,
      language: getLanguage(),
      platform: 'Web',
      os: undefined,
      deviceModel: undefined
    };
  };
  return ApplicationContextProviderImpl;
}();
var getLanguage = function getLanguage() {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */function () {
  function EventBridgeImpl() {
    this.queue = [];
  }
  EventBridgeImpl.prototype.logEvent = function (event) {
    if (!this.receiver) {
      if (this.queue.length < 512) {
        this.queue.push(event);
      }
    } else {
      this.receiver(event);
    }
  };
  EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
    this.receiver = receiver;
    if (this.queue.length > 0) {
      this.queue.forEach(function (event) {
        receiver(event);
      });
      this.queue = [];
    }
  };
  return EventBridgeImpl;
}();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function isEqual(obj1, obj2) {
  var e_1, _a;
  var primitive = ['string', 'number', 'boolean', 'undefined'];
  var typeA = typeof obj1;
  var typeB = typeof obj2;
  if (typeA !== typeB) {
    return false;
  }
  try {
    for (var primitive_1 = __values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()) {
      var p = primitive_1_1.value;
      if (p === typeA) {
        return obj1 === obj2;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  // check null
  if (obj1 == null && obj2 == null) {
    return true;
  } else if (obj1 == null || obj2 == null) {
    return false;
  }
  // if got here - objects
  if (obj1.length !== obj2.length) {
    return false;
  }
  //check if arrays
  var isArrayA = Array.isArray(obj1);
  var isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA && isArrayB) {
    //arrays
    for (var i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    //objects
    var sorted1 = Object.keys(obj1).sort();
    var sorted2 = Object.keys(obj2).sort();
    if (!isEqual(sorted1, sorted2)) {
      return false;
    }
    //compare object values
    var result_1 = true;
    Object.keys(obj1).forEach(function (key) {
      if (!isEqual(obj1[key], obj2[key])) {
        result_1 = false;
      }
    });
    return result_1;
  }
  return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}
var IdentityStoreImpl = /** @class */function () {
  function IdentityStoreImpl() {
    this.identity = {
      userProperties: {}
    };
    this.listeners = new Set();
  }
  IdentityStoreImpl.prototype.editIdentity = function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    var actingUserProperties = _assign({}, this.identity.userProperties);
    var actingIdentity = _assign(_assign({}, this.identity), {
      userProperties: actingUserProperties
    });
    return {
      setUserId: function (userId) {
        actingIdentity.userId = userId;
        return this;
      },
      setDeviceId: function (deviceId) {
        actingIdentity.deviceId = deviceId;
        return this;
      },
      setUserProperties: function (userProperties) {
        actingIdentity.userProperties = userProperties;
        return this;
      },
      setOptOut: function (optOut) {
        actingIdentity.optOut = optOut;
        return this;
      },
      updateUserProperties: function (actions) {
        var e_1, _a, e_2, _b, e_3, _c;
        var actingProperties = actingIdentity.userProperties || {};
        try {
          for (var _d = __values(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var _f = __read(_e.value, 2),
              action = _f[0],
              properties = _f[1];
            switch (action) {
              case ID_OP_SET:
                try {
                  for (var _g = (e_2 = void 0, __values(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var _j = __read(_h.value, 2),
                      key = _j[0],
                      value = _j[1];
                    actingProperties[key] = value;
                  }
                } catch (e_2_1) {
                  e_2 = {
                    error: e_2_1
                  };
                } finally {
                  try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                  } finally {
                    if (e_2) throw e_2.error;
                  }
                }
                break;
              case ID_OP_UNSET:
                try {
                  for (var _k = (e_3 = void 0, __values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var key = _l.value;
                    delete actingProperties[key];
                  }
                } catch (e_3_1) {
                  e_3 = {
                    error: e_3_1
                  };
                } finally {
                  try {
                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                  } finally {
                    if (e_3) throw e_3.error;
                  }
                }
                break;
              case ID_OP_CLEAR_ALL:
                actingProperties = {};
                break;
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        actingIdentity.userProperties = actingProperties;
        return this;
      },
      commit: function () {
        self.setIdentity(actingIdentity);
        return this;
      }
    };
  };
  IdentityStoreImpl.prototype.getIdentity = function () {
    return _assign({}, this.identity);
  };
  IdentityStoreImpl.prototype.setIdentity = function (identity) {
    var originalIdentity = _assign({}, this.identity);
    this.identity = _assign({}, identity);
    if (!isEqual(originalIdentity, this.identity)) {
      this.listeners.forEach(function (listener) {
        listener(identity);
      });
    }
  };
  IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
    this.listeners.add(listener);
  };
  IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
    this.listeners.delete(listener);
  };
  return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
var AnalyticsConnector = /** @class */function () {
  function AnalyticsConnector() {
    this.identityStore = new IdentityStoreImpl();
    this.eventBridge = new EventBridgeImpl();
    this.applicationContextProvider = new ApplicationContextProviderImpl();
  }
  AnalyticsConnector.getInstance = function (instanceName) {
    if (!safeGlobal['analyticsConnectorInstances']) {
      safeGlobal['analyticsConnectorInstances'] = {};
    }
    if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
      safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
    }
    return safeGlobal['analyticsConnectorInstances'][instanceName];
  };
  return AnalyticsConnector;
}();
var getAnalyticsConnector = function getAnalyticsConnector(instanceName) {
  return AnalyticsConnector.getInstance(normalizeInstanceName(instanceName));
};
var generateHashCode = function generateHashCode(str) {
  var hash = 0;
  if (str.length === 0) return hash;
  for (var i = 0; i < str.length; i++) {
    var chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};
var isTimestampInSample = function isTimestampInSample(timestamp, sampleRate) {
  var hashNumber = generateHashCode(timestamp.toString());
  var absHash = Math.abs(hashNumber);
  var absHashMultiply = absHash * 31;
  var mod = absHashMultiply % 1000000;
  return mod / 1000000 < sampleRate;
};
var BaseTransport = /** @class */function () {
  function BaseTransport() {}
  BaseTransport.prototype.send = function (_serverUrl, _payload, _enableRequestBodyCompression) {
    return Promise.resolve(null);
  };
  BaseTransport.prototype.buildResponse = function (responseJSON) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    if (typeof responseJSON !== 'object') {
      return null;
    }
    var statusCode = responseJSON.code || 0;
    var status = this.buildStatus(statusCode);
    switch (status) {
      case Status.Success:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
            payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
            serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
          }
        };
      case Status.Invalid:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
            missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
            eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
            eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
            eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
            epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
            exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
            silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
            silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
            throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
            throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
          }
        };
      case Status.PayloadTooLarge:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
          }
        };
      case Status.RateLimit:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
            epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
            throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
            throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
            exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
            exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
            throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
          }
        };
      case Status.Timeout:
      default:
        return {
          status: status,
          statusCode: statusCode
        };
    }
  };
  BaseTransport.prototype.buildStatus = function (code) {
    if (isSuccessStatusCode(code)) {
      return Status.Success;
    }
    if (code === 429) {
      return Status.RateLimit;
    }
    if (code === 413) {
      return Status.PayloadTooLarge;
    }
    if (code === 408) {
      return Status.Timeout;
    }
    if (code >= 400 && code < 500) {
      return Status.Invalid;
    }
    if (code >= 500) {
      return Status.Failed;
    }
    return Status.Unknown;
  };
  return BaseTransport;
}();
var FetchTransport = /** @class */function (_super) {
  __extends(FetchTransport, _super);
  function FetchTransport(customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }
    var _this = _super.call(this) || this;
    _this.customHeaders = customHeaders;
    return _this;
  }
  FetchTransport.prototype.send = function (serverUrl, payload) {
    return __awaiter(this, void 0, void 0, function () {
      var options, response, responseText;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            /* istanbul ignore if */
            if (typeof fetch === 'undefined') {
              throw new Error('FetchTransport is not supported');
            }
            options = {
              headers: _assign$({
                'Content-Type': 'application/json',
                Accept: '*/*'
              }, this.customHeaders),
              body: JSON.stringify(payload),
              method: 'POST'
            };
            return [4 /*yield*/, fetch(serverUrl, options)];
          case 1:
            response = _a.sent();
            return [4 /*yield*/, response.text()];
          case 2:
            responseText = _a.sent();
            try {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              return [2 /*return*/, this.buildResponse(JSON.parse(responseText))];
            } catch (_b) {
              return [2 /*return*/, this.buildResponse({
                code: response.status
              })];
            }
            return [2 /*return*/];
        }
      });
    });
  };
  return FetchTransport;
}(BaseTransport);
var RemoteConfigLocalStorage = /** @class */function () {
  function RemoteConfigLocalStorage(apiKey, logger) {
    this.key = "AMP_remote_config_".concat(apiKey.substring(0, 10));
    this.logger = logger;
    try {
      this.isSupported = typeof localStorage !== 'undefined';
    } catch (error) {
      this.logger.debug('Remote config localstorage failed to access: ', error);
      this.isSupported = false;
    }
  }
  RemoteConfigLocalStorage.prototype.fetchConfig = function () {
    var result = null;
    var failedRemoteConfigInfo = {
      remoteConfig: null,
      lastFetch: new Date()
    };
    if (!this.isSupported) {
      return Promise.resolve(failedRemoteConfigInfo);
    }
    try {
      result = localStorage.getItem(this.key);
    } catch (error) {
      this.logger.debug('Remote config localstorage failed to access: ', error);
      return Promise.resolve(failedRemoteConfigInfo);
    }
    if (result === null) {
      this.logger.debug('Remote config localstorage gets null because the key does not exist');
      return Promise.resolve(failedRemoteConfigInfo);
    }
    try {
      var remoteConfigInfo = JSON.parse(result);
      this.logger.debug("Remote config localstorage parsed successfully: ".concat(safeJsonStringify(remoteConfigInfo)));
      return Promise.resolve({
        remoteConfig: remoteConfigInfo.remoteConfig,
        lastFetch: new Date(remoteConfigInfo.lastFetch)
      });
    } catch (error) {
      this.logger.debug('Remote config localstorage failed to parse: ', error);
      localStorage.removeItem(this.key);
      return Promise.resolve(failedRemoteConfigInfo);
    }
  };
  RemoteConfigLocalStorage.prototype.setConfig = function (config) {
    if (!this.isSupported) {
      return Promise.resolve(false);
    }
    try {
      localStorage.setItem(this.key, JSON.stringify(config));
      this.logger.debug('Remote config localstorage set successfully.');
      return Promise.resolve(true);
    } catch (error) {
      this.logger.debug('Remote config localstorage failed to set: ', error);
    }
    return Promise.resolve(false);
  };
  return RemoteConfigLocalStorage;
}();

/**
 * Settles with `promise`, but rejects with an AbortError when `signal` fires. The request-timeout
 * signal is handed to customFetch, but a transport that ignores it would block the await (and the
 * retry loop) indefinitely; racing the abort guarantees the client-side timeout always applies.
 * The transport's own promise keeps running — we can't cancel it — we just stop awaiting it.
 */
function abortableFetch(promise, signal) {
  return new Promise(function (resolve, reject) {
    var onAbort = function onAbort() {
      // Match how a native aborted fetch rejects (name 'AbortError') so fetch()'s catch logs it
      // as a timeout; either way the loop retries since the abort doesn't clear shouldRetry.
      var err = new Error('Remote config custom fetch aborted by timeout');
      err.name = 'AbortError';
      reject(err);
    };
    signal.addEventListener('abort', onAbort, {
      once: true
    });
    promise.then(function (value) {
      signal.removeEventListener('abort', onAbort);
      resolve(value);
    }, function (err) {
      signal.removeEventListener('abort', onAbort);
      reject(err);
    });
  });
}
var US_SERVER_URL = 'https://sr-client-cfg.amplitude.com/config';
var EU_SERVER_URL = 'https://sr-client-cfg.eu.amplitude.com/config';
var DEFAULT_MAX_RETRIES = 3;
var CODE_STATUS = {
  INVALID_API_KEY: 401,
  FORBIDDEN: 403,
  RATE_LIMIT: 429
};
/**
 * The default timeout for fetch in milliseconds.
 * Linear backoff policy: timeout / retry times is the interval between fetch retry.
 */
var DEFAULT_TIMEOUT$1 = 1000;
/**
 * The minimum time between fetches in milliseconds.
 * This prevents too many requests from being sent in a short period of time.
 */
var DEFAULT_MIN_TIME_BETWEEN_FETCHES = 5 * 60 * 1000; // 5 minutes
var RemoteConfigClient = /** @class */function () {
  function RemoteConfigClient(apiKey, logger, serverZone, serverUrl, customFetch, configGroup, customStorage) {
    if (serverZone === void 0) {
      serverZone = 'US';
    }
    if (configGroup === void 0) {
      configGroup = RemoteConfigClient.DEFAULT_CONFIG_GROUP;
    }
    // Registered callbackInfos by subscribe().
    this.callbackInfos = [];
    // Track the last successful fetch time for throttling (timestamp in milliseconds).
    this.lastSuccessfulFetch = null;
    // Store the in-flight fetch promise for deduplication.
    this.fetchPromise = null;
    // Used to skip periodic updateConfigs calls when API key is invalid.
    this.isLastFetchInvalidApiKey = false;
    this.apiKey = apiKey;
    this.configGroup = configGroup;
    this.serverUrl = serverUrl || (serverZone === 'US' ? US_SERVER_URL : EU_SERVER_URL);
    this.logger = logger;
    this.storage = customStorage || new RemoteConfigLocalStorage(apiKey, logger);
    this.customFetch = customFetch;
  }
  RemoteConfigClient.prototype.subscribe = function (key, deliveryMode, callback) {
    var id = UUID();
    var callbackInfo = {
      id: id,
      key: key,
      deliveryMode: deliveryMode,
      callback: callback
    };
    this.callbackInfos.push(callbackInfo);
    if (deliveryMode === 'all') {
      void this.subscribeAll(callbackInfo);
    } else {
      void this.subscribeWaitForRemote(callbackInfo, deliveryMode.timeout);
    }
    return id;
  };
  RemoteConfigClient.prototype.unsubscribe = function (id) {
    var index = this.callbackInfos.findIndex(function (callbackInfo) {
      return callbackInfo.id === id;
    });
    if (index === -1) {
      this.logger.debug("Remote config client unsubscribe failed because callback with id ".concat(id, " doesn't exist."));
      return false;
    }
    this.callbackInfos.splice(index, 1);
    this.logger.debug("Remote config client unsubscribe succeeded removing callback with id ".concat(id, "."));
    return true;
  };
  RemoteConfigClient.prototype.updateConfigs = function () {
    return __awaiter(this, void 0, void 0, function () {
      var timeSinceLastFetch, result;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // Check if we need to throttle based on last successful fetch time
            if (this.lastSuccessfulFetch) {
              timeSinceLastFetch = Date.now() - this.lastSuccessfulFetch;
              if (timeSinceLastFetch < DEFAULT_MIN_TIME_BETWEEN_FETCHES) {
                this.logger.debug('Remote config client skipping updateConfigs: Too recent');
                return [2 /*return*/];
              }
            }
            return [4 /*yield*/, this.getOrCreateFetchPromise()];
          case 1:
            result = _a.sent();
            void this.storage.setConfig(result);
            this.callbackInfos.forEach(function (callbackInfo) {
              _this.sendCallback(callbackInfo, result, 'remote');
            });
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Get the in-flight fetch promise or create a new one.
   * This ensures multiple subscribe calls share the same network request.
   */
  RemoteConfigClient.prototype.getOrCreateFetchPromise = function () {
    var _this = this;
    if (this.fetchPromise) {
      return this.fetchPromise;
    }
    if (this.isLastFetchInvalidApiKey) {
      this.logger.debug('Remote config client skipping fetch: Invalid API key');
      this.fetchPromise = Promise.resolve({
        remoteConfig: null,
        lastFetch: new Date()
      }).finally(function () {
        _this.fetchPromise = null;
      });
      return this.fetchPromise;
    }
    this.fetchPromise = this.fetch().then(function (result) {
      // Update last successful fetch time if we got a valid config
      if (result.remoteConfig !== null) {
        _this.lastSuccessfulFetch = Date.now();
      }
      return result;
    }).finally(function () {
      // Clear the promise after it settles (success or failure)
      _this.fetchPromise = null;
    });
    return this.fetchPromise;
  };
  /**
   * Send remote first. If it's already complete, we can skip the cached response.
   * - if remote is fetched first, no cache fetch.
   * - if cache is fetched first, still fetching remote.
   */
  RemoteConfigClient.prototype.subscribeAll = function (callbackInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var remotePromise, cachePromise, result;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            remotePromise = this.getOrCreateFetchPromise().then(function (result) {
              _this.logger.debug("Remote config client subscription all mode fetched from remote: ".concat(JSON.stringify(result)));
              _this.sendCallback(callbackInfo, result, 'remote');
              void _this.storage.setConfig(result);
            });
            cachePromise = this.storage.fetchConfig().then(function (result) {
              return result;
            });
            return [4 /*yield*/, Promise.race([remotePromise, cachePromise])];
          case 1:
            result = _a.sent();
            // If cache is fetched first, wait for remote.
            if (result !== undefined) {
              this.logger.debug("Remote config client subscription all mode fetched from cache: ".concat(JSON.stringify(result)));
              // Skip sending callback if cache is empty (first time user).
              if (result.remoteConfig !== null) {
                this.sendCallback(callbackInfo, result, 'cache');
              } else {
                this.logger.debug('Remote config client skips sending callback because cache is empty (first time user).');
              }
            }
            return [4 /*yield*/, remotePromise];
          case 2:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Waits for a remote response until the given timeout, then return a cached copy, if available.
   */
  RemoteConfigClient.prototype.subscribeWaitForRemote = function (callbackInfo, timeout) {
    return __awaiter(this, void 0, void 0, function () {
      var timeoutPromise, result, result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            timeoutPromise = new Promise(function (_, reject) {
              setTimeout(function () {
                reject('Timeout exceeded');
              }, timeout);
            });
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 5]);
            return [4 /*yield*/, Promise.race([this.getOrCreateFetchPromise(), timeoutPromise])];
          case 2:
            result = _a.sent();
            this.logger.debug('Remote config client subscription wait for remote mode returns from remote.');
            this.sendCallback(callbackInfo, result, 'remote');
            void this.storage.setConfig(result);
            return [3 /*break*/, 5];
          case 3:
            _a.sent();
            this.logger.debug('Remote config client subscription wait for remote mode exceeded timeout. Try to fetch from cache.');
            return [4 /*yield*/, this.storage.fetchConfig()];
          case 4:
            result = _a.sent();
            if (result.remoteConfig !== null) {
              this.logger.debug('Remote config client subscription wait for remote mode returns a cached copy.');
              this.sendCallback(callbackInfo, result, 'cache');
            } else {
              this.logger.debug('Remote config client subscription wait for remote mode failed to fetch cache.');
              this.sendCallback(callbackInfo, result, 'remote');
            }
            return [3 /*break*/, 5];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Call the callback with filtered remote config based on key.
   * @param remoteConfigInfo - the whole remote config object without filtering by key.
   */
  RemoteConfigClient.prototype.sendCallback = function (callbackInfo, remoteConfigInfo, source) {
    callbackInfo.lastCallback = new Date();
    var filteredConfig;
    if (callbackInfo.key) {
      // Filter remote config by key.
      // For example, if remote config is {a: {b: {c: 1}}},
      // if key = 'a', filter result is {b: {c: 1}};
      // if key = 'a.b', filter result is {c: 1}
      filteredConfig = callbackInfo.key.split('.').reduce(function (config, key) {
        if (config === null) {
          return config;
        }
        return key in config ? config[key] : null;
      }, remoteConfigInfo.remoteConfig);
    } else {
      filteredConfig = remoteConfigInfo.remoteConfig;
    }
    callbackInfo.callback(filteredConfig, source, remoteConfigInfo.lastFetch);
  };
  /**
   * Fetch remote config from remote.
   * @param retries - the number of retries. default is 3.
   * @param timeout - the timeout in milliseconds. Default is 1000.
   * This timeout serves two purposes:
   * 1. It determines how long to wait for each remote config fetch request before aborting it.
   *    If the fetch does not complete within the specified timeout, the request is cancelled using AbortController,
   *    and the attempt is considered failed (and may be retried if retries remain).
   * 2. It is also used to calculate the interval between retries. The total timeout is divided by the number of retries,
   *    so each retry waits for (timeout / retries) milliseconds before the next attempt (linear backoff).
   * Retry behavior by status code:
   * - 401: invalid API key (stop retries and disable future updateConfigs calls).
   * - 429: retry up to max retries.
   * - other 4xx: no retry.
   * - 5xx and network failures: retry up to max retries.
   * @returns the remote config info. null if failed to fetch or the response is not valid JSON.
   */
  RemoteConfigClient.prototype.fetch = function (retries, timeout) {
    if (retries === void 0) {
      retries = DEFAULT_MAX_RETRIES;
    }
    if (timeout === void 0) {
      timeout = DEFAULT_TIMEOUT$1;
    }
    return __awaiter(this, void 0, void 0, function () {
      var interval, failedRemoteConfigInfo, _loop_1, this_1, attempt, state_1;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            interval = timeout / retries;
            failedRemoteConfigInfo = {
              remoteConfig: null,
              lastFetch: new Date()
            };
            _loop_1 = function (attempt) {
              var shouldRetry, abortController, timeoutId, url, headers, res, _b, isSuccess, body, remoteConfig, error_2;
              return __generator(this, function (_c) {
                switch (_c.label) {
                  case 0:
                    shouldRetry = true;
                    abortController = new AbortController();
                    timeoutId = setTimeout(function () {
                      return abortController.abort();
                    }, timeout);
                    _c.label = 1;
                  case 1:
                    _c.trys.push([1, 10, 11, 12]);
                    url = this_1.getUrlParams();
                    headers = {
                      Accept: '*/*'
                    };
                    if (!this_1.customFetch) return [3 /*break*/, 3];
                    return [4 /*yield*/, abortableFetch(this_1.customFetch({
                      url: url,
                      method: 'GET',
                      headers: headers,
                      signal: abortController.signal
                    }), abortController.signal)];
                  case 2:
                    _b = _c.sent();
                    return [3 /*break*/, 5];
                  case 3:
                    return [4 /*yield*/, fetch(url, {
                      method: 'GET',
                      headers: headers,
                      signal: abortController.signal
                    })];
                  case 4:
                    _b = _c.sent();
                    _c.label = 5;
                  case 5:
                    res = _b;
                    isSuccess = res.ok || res.status >= 200 && res.status < 300;
                    if (!!isSuccess) return [3 /*break*/, 7];
                    return [4 /*yield*/, res.text()];
                  case 6:
                    body = _c.sent();
                    this_1.logger.debug("Remote config client fetch with retry time ".concat(retries, " failed with ").concat(res.status, ": ").concat(body));
                    if (res.status === CODE_STATUS.INVALID_API_KEY || res.status === CODE_STATUS.FORBIDDEN) {
                      this_1.logger.error("Remote config client fetch failed with ".concat(res.status, ". Invalid API key; future fetches will be skipped."));
                      this_1.isLastFetchInvalidApiKey = true;
                      shouldRetry = false;
                    } else if (res.status >= 400 && res.status < 500 && res.status !== CODE_STATUS.RATE_LIMIT) {
                      shouldRetry = false;
                    }
                    return [3 /*break*/, 9];
                  case 7:
                    return [4 /*yield*/, res.json()];
                  case 8:
                    remoteConfig = _c.sent();
                    return [2 /*return*/, {
                      value: {
                        remoteConfig: remoteConfig,
                        lastFetch: new Date()
                      }
                    }];
                  case 9:
                    return [3 /*break*/, 12];
                  case 10:
                    error_2 = _c.sent();
                    // Handle rejects when the request fails, for example, a network error or timeout
                    if (error_2 instanceof Error && error_2.name === 'AbortError') {
                      this_1.logger.debug("Remote config client fetch with retry time ".concat(retries, " timed out after ").concat(timeout, "ms"));
                    } else {
                      this_1.logger.debug("Remote config client fetch with retry time ".concat(retries, " is rejected because: "), error_2);
                    }
                    return [3 /*break*/, 12];
                  case 11:
                    // Clear the timeout since request completed or failed
                    clearTimeout(timeoutId);
                    return [7 /*endfinally*/];
                  case 12:
                    if (!shouldRetry) {
                      return [2 /*return*/, "break"];
                    }
                    if (!(attempt < retries - 1)) return [3 /*break*/, 14];
                    return [4 /*yield*/, new Promise(function (resolve) {
                      return setTimeout(resolve, _this.getJitterDelay(interval));
                    })];
                  case 13:
                    _c.sent();
                    _c.label = 14;
                  case 14:
                    return [2 /*return*/];
                }
              });
            };
            this_1 = this;
            attempt = 0;
            _a.label = 1;
          case 1:
            if (!(attempt < retries)) return [3 /*break*/, 4];
            return [5 /*yield**/, _loop_1(attempt)];
          case 2:
            state_1 = _a.sent();
            if (typeof state_1 === "object") return [2 /*return*/, state_1.value];
            if (state_1 === "break") return [3 /*break*/, 4];
            _a.label = 3;
          case 3:
            attempt++;
            return [3 /*break*/, 1];
          case 4:
            return [2 /*return*/, failedRemoteConfigInfo];
        }
      });
    });
  };
  /**
   * Return jitter in the bound of [0,baseDelay) and then floor round.
   */
  RemoteConfigClient.prototype.getJitterDelay = function (baseDelay) {
    return Math.floor(Math.random() * baseDelay);
  };
  RemoteConfigClient.prototype.getUrlParams = function () {
    var urlParams = new URLSearchParams();
    urlParams.append('api_key', this.apiKey);
    return "".concat(this.serverUrl, "?").concat(urlParams.toString());
  };
  RemoteConfigClient.DEFAULT_CONFIG_GROUP = 'browser';
  return RemoteConfigClient;
}();

/**
 * @deprecated use ServerZoneType instead
 */
var ServerZone;
(function (ServerZone) {
  ServerZone["US"] = "US";
  ServerZone["EU"] = "EU";
  /**
   * Add for session-replay-browser migration from analytics-type v1.x.
   */
  ServerZone["STAGING"] = "STAGING";
})(ServerZone || (ServerZone = {}));
var DEFAULT_EVENT_PROPERTY_PREFIX = '[Amplitude]';
var DEFAULT_SESSION_REPLAY_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay ID");
var DEFAULT_SAMPLE_RATE = 0;
var DEFAULT_SERVER_ZONE = ServerZone.US;
var DEFAULT_PERFORMANCE_CONFIG = {
  enabled: true
};
var DEFAULT_URL_CHANGE_POLLING_INTERVAL = 1000;
var SESSION_REPLAY_DEBUG_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay Debug");
var UNMASK_TEXT_CLASS = 'amp-unmask';
var SESSION_REPLAY_SERVER_URL = 'https://api-sr.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_EU_URL = 'https://api-sr.eu.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_STAGING_URL = 'https://api-sr.stag2.amplitude.com/sessions/v2/track';
// Raw (uncompressed) UTF-8 byte cap for a single batched events list before the store splits
// it into its own request. Larger batches mean fewer requests — the primary steady-state lever
// for request volume — while the time-based flush (flushIntervalConfig) still controls send
// cadence, so this only decides whether a single high-activity flush gets split into multiple
// requests. Set to 2 MB: gzipped on the wire that's ~0.2 MB, far under the SR ingest service's
// 10,000,000-byte decompressed split threshold (nova SessionReplayServletV2 splits batches above
// it server-side and only 413s a single >10 MB event), and well clear of the ~10-30% wrapper/
// JSON-escaping overhead. Kept at 2 MB (not higher) so it stays a safe POST body on the
// no-CompressionStream fallback path (raw == wire there) and keeps per-session memory/IDB
// buffering modest on low-end devices. A smaller cap (e.g. 700 KB) splits busy-page flushes
// into several more requests/session and drives SR ingest request-rate throttling.
var MAX_EVENT_LIST_SIZE = 2000000;
// Default raw (uncompressed) UTF-8 byte cap for a single buffered events list when the
// consumer does not set `maxPersistedEventsSizeBytes`. Set to 6 MB — the value validated in
// the amp-on-amp canary (appid 187520, session-replay-sdk-perf-config onenav-prod payload):
// larger batches mean fewer requests and materially less SR ingest request-rate throttling
// (rc3 0.02% throttle vs prod 1.31.0 2.95%) while staying under the server's 10 MB
// decompressed split threshold. Kept distinct from MAX_EVENT_LIST_SIZE (2 MB) because that
// constant is still used to derive MERGE_AFTER_THROTTLE_SOFT_CAP and as a documented per-batch
// reference; this constant only governs the default buffer cap. Reverses PR #1814's 2 MB default.
var DEFAULT_MAX_PERSISTED_EVENTS_SIZE_BYTES = 6000000;
// 9 MB UTF-8 bytes — just under the server's 10 MB per-event threshold. Compared against the
// UTF-8 byte length of the serialized event (via Blob/TextEncoder), not the JS string length,
// so multi-byte payloads (CJK, emoji) are gated correctly.
var MAX_SINGLE_EVENT_SIZE = 9 * 1000000;
// WAF rejects oversized compressed payloads with a body containing wording like
// "Payload exceeds the maximum allowed size of 10MB". Match loosely so vendor wording
// tweaks (rule updates, capitalization, etc.) don't silently disable bisect-retry.
var WAF_PAYLOAD_TOO_LARGE_PATTERN = /payload.*exceed/i;
var INTERACTION_MIN_INTERVAL = 30000; // 30 seconds
var INTERACTION_MAX_INTERVAL = 60000; // 1 minute
var MIN_INTERVAL = 500; // 500 ms
var MAX_INTERVAL = 10 * 1000; // 10 seconds
// Default flush-interval bounds applied when the consumer does not pass `flushIntervalConfig`.
// Set to the values validated in the amp-on-amp canary (session-replay-sdk-perf-config
// onenav-prod payload, SR-4646): a 1s floor (up from the MIN_INTERVAL 500ms hard floor) reduces
// request volume on busy pages while the 10s ceiling matches MAX_INTERVAL. MIN_INTERVAL/
// MAX_INTERVAL remain the absolute clamp bounds and partial-config cross-validation defaults.
var DEFAULT_FLUSH_MIN_INTERVAL_MS = 1000; // 1 second
var DEFAULT_FLUSH_MAX_INTERVAL_MS = 10 * 1000; // 10 seconds
var KB_SIZE = 1024;
var MAX_URL_LENGTH = 1000;
var MAX_KEEPALIVE_BYTES = 64 * 1024; // browser keepalive budget shared with sendBeacon
// Per-request send timeout. fetch() has no native timeout, so a single hung request
// (stuck "pending" forever) would otherwise block the serial flush loop indefinitely —
// head-of-line blocking that stalls every queued batch behind it. We abort after this
// many ms so each send always settles and the queue keeps draining.
var SEND_TIMEOUT_MS = 10000;
// Server returns 200 + this header for "no-retry" drops (throttle / capture disabled / out-of-range).
// See projects/sessionreplay/sessionreplay-ingestion/.../SessionReplayError.java.
// Header value is the numeric error code as a string.
var EVENT_SKIPPED_HEADER = 'X-Session-Replay-Event-Skipped';
var EVENT_SKIP_CODE_THROTTLED = '429';
var EVENT_SKIP_CODE_INVALID_RANGE = '4004';
var EVENT_SKIP_CODE_CAPTURE_DISABLED = '4005';
// How long to pause the flush schedule after the server signals a throttle.
var THROTTLED_FLUSH_PAUSE_MS = 60000;
// Soft UTF-8 byte cap for merging same-session contexts after a throttle pause.
// Set to 2 * MAX_EVENT_LIST_SIZE so we'll merge at most ~2 max-size sequences (or many
// small ones) into one POST — fewer requests during recovery without pushing close to
// the server's 10MB-compressed 413 ceiling. Compared against UTF-8 byte size (via Blob)
// to match the per-sequence limit's units enforced upstream by base-events-store.
var MERGE_AFTER_THROTTLE_SOFT_CAP = 2 * MAX_EVENT_LIST_SIZE;
var CROSS_ORIGIN_IFRAME_MESSAGE_TYPE = 'amplitude-sr-iframe';
var CustomRRwebEvent;
(function (CustomRRwebEvent) {
  CustomRRwebEvent["GET_SR_PROPS"] = "get-sr-props";
  CustomRRwebEvent["DEBUG_INFO"] = "debug-info";
  CustomRRwebEvent["FETCH_REQUEST"] = "fetch-request";
  CustomRRwebEvent["METADATA"] = "metadata";
  CustomRRwebEvent["TARGETING_DECISION"] = "targeting-decision";
  /**
   * Emitted once per session, on the first send that passes the min_session_duration_ms
   * gate. Captures how many sends were suppressed before passing and the elapsed time
   * spent below the threshold. Lets backend ingestion diff intended replay count vs
   * actual ingestion so on-call can spot start-time-tracking regressions.
   *
   * Sessions that bounce before crossing the threshold never emit this event by design
   * (the whole payload is suppressed); their absence is the signal.
   */
  CustomRRwebEvent["REPLAY_GATE_DECISION"] = "replay-gate-decision";
})(CustomRRwebEvent || (CustomRRwebEvent = {}));
var SafeLoggerProvider = /** @class */function () {
  function SafeLoggerProvider(loggerProvider) {
    this.logger = loggerProvider;
    this.log = this.getSafeMethod('log');
    this.warn = this.getSafeMethod('warn');
    this.error = this.getSafeMethod('error');
    this.debug = this.getSafeMethod('debug');
  }
  SafeLoggerProvider.prototype.getSafeMethod = function (method) {
    var _a;
    if (!this.logger) {
      return function () {
        // No-op function fallback
      };
    }
    var fn = this.logger[method];
    if (typeof fn === 'function') {
      var originalFn = (_a = fn.__rrweb_original__) !== null && _a !== void 0 ? _a : fn;
      return originalFn.bind(this.logger);
    }
    return function () {
      // No-op function fallback
    };
  };
  SafeLoggerProvider.prototype.enable = function (logLevel) {
    this.logger.enable(logLevel);
  };
  SafeLoggerProvider.prototype.disable = function () {
    this.logger.disable();
  };
  return SafeLoggerProvider;
}();
var DEFAULT_MASK_LEVEL = 'medium';
function toLowerCase(str) {
  return str.toLowerCase();
}
/**
 * Get the type of an input element.
 * This takes care of the case where a password input is changed to a text input.
 * In this case, we continue to consider this of type password, in order to avoid leaking sensitive data
 * where passwords should be masked.
 */
function getInputType(element) {
  // when omitting the type of input element(e.g. <input />), the type is treated as text
  var type = element.type;
  return element.hasAttribute('data-rr-is-password') ? 'password' : type ?
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  toLowerCase(type) : null;
}
var globRegexCache = new Map();
var globToRegex = function globToRegex(glob) {
  var cached = globRegexCache.get(glob);
  if (cached) return cached;
  // Glob → regex conversion. Glob substitution must happen BEFORE regex escaping so that
  // the escaper does not corrupt the glob characters (e.g. turning `/**` into `/\*\*`).
  // Placeholder tokens use null bytes, which are illegal in HTTP URLs and therefore can
  // never collide with real pattern content.
  //
  // Substitution order (most-specific first):
  //   trailing /**   → (/.*)?          — path with or without a trailing slash/subpath
  //   middle  /**/   → /(.*\/)?        — zero-or-more path segments (including zero)
  //   bare    **     → .*              — graceful fallback for ** not adjacent to /
  //   single  *      → .*              — any characters (preserves existing behaviour)
  //   ?              → .               — single character wildcard
  var T_TRAILING = '\x00TRAIL\x00';
  var T_MIDDLE = '\x00MID\x00';
  var T_DSTAR = '\x00DS\x00';
  var T_STAR = '\x00ST\x00';
  var T_QUEST = '\x00QU\x00';
  var s = glob;
  s = s.replace(/\/\*\*$/, T_TRAILING); // trailing /**
  s = s.replace(/\/\*\*\//g, T_MIDDLE); // /**/ in the middle
  s = s.replace(/\*\*/g, T_DSTAR); // bare ** (e.g. **.example.com)
  s = s.replace(/\*/g, T_STAR); // single *
  s = s.replace(/\?/g, T_QUEST); // ?
  // Escape all remaining regex special characters.
  s = s.replace(/[.+^${}()|[\]\\]/g, '\\$&');
  // Expand tokens into their regex equivalents.
  // Use split/join (not regex) to avoid the no-control-regex lint rule on the token strings.
  s = s.split(T_TRAILING).join('(/.*)?'); // /** → optional /anything
  s = s.split(T_MIDDLE).join('/(.*\\/)?'); // /**/ → /zero-or-more-segments/
  s = s.split(T_DSTAR).join('.*'); // bare ** → .*
  s = s.split(T_STAR).join('.*'); // * → .*
  s = s.split(T_QUEST).join('.'); // ? → .
  var regex = new RegExp("^".concat(s, "$"));
  globRegexCache.set(glob, regex);
  return regex;
};

/**
 * Light: Subset of inputs (sensitive types only — password, hidden, email, tel, cc-*)
 * Medium: All inputs (form fields), text is NOT masked
 * Conservative: All inputs and all texts
 */
var isMaskedForLevel = function isMaskedForLevel(elementType, level, element) {
  switch (level) {
    case 'light':
      {
        if (elementType !== 'input') {
          return false;
        }
        var inputType = element ? getInputType(element) : '';
        /* istanbul ignore if */ // TODO(lew): For some reason it's impossible to test this.
        if (!inputType) {
          return false;
        }
        if (['password', 'hidden', 'email', 'tel'].includes(inputType)) {
          return true;
        }
        if (element.autocomplete.startsWith('cc-')) {
          return true;
        }
        return false;
      }
    case 'medium':
      return elementType === 'input';
    case 'conservative':
      return true;
    default:
      return isMaskedForLevel(elementType, DEFAULT_MASK_LEVEL, element);
  }
};
/**
 * Returns the effective mask level for a given URL by checking `urlMaskLevels`
 * (first match wins) and falling back to `defaultMaskLevel`.
 */
var getEffectiveMaskLevel = function getEffectiveMaskLevel(url, config) {
  var e_1, _a;
  var _b;
  if (url && config.urlMaskLevels) {
    try {
      for (var _c = __values$1(config.urlMaskLevels), _d = _c.next(); !_d.done; _d = _c.next()) {
        var rule = _d.value;
        if (globToRegex(rule.match).test(url)) {
          return rule.maskLevel;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  return (_b = config.defaultMaskLevel) !== null && _b !== void 0 ? _b : DEFAULT_MASK_LEVEL;
};
/**
 * Checks if the given element set to be masked by rrweb
 *
 * Priority is:
 *  1. [In code] Element/class based masking/unmasking <> [Config based] Selector based masking/unmasking
 *  2. Use app defaults
 */
var isMasked = function isMasked(elementType, config, element, currentUrl) {
  var _a, _b;
  if (config === void 0) {
    config = {
      defaultMaskLevel: DEFAULT_MASK_LEVEL
    };
  }
  if (element) {
    // Element or parent is explicitly instrumented in code to mask
    if (element.closest('.amp-mask, [data-amp-mask]')) {
      return true;
    }
    // Config has override for mask
    var shouldMask = ((_a = config.maskSelector) !== null && _a !== void 0 ? _a : []).some(function (selector) {
      return element.closest(selector);
    });
    if (shouldMask) {
      return true;
    }
    // Code or config has override to unmask
    if (element.closest('.amp-unmask, [data-amp-unmask]')) {
      return false;
    }
    // Here we are probably sent an element, but we want to match if they have a
    // parent with an unmask selector.
    var shouldUnmask = ((_b = config.unmaskSelector) !== null && _b !== void 0 ? _b : []).some(function (selector) {
      return element.closest(selector);
    });
    if (shouldUnmask) {
      return false;
    }
  }
  return isMaskedForLevel(elementType, getEffectiveMaskLevel(currentUrl, config), element);
};
var maskFn = function maskFn(elementType, config, getCurrentUrl) {
  return function (text, element) {
    return isMasked(elementType, config, element, getCurrentUrl === null || getCurrentUrl === void 0 ? void 0 : getCurrentUrl()) ? text.replace(/[^\s]/g, '*') : text;
  };
};
var maskAttributeFn = function maskAttributeFn(config, getCurrentUrl) {
  return function (key, value, element) {
    var _a;
    // Never mask style — rrweb has a separate styleDiff path for attribute mutations
    // that reads directly from the DOM, bypassing maskAttributeFn.
    if (key === 'style') return value;
    // Short-circuit: only proceed if this attribute is in the allowlist.
    if (!((_a = config === null || config === void 0 ? void 0 : config.maskAttributes) !== null && _a !== void 0 ? _a : []).includes(key)) return value;
    // Use 'input' for form elements so that `medium` (which masks inputs but not text)
    // still masks attributes on inputs/selects/textareas. For non-form elements, use
    // 'text' so medium leaves them visible.
    var elementType = ['INPUT', 'SELECT', 'TEXTAREA'].includes(element.tagName) ? 'input' : 'text';
    return isMasked(elementType, config, element, getCurrentUrl === null || getCurrentUrl === void 0 ? void 0 : getCurrentUrl()) ? value.replace(/[^\s]/g, '*') : value;
  };
};
var getBlockSelectors = function getBlockSelectors(config) {
  var configured = config === null || config === void 0 ? void 0 : config.blockSelector;
  var selectors = typeof configured === 'string' ? configured ? [configured] : [] : configured !== null && configured !== void 0 ? configured : [];
  return __spreadArray(__spreadArray([], __read$1(selectors), false), ['[data-amp-block]'], false).join(',');
};
var getMaskTextSelectors = function getMaskTextSelectors(config, url) {
  var _a, _b;
  // rrweb selects which text reaches the callback at recorder startup. Include all
  // text if any route can require conservative masking; callbacks resolve the URL dynamically.
  if (config && (getEffectiveMaskLevel(url, config) === 'conservative' || config.defaultMaskLevel === 'conservative' || ((_a = config.urlMaskLevels) === null || _a === void 0 ? void 0 : _a.some(function (rule) {
    return rule.maskLevel === 'conservative';
  })))) return '*';
  return __spreadArray(__spreadArray([], __read$1((_b = config === null || config === void 0 ? void 0 : config.maskSelector) !== null && _b !== void 0 ? _b : []), false), ['[data-amp-mask]'], false).join(',');
};
/** Lifecycle and URL observation belong to the caller. Replace the recorder when policy changes. */
var createPrivacyRecorderOptions = function createPrivacyRecorderOptions(config, getCurrentUrl) {
  if (getCurrentUrl === void 0) {
    getCurrentUrl = function () {
      return '';
    };
  }
  var blockSelector = getBlockSelectors(config);
  return {
    maskAllInputs: true,
    maskTextClass: 'amp-mask',
    blockClass: 'amp-block',
    blockSelector: blockSelector,
    maskTextSelector: getMaskTextSelectors(config, getCurrentUrl()),
    maskInputFn: maskFn('input', config, getCurrentUrl),
    maskTextFn: maskFn('text', config, getCurrentUrl),
    maskAttributeFn: maskAttributeFn(config, getCurrentUrl)
  };
};

/** Returns a copy. The caller supplies a validator for the target DOM's CSS syntax. */
var validatePrivacySelectors = function validatePrivacySelectors(config, validate, onInvalid) {
  var e_1, _a;
  var result = _assign$({}, config);
  try {
    for (var _b = __values$1(['blockSelector', 'maskSelector', 'unmaskSelector']), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var value = config[key];
      var selectors = typeof value === 'string' ? [value] : value !== null && value !== void 0 ? value : [];
      var valid = selectors.filter(function (selector) {
        try {
          validate(selector);
          return true;
        } catch (_a) {
          if (!onInvalid) throw new Error("Invalid privacy selector: ".concat(selector));
          onInvalid(selector);
          return false;
        }
      });
      result[key] = valid.length ? valid : undefined;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return result;
};
function getServerUrl(serverZone, trackServerUrl) {
  if (trackServerUrl) return trackServerUrl;
  if (serverZone === 'STAGING') return SESSION_REPLAY_STAGING_URL;
  if (serverZone === 'EU') return SESSION_REPLAY_EU_URL;
  return SESSION_REPLAY_SERVER_URL;
}
var getCurrentUrl = function getCurrentUrl() {
  var globalScope = getGlobalScope();
  return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) ? globalScope.location.href : '';
};
var generateSessionReplayId = function generateSessionReplayId(sessionId, deviceId) {
  return "".concat(deviceId, "/").concat(sessionId);
};
var isValidGlobUrl = function isValidGlobUrl(globUrl) {
  if (typeof globUrl !== 'string' || globUrl.trim() === '') return false;
  var urlPattern = /^\/|^https?:\/\/[^\s]+$/;
  if (!urlPattern.test(globUrl)) return false;
  return true;
};
var validateUGCFilterRules = function validateUGCFilterRules(ugcFilterRules) {
  // validate ugcFilterRules
  if (!ugcFilterRules.every(function (rule) {
    return typeof rule.selector === 'string' && typeof rule.replacement === 'string';
  })) {
    throw new Error('ugcFilterRules must be an array of objects with selector and replacement properties');
  }
  // validate ugcFilterRules are valid globs
  if (!ugcFilterRules.every(function (rule) {
    return isValidGlobUrl(rule.selector);
  })) {
    throw new Error('ugcFilterRules must be an array of objects with valid globs');
  }
};
var getPageUrl = function getPageUrl(pageUrl, ugcFilterRules) {
  var e_1, _a;
  try {
    // apply ugcFilterRules, order is important, first rule wins
    for (var ugcFilterRules_1 = __values$1(ugcFilterRules), ugcFilterRules_1_1 = ugcFilterRules_1.next(); !ugcFilterRules_1_1.done; ugcFilterRules_1_1 = ugcFilterRules_1.next()) {
      var rule = ugcFilterRules_1_1.value;
      var regex = globToRegex(rule.selector);
      if (regex.test(pageUrl)) {
        return pageUrl.replace(regex, rule.replacement);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (ugcFilterRules_1_1 && !ugcFilterRules_1_1.done && (_a = ugcFilterRules_1.return)) _a.call(ugcFilterRules_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return pageUrl;
};
var getStorageSize = function getStorageSize() {
  return __awaiter(void 0, void 0, void 0, function () {
    var globalScope, _a, usage, quota, usageDetails, totalStorageSize, percentOfQuota;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 3,, 4]);
          globalScope = getGlobalScope();
          if (!globalScope) return [3 /*break*/, 2];
          return [4 /*yield*/, globalScope.navigator.storage.estimate()];
        case 1:
          _a = _b.sent(), usage = _a.usage, quota = _a.quota, usageDetails = _a.usageDetails;
          totalStorageSize = usage ? Math.round(usage / KB_SIZE) : 0;
          percentOfQuota = usage && quota ? Math.round((usage / quota + Number.EPSILON) * 1000) / 1000 : 0;
          return [2 /*return*/, {
            totalStorageSize: totalStorageSize,
            percentOfQuota: percentOfQuota,
            usageDetails: JSON.stringify(usageDetails)
          }];
        case 2:
          return [3 /*break*/, 4];
        case 3:
          _b.sent();
          return [3 /*break*/, 4];
        case 4:
          return [2 /*return*/, {
            totalStorageSize: 0,
            percentOfQuota: 0,
            usageDetails: ''
          }];
      }
    });
  });
};
var getDebugConfig = function getDebugConfig(config) {
  var debugConfig = _assign$({}, config);
  var apiKey = debugConfig.apiKey;
  debugConfig.apiKey = "****".concat(apiKey.substring(apiKey.length - 4));
  return debugConfig;
};
var getDefaultConfig = function getDefaultConfig() {
  return {
    flushMaxRetries: 2,
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    transportProvider: new FetchTransport()
  };
};
var SessionReplayLocalConfig = /** @class */function (_super) {
  __extends(SessionReplayLocalConfig, _super);
  function SessionReplayLocalConfig(apiKey, options) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _o, _p;
    var defaultConfig = getDefaultConfig();
    _this = _super.call(this, _assign$(_assign$({
      transportProvider: defaultConfig.transportProvider,
      loggerProvider: new SafeLoggerProvider(options.loggerProvider || defaultConfig.loggerProvider)
    }, options), {
      apiKey: apiKey
    })) || this;
    _this.flushMaxRetries = options.flushMaxRetries !== undefined && options.flushMaxRetries <= defaultConfig.flushMaxRetries ? options.flushMaxRetries : defaultConfig.flushMaxRetries;
    _this.apiKey = apiKey;
    _this.sampleRate = options.sampleRate || DEFAULT_SAMPLE_RATE;
    _this.serverZone = options.serverZone || DEFAULT_SERVER_ZONE;
    _this.configServerUrl = options.configServerUrl;
    _this.trackServerUrl = options.trackServerUrl;
    _this.shouldInlineStylesheet = options.shouldInlineStylesheet;
    _this.inlineImages = options.inlineImages;
    _this.version = options.version;
    _this.performanceConfig = options.performanceConfig || DEFAULT_PERFORMANCE_CONFIG;
    _this.storeType = (_a = options.storeType) !== null && _a !== void 0 ? _a : 'memory';
    _this.applyBackgroundColorToBlockedElements = (_b = options.applyBackgroundColorToBlockedElements) !== null && _b !== void 0 ? _b : false;
    _this.enableUrlChangePolling = (_c = options.enableUrlChangePolling) !== null && _c !== void 0 ? _c : false;
    _this.urlChangePollingInterval = (_d = options.urlChangePollingInterval) !== null && _d !== void 0 ? _d : DEFAULT_URL_CHANGE_POLLING_INTERVAL;
    _this.captureDocumentTitle = (_e = options.captureDocumentTitle) !== null && _e !== void 0 ? _e : false;
    if (options.fullSnapshotIntervalMs !== undefined) {
      _this.fullSnapshotIntervalMs = options.fullSnapshotIntervalMs;
    }
    if (options.eagerFullSnapshotSend !== undefined) {
      _this.eagerFullSnapshotSend = options.eagerFullSnapshotSend;
    }
    // Defaults to false per the validated amp-on-amp perf config (SR-4646): the on-focus full
    // snapshot is off unless the consumer explicitly opts in. focusListener honors this by
    // skipping the snapshot whenever the value is not true.
    _this.captureFullSnapshotOnFocus = (_f = options.captureFullSnapshotOnFocus) !== null && _f !== void 0 ? _f : false;
    if (options.maxPersistedEventsSizeBytes !== undefined) {
      _this.maxPersistedEventsSizeBytes = sanitizeByteSize(options.maxPersistedEventsSizeBytes, MIN_EVENT_BYTE_SIZE, MAX_PERSISTED_EVENTS_SIZE_CEILING, 'maxPersistedEventsSizeBytes', _this.loggerProvider);
    }
    if (options.maxSingleEventSizeBytes !== undefined) {
      _this.maxSingleEventSizeBytes = sanitizeByteSize(options.maxSingleEventSizeBytes, MIN_EVENT_BYTE_SIZE, MAX_SINGLE_EVENT_SIZE_CEILING, 'maxSingleEventSizeBytes', _this.loggerProvider);
    }
    // Auto-include .amp-unmask as a default unmaskSelector entry so it works
    // symmetrically with amp-mask/amp-block without requiring explicit config (SR-2945).
    _this.privacyConfig = _assign$(_assign$({}, (_g = options.privacyConfig) !== null && _g !== void 0 ? _g : {}), {
      unmaskSelector: Array.from(new Set(__spreadArray([".".concat(UNMASK_TEXT_CLASS)], __read$1((_j = (_h = options.privacyConfig) === null || _h === void 0 ? void 0 : _h.unmaskSelector) !== null && _j !== void 0 ? _j : []), false)))
    });
    if (options.interactionConfig) {
      _this.interactionConfig = options.interactionConfig;
      // validate ugcFilterRules, throw error if invalid - throw error at the beginning of the config
      if (_this.interactionConfig.ugcFilterRules) {
        validateUGCFilterRules(_this.interactionConfig.ugcFilterRules);
      }
    }
    if (options.debugMode) {
      _this.debugMode = options.debugMode;
    }
    _this.useWebWorker = false;
    _this.enableTransportCompression = (_o = options.enableTransportCompression) !== null && _o !== void 0 ? _o : false;
    // Pass through undefined so the track destination applies its SEND_TIMEOUT_MS default;
    // an explicit 0 is preserved (disables the timeout).
    _this.sendTimeoutMs = options.sendTimeoutMs;
    _this.captureAdoptedStyleSheets = (_p = options.captureAdoptedStyleSheets) !== null && _p !== void 0 ? _p : true;
    if (options.crossOriginIframes) {
      _this.crossOriginIframes = options.crossOriginIframes;
    }
    if (options.flushIntervalConfig) {
      _this.flushIntervalConfig = sanitizeFlushIntervalConfig(options.flushIntervalConfig, _this.loggerProvider);
    } else {
      // Default to the validated amp-on-amp perf config (SR-4646). The values are known-valid
      // (min <= max, both above the floor), so no sanitization is required.
      _this.flushIntervalConfig = {
        minIntervalMs: DEFAULT_FLUSH_MIN_INTERVAL_MS,
        maxIntervalMs: DEFAULT_FLUSH_MAX_INTERVAL_MS
      };
    }
    _this.handleSendEvents = options.handleSendEvents;
    _this.handleFetchConfig = options.handleFetchConfig;
    return _this;
  }
  return SessionReplayLocalConfig;
}(Config);
// 100ms floor avoids degenerate configs (0/negative) that would split on every event.
// Customers wanting fewer requests should be raising the value, not lowering it; the floor
// is just a defensive guard against typos and unsigned-int rollovers.
var MIN_FLUSH_INTERVAL_FLOOR_MS = 100;
// Shared 1 KB floor for the byte-size overrides — small enough to exercise splitting/drops
// while debugging, large enough to avoid a 0/negative config that splits on every event.
var MIN_EVENT_BYTE_SIZE = 1000;
// Batch cap ceiling: stay under the SR ingest service's 10 MB decompressed split threshold
// (above which the server splits the batch itself) with headroom for the request wrapper.
var MAX_PERSISTED_EVENTS_SIZE_CEILING = 8000000;
// Single-event ceiling: the server rejects a single event above ~10 MB, so never allow an
// override to exceed that.
var MAX_SINGLE_EVENT_SIZE_CEILING = 10000000;
// Defensive bounds for the byte-size overrides. Non-finite inputs are ignored (fall back to
// the SDK default); out-of-range values are clamped and logged so a typo can't silently
// disable splitting or push past the server's limits.
function sanitizeByteSize(raw, min, max, name, loggerProvider) {
  if (!Number.isFinite(raw)) {
    loggerProvider.warn("".concat(name, " value is not a finite number (got ").concat(String(raw), "); ignoring."));
    return undefined;
  }
  if (raw < min) {
    loggerProvider.warn("".concat(name, " ").concat(raw, " is below floor ").concat(min, "; clamping."));
    return min;
  }
  if (raw > max) {
    loggerProvider.warn("".concat(name, " ").concat(raw, " exceeds ceiling ").concat(max, "; clamping."));
    return max;
  }
  return raw;
}
function sanitizeFlushIntervalConfig(raw, loggerProvider) {
  var _a, _b;
  var sanitized = {};
  if (raw.minIntervalMs !== undefined) {
    if (!Number.isFinite(raw.minIntervalMs) || raw.minIntervalMs < MIN_FLUSH_INTERVAL_FLOOR_MS) {
      loggerProvider.warn("flushIntervalConfig.minIntervalMs ".concat(raw.minIntervalMs, " is below floor ").concat(MIN_FLUSH_INTERVAL_FLOOR_MS, "ms; clamping."));
      sanitized.minIntervalMs = MIN_FLUSH_INTERVAL_FLOOR_MS;
    } else {
      sanitized.minIntervalMs = raw.minIntervalMs;
    }
  }
  if (raw.maxIntervalMs !== undefined) {
    // Unlike min, `Infinity` is a meaningful value here: it means "no upper bound on interval
    // growth" (Math.min(Infinity, x) === x in BaseEventsStore.shouldSplitEventsList). Reject
    // only NaN and sub-floor values; pass Infinity through.
    if (Number.isNaN(raw.maxIntervalMs) || raw.maxIntervalMs < MIN_FLUSH_INTERVAL_FLOOR_MS) {
      loggerProvider.warn("flushIntervalConfig.maxIntervalMs ".concat(raw.maxIntervalMs, " is below floor ").concat(MIN_FLUSH_INTERVAL_FLOOR_MS, "ms; clamping."));
      sanitized.maxIntervalMs = MIN_FLUSH_INTERVAL_FLOOR_MS;
    } else {
      sanitized.maxIntervalMs = raw.maxIntervalMs;
    }
  }
  // Cross-validate against the SDK's effective defaults so that a partial config (only one of
  // {minIntervalMs, maxIntervalMs}) doesn't get silently clamped by the unspecified default.
  // Concrete failure mode without this: customer sets only `minIntervalMs: 30_000`, the store's
  // `maxInterval` falls back to `MAX_INTERVAL = 10_000`, and `shouldSplitEventsList` then
  // caps the effective interval at 10s — silently negating the customer's tune-up.
  // The user-supplied value always wins; we fill in the other side to match.
  if (sanitized.minIntervalMs !== undefined || sanitized.maxIntervalMs !== undefined) {
    var effectiveMin = (_a = sanitized.minIntervalMs) !== null && _a !== void 0 ? _a : MIN_INTERVAL;
    var effectiveMax = (_b = sanitized.maxIntervalMs) !== null && _b !== void 0 ? _b : MAX_INTERVAL;
    if (effectiveMax < effectiveMin) {
      if (sanitized.maxIntervalMs === undefined) {
        loggerProvider.warn("flushIntervalConfig.minIntervalMs (".concat(effectiveMin, ") exceeds the default maxIntervalMs (").concat(MAX_INTERVAL, "); raising max to match min."));
        sanitized.maxIntervalMs = effectiveMin;
      } else if (sanitized.minIntervalMs === undefined) {
        loggerProvider.warn("flushIntervalConfig.maxIntervalMs (".concat(effectiveMax, ") is below the default minIntervalMs (").concat(MIN_INTERVAL, "); lowering min to match max."));
        sanitized.minIntervalMs = effectiveMax;
      } else {
        loggerProvider.warn("flushIntervalConfig.maxIntervalMs (".concat(sanitized.maxIntervalMs, ") is less than minIntervalMs (").concat(sanitized.minIntervalMs, "); raising max to match min."));
        sanitized.maxIntervalMs = sanitized.minIntervalMs;
      }
    }
  }
  return sanitized;
}
var EventType = /* @__PURE__ */(EventType2 => {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
})(EventType || {});
var MouseInteractions = /* @__PURE__ */(MouseInteractions2 => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions || {});

// Budget for waiting on the remote config response before falling back to the local cache.
// The inner fetch in analytics-core uses a 1000ms per-attempt AbortController timeout with
// up to 3 retries — but this outer timeout is the only thing the SR plugin waits on, so
// only the first attempt can possibly complete in time (attempt 2 starts at ~1000-1333ms
// after backoff jitter and runs to ~2000-2333ms, well past any reasonable outer budget).
// 1500ms is set above the 1000ms inner abort to avoid a tie with the inner cutoff and
// give the first attempt's resolution path room to finish; everything else falls through
// to the cache fallback. See SR-4234: prefer remote over a stale cache that would
// otherwise win the synchronous race in 'all' mode.
var REMOTE_CONFIG_TIMEOUT_MS = 1500;
var removeInvalidSelectorsFromPrivacyConfig = function removeInvalidSelectorsFromPrivacyConfig(privacyConfig, loggerProvider) {
  var fragment = document.createDocumentFragment();
  return validatePrivacySelectors(privacyConfig, function (selector) {
    fragment.querySelector(selector);
  }, function (selector) {
    loggerProvider.warn("[session-replay-browser] omitting selector \"".concat(selector, "\" because it is invalid"));
  });
};
var SessionReplayJoinedConfigGenerator = /** @class */function () {
  function SessionReplayJoinedConfigGenerator(remoteConfigClient, localConfig) {
    this.localConfig = localConfig;
    this.remoteConfigClient = remoteConfigClient;
  }
  SessionReplayJoinedConfigGenerator.prototype.generateJoinedConfig = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    return __awaiter(this, void 0, void 0, function () {
      var config, sessionReplayRemoteConfig, error_1, samplingConfig, remotePrivacyConfig, targetingConfig, localPrivacyConfig, joinedPrivacyConfig, privacyConfigSelectorMap, selectorMap, _h, _j, _k, selector, selectorType;
      var e_1, _l;
      var _this = this;
      return __generator(this, function (_m) {
        switch (_m.label) {
          case 0:
            config = _assign$({}, this.localConfig);
            // Special case here as optOut is implemented via getter/setter
            config.optOut = this.localConfig.optOut;
            // We always want captureEnabled to be true, unless there's an override
            // in the remote config.
            config.captureEnabled = true;
            _m.label = 1;
          case 1:
            _m.trys.push([1, 3,, 4]);
            // Subscribe with a timeout so the SDK prefers the remote response and only falls back
            // to cache after the budget elapses. 'all' mode would race a synchronous cache read
            // against the network and resolve on whichever fires first — cache always wins, so a
            // stale cache silently overrides the live config (SR-4234).
            return [4 /*yield*/, new Promise(function (resolve, reject) {
              _this.remoteConfigClient.subscribe('configs.sessionReplay', {
                timeout: REMOTE_CONFIG_TIMEOUT_MS
              }, function (remoteConfig, source) {
                var _a;
                _this.localConfig.loggerProvider.debug("Session Replay remote configuration received from ".concat(source, ":"), JSON.stringify(remoteConfig, null, 2));
                if (!remoteConfig) {
                  reject(new Error('No remote config received'));
                  return;
                }
                // remoteConfig is already filtered to 'configs.sessionReplay' namespace
                var namespaceConfig = remoteConfig;
                var samplingConfig = namespaceConfig.sr_sampling_config;
                var privacyConfig = namespaceConfig.sr_privacy_config;
                var targetingConfig = namespaceConfig.sr_targeting_config;
                var ugcFilterRules = (_a = config.interactionConfig) === null || _a === void 0 ? void 0 : _a.ugcFilterRules;
                // This is intentionally forced to only be set through the remote config.
                config.interactionConfig = namespaceConfig.sr_interaction_config;
                if (config.interactionConfig && ugcFilterRules) {
                  config.interactionConfig.ugcFilterRules = ugcFilterRules;
                }
                // This is intentionally forced to only be set through the remote config.
                config.loggingConfig = namespaceConfig.sr_logging_config;
                if (samplingConfig || privacyConfig || targetingConfig) {
                  sessionReplayRemoteConfig = {};
                  if (samplingConfig) {
                    sessionReplayRemoteConfig.sr_sampling_config = samplingConfig;
                  }
                  if (privacyConfig) {
                    sessionReplayRemoteConfig.sr_privacy_config = privacyConfig;
                  }
                  if (targetingConfig) {
                    sessionReplayRemoteConfig.sr_targeting_config = targetingConfig;
                  }
                }
                resolve();
              });
            })];
          case 2:
            // Subscribe with a timeout so the SDK prefers the remote response and only falls back
            // to cache after the budget elapses. 'all' mode would race a synchronous cache read
            // against the network and resolve on whichever fires first — cache always wins, so a
            // stale cache silently overrides the live config (SR-4234).
            _m.sent();
            return [3 /*break*/, 4];
          case 3:
            error_1 = _m.sent();
            this.localConfig.loggerProvider.error('Failed to generate joined config: ', error_1);
            config.captureEnabled = false;
            return [2 /*return*/, {
              localConfig: this.localConfig,
              joinedConfig: config,
              remoteConfig: undefined
            }];
          case 4:
            if (!sessionReplayRemoteConfig) {
              return [2 /*return*/, {
                localConfig: this.localConfig,
                joinedConfig: config,
                remoteConfig: sessionReplayRemoteConfig
              }];
            }
            samplingConfig = sessionReplayRemoteConfig.sr_sampling_config, remotePrivacyConfig = sessionReplayRemoteConfig.sr_privacy_config, targetingConfig = sessionReplayRemoteConfig.sr_targeting_config;
            if (samplingConfig && Object.keys(samplingConfig).length > 0) {
              if (Object.prototype.hasOwnProperty.call(samplingConfig, 'capture_enabled')) {
                config.captureEnabled = samplingConfig.capture_enabled;
              } else {
                config.captureEnabled = false;
              }
              if (Object.prototype.hasOwnProperty.call(samplingConfig, 'sample_rate')) {
                config.sampleRate = samplingConfig.sample_rate;
              }
              if (Object.prototype.hasOwnProperty.call(samplingConfig, 'min_session_duration_ms')) {
                config.minSessionDurationMs = this.sanitizeMinSessionDurationMs(samplingConfig.min_session_duration_ms);
              }
            } else {
              // If config API response was valid (ie 200), but no config returned, assume that
              // customer has not yet set up config, and use sample rate from SDK options,
              // allowing for immediate replay capture
              config.captureEnabled = true;
              this.localConfig.loggerProvider.debug('Remote config successfully fetched, but no values set for project, Session Replay capture enabled.');
            }
            // Remote config join acts somewhat like a left join between the remote and the local
            // config. That is, remote config has precedence over local values as with sampling.
            // However, non conflicting values will be added to the lists.
            // Here's an example to illustrate:
            //
            // Remote config:   {'.selector1': 'MASK',   '.selector2': 'UNMASK'}
            // Local config:    {'.selector1': 'UNMASK',                         '.selector3': 'MASK'}
            //
            // Resolved config: {'.selector1': 'MASK',   '.selector2': 'UNMASK', '.selector3': 'MASK'}
            // config.privacyConfig = {
            //   ...(config.privacyConfig ?? {}),
            //   ...remotePrivacyConfig,
            // };
            if (remotePrivacyConfig) {
              localPrivacyConfig = (_a = config.privacyConfig) !== null && _a !== void 0 ? _a : {};
              joinedPrivacyConfig = {
                defaultMaskLevel: (_c = (_b = remotePrivacyConfig.defaultMaskLevel) !== null && _b !== void 0 ? _b : localPrivacyConfig.defaultMaskLevel) !== null && _c !== void 0 ? _c : 'medium',
                blockSelector: [],
                maskSelector: [],
                unmaskSelector: [],
                maskAttributes: __spreadArray([], __read$1(new Set(__spreadArray(__spreadArray([], __read$1((_d = localPrivacyConfig.maskAttributes) !== null && _d !== void 0 ? _d : []), false), __read$1((_e = remotePrivacyConfig.maskAttributes) !== null && _e !== void 0 ? _e : []), false))), false),
                urlMaskLevels: __spreadArray(__spreadArray([], __read$1((_f = remotePrivacyConfig.urlMaskLevels) !== null && _f !== void 0 ? _f : []), false), __read$1((_g = localPrivacyConfig.urlMaskLevels) !== null && _g !== void 0 ? _g : []), false)
              };
              privacyConfigSelectorMap = function (privacyConfig) {
                var e_2, _a, e_3, _b, e_4, _c;
                var _d, _e, _f;
                var selectorMap = {};
                if (typeof privacyConfig.blockSelector === 'string') {
                  privacyConfig.blockSelector = [privacyConfig.blockSelector];
                }
                try {
                  for (var _g = __values$1((_d = privacyConfig.blockSelector) !== null && _d !== void 0 ? _d : []), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var selector = _h.value;
                    selectorMap[selector] = 'block';
                  }
                } catch (e_2_1) {
                  e_2 = {
                    error: e_2_1
                  };
                } finally {
                  try {
                    if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                  } finally {
                    if (e_2) throw e_2.error;
                  }
                }
                try {
                  for (var _j = __values$1((_e = privacyConfig.maskSelector) !== null && _e !== void 0 ? _e : []), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var selector = _k.value;
                    selectorMap[selector] = 'mask';
                  }
                } catch (e_3_1) {
                  e_3 = {
                    error: e_3_1
                  };
                } finally {
                  try {
                    if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                  } finally {
                    if (e_3) throw e_3.error;
                  }
                }
                try {
                  for (var _l = __values$1((_f = privacyConfig.unmaskSelector) !== null && _f !== void 0 ? _f : []), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var selector = _m.value;
                    selectorMap[selector] = 'unmask';
                  }
                } catch (e_4_1) {
                  e_4 = {
                    error: e_4_1
                  };
                } finally {
                  try {
                    if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
                  } finally {
                    if (e_4) throw e_4.error;
                  }
                }
                return selectorMap;
              };
              selectorMap = _assign$(_assign$({}, privacyConfigSelectorMap(localPrivacyConfig)), privacyConfigSelectorMap(remotePrivacyConfig));
              try {
                for (_h = __values$1(Object.entries(selectorMap)), _j = _h.next(); !_j.done; _j = _h.next()) {
                  _k = __read$1(_j.value, 2), selector = _k[0], selectorType = _k[1];
                  if (selectorType === 'mask') {
                    joinedPrivacyConfig.maskSelector.push(selector);
                  } else if (selectorType === 'block') {
                    joinedPrivacyConfig.blockSelector.push(selector);
                  } else if (selectorType === 'unmask') {
                    joinedPrivacyConfig.unmaskSelector.push(selector);
                  }
                }
              } catch (e_1_1) {
                e_1 = {
                  error: e_1_1
                };
              } finally {
                try {
                  if (_j && !_j.done && (_l = _h.return)) _l.call(_h);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }
              config.privacyConfig = removeInvalidSelectorsFromPrivacyConfig(joinedPrivacyConfig, this.localConfig.loggerProvider);
            }
            if (targetingConfig && Object.keys(targetingConfig).length > 0) {
              config.targetingConfig = targetingConfig;
            }
            this.localConfig.loggerProvider.debug(JSON.stringify({
              name: 'session replay joined config',
              config: getDebugConfig(config)
            }, null, 2));
            return [2 /*return*/, {
              localConfig: this.localConfig,
              joinedConfig: config,
              remoteConfig: sessionReplayRemoteConfig
            }];
        }
      });
    });
  };
  /**
   * Defensive bounds for the remote-supplied min_session_duration_ms. A misconfigured
   * value (e.g. 30_000_000) would silently suppress every replay until the config is
   * pushed again, so we clamp to a sane ceiling and warn on out-of-range inputs.
   * Returns undefined for clearly invalid values so the gate falls back to disabled
   * rather than carrying a NaN through downstream comparisons.
   */
  SessionReplayJoinedConfigGenerator.prototype.sanitizeMinSessionDurationMs = function (raw) {
    if (typeof raw !== 'number' || !Number.isFinite(raw)) {
      this.localConfig.loggerProvider.warn("min_session_duration_ms remote value is not a finite number (got ".concat(String(raw), "); ignoring."));
      return undefined;
    }
    if (raw < 0) {
      this.localConfig.loggerProvider.warn("min_session_duration_ms remote value is negative (".concat(raw, "); ignoring."));
      return undefined;
    }
    if (raw > MAX_MIN_SESSION_DURATION_MS) {
      this.localConfig.loggerProvider.warn("min_session_duration_ms remote value ".concat(raw, " exceeds ").concat(MAX_MIN_SESSION_DURATION_MS, "ms ceiling; clamping."));
      return MAX_MIN_SESSION_DURATION_MS;
    }
    return raw;
  };
  return SessionReplayJoinedConfigGenerator;
}();
/**
 * Upper bound for the remote-configured replay min duration. 60 seconds is well above
 * any reasonable bounce threshold; values higher than this are almost certainly typos
 * (e.g. seconds confused for milliseconds, or an extra zero) and would otherwise
 * suppress every replay until the config is corrected.
 */
var MAX_MIN_SESSION_DURATION_MS = 60000;
var createSessionReplayJoinedConfigGenerator = function createSessionReplayJoinedConfigGenerator(apiKey, options) {
  return __awaiter(void 0, void 0, void 0, function () {
    var localConfig, remoteConfigClient;
    return __generator(this, function (_a) {
      localConfig = new SessionReplayLocalConfig(apiKey, options);
      remoteConfigClient = new RemoteConfigClient(apiKey, localConfig.loggerProvider, localConfig.serverZone, options.configServerUrl,
      // Custom transport for the config GET. SR's FetchConfigRequest is structurally compatible
      // with RemoteConfigFetchRequest, so the customer's handleFetchConfig drops straight in.
      options.handleFetchConfig);
      return [2 /*return*/, new SessionReplayJoinedConfigGenerator(remoteConfigClient, localConfig)];
    });
  });
};
var u8 = Uint8Array,
  u16 = Uint16Array,
  u32 = Uint32Array;
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */
0, 0, /* impossible */
0]);
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */
0, 0]);
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var freb = function freb(eb, start) {
  var b = new u16(31);
  for (var i = 0; i < 31; ++i) {
    b[i] = start += 1 << eb[i - 1];
  }
  var r = new u32(b[30]);
  for (var i = 1; i < 30; ++i) {
    for (var j = b[i]; j < b[i + 1]; ++j) {
      r[j] = j - b[i] << 5 | i;
    }
  }
  return [b, r];
};
var _a = freb(fleb, 2),
  fl = _a[0],
  revfl = _a[1];
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0),
  revfd = _b[1];
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
  var x = (i & 43690) >>> 1 | (i & 21845) << 1;
  x = (x & 52428) >>> 2 | (x & 13107) << 2;
  x = (x & 61680) >>> 4 | (x & 3855) << 4;
  rev[i] = ((x & 65280) >>> 8 | (x & 255) << 8) >>> 1;
}
var hMap = function hMap(cd, mb, r) {
  var s = cd.length;
  var i = 0;
  var l = new u16(mb);
  for (; i < s; ++i) ++l[cd[i] - 1];
  var le = new u16(mb);
  for (i = 0; i < mb; ++i) {
    le[i] = le[i - 1] + l[i - 1] << 1;
  }
  var co;
  if (r) {
    co = new u16(1 << mb);
    var rvb = 15 - mb;
    for (i = 0; i < s; ++i) {
      if (cd[i]) {
        var sv = i << 4 | cd[i];
        var r_1 = mb - cd[i];
        var v = le[cd[i] - 1]++ << r_1;
        for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
          co[rev[v] >>> rvb] = sv;
        }
      }
    }
  } else {
    co = new u16(s);
    for (i = 0; i < s; ++i) co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
  }
  return co;
};
var flt = new u8(288);
for (var i = 0; i < 144; ++i) flt[i] = 8;
for (var i = 144; i < 256; ++i) flt[i] = 9;
for (var i = 256; i < 280; ++i) flt[i] = 7;
for (var i = 280; i < 288; ++i) flt[i] = 8;
var fdt = new u8(32);
for (var i = 0; i < 32; ++i) fdt[i] = 5;
var flm = /* @__PURE__ */hMap(flt, 9, 0);
var fdm = /* @__PURE__ */hMap(fdt, 5, 0);
var shft = function shft(p) {
  return (p / 8 >> 0) + (p & 7 && 1);
};
var slc = function slc(v, s, e) {
  if (e == null || e > v.length) e = v.length;
  var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
  n.set(v.subarray(s, e));
  return n;
};
var wbits = function wbits(d, p, v) {
  v <<= p & 7;
  var o = p / 8 >> 0;
  d[o] |= v;
  d[o + 1] |= v >>> 8;
};
var wbits16 = function wbits16(d, p, v) {
  v <<= p & 7;
  var o = p / 8 >> 0;
  d[o] |= v;
  d[o + 1] |= v >>> 8;
  d[o + 2] |= v >>> 16;
};
var hTree = function hTree(d, mb) {
  var t = [];
  for (var i = 0; i < d.length; ++i) {
    if (d[i]) t.push({
      s: i,
      f: d[i]
    });
  }
  var s = t.length;
  var t2 = t.slice();
  if (!s) return [new u8(0), 0];
  if (s == 1) {
    var v = new u8(t[0].s + 1);
    v[t[0].s] = 1;
    return [v, 1];
  }
  t.sort(function (a, b) {
    return a.f - b.f;
  });
  t.push({
    s: -1,
    f: 25001
  });
  var l = t[0],
    r = t[1],
    i0 = 0,
    i1 = 1,
    i2 = 2;
  t[0] = {
    s: -1,
    f: l.f + r.f,
    l,
    r
  };
  while (i1 != s - 1) {
    l = t[t[i0].f < t[i2].f ? i0++ : i2++];
    r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
    t[i1++] = {
      s: -1,
      f: l.f + r.f,
      l,
      r
    };
  }
  var maxSym = t2[0].s;
  for (var i = 1; i < s; ++i) {
    if (t2[i].s > maxSym) maxSym = t2[i].s;
  }
  var tr = new u16(maxSym + 1);
  var mbt = ln(t[i1 - 1], tr, 0);
  if (mbt > mb) {
    var i = 0,
      dt = 0;
    var lft = mbt - mb,
      cst = 1 << lft;
    t2.sort(function (a, b) {
      return tr[b.s] - tr[a.s] || a.f - b.f;
    });
    for (; i < s; ++i) {
      var i2_1 = t2[i].s;
      if (tr[i2_1] > mb) {
        dt += cst - (1 << mbt - tr[i2_1]);
        tr[i2_1] = mb;
      } else break;
    }
    dt >>>= lft;
    while (dt > 0) {
      var i2_2 = t2[i].s;
      if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;else ++i;
    }
    for (; i >= 0 && dt; --i) {
      var i2_3 = t2[i].s;
      if (tr[i2_3] == mb) {
        --tr[i2_3];
        ++dt;
      }
    }
    mbt = mb;
  }
  return [new u8(tr), mbt];
};
var ln = function ln(n, l, d) {
  return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
var lc = function lc(c) {
  var s = c.length;
  while (s && !c[--s]);
  var cl = new u16(++s);
  var cli = 0,
    cln = c[0],
    cls = 1;
  var w = function w(v) {
    cl[cli++] = v;
  };
  for (var i = 1; i <= s; ++i) {
    if (c[i] == cln && i != s) ++cls;else {
      if (!cln && cls > 2) {
        for (; cls > 138; cls -= 138) w(32754);
        if (cls > 2) {
          w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
          cls = 0;
        }
      } else if (cls > 3) {
        w(cln), --cls;
        for (; cls > 6; cls -= 6) w(8304);
        if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
      }
      while (cls--) w(cln);
      cls = 1;
      cln = c[i];
    }
  }
  return [cl.subarray(0, cli), s];
};
var clen = function clen(cf, cl) {
  var l = 0;
  for (var i = 0; i < cl.length; ++i) l += cf[i] * cl[i];
  return l;
};
var wfblk = function wfblk(out, pos, dat) {
  var s = dat.length;
  var o = shft(pos + 2);
  out[o] = s & 255;
  out[o + 1] = s >>> 8;
  out[o + 2] = out[o] ^ 255;
  out[o + 3] = out[o + 1] ^ 255;
  for (var i = 0; i < s; ++i) out[o + i + 4] = dat[i];
  return (o + 4 + s) * 8;
};
var wblk = function wblk(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
  wbits(out, p++, final);
  ++lf[256];
  var _a2 = hTree(lf, 15),
    dlt = _a2[0],
    mlb = _a2[1];
  var _b2 = hTree(df, 15),
    ddt = _b2[0],
    mdb = _b2[1];
  var _c = lc(dlt),
    lclt = _c[0],
    nlc = _c[1];
  var _d = lc(ddt),
    lcdt = _d[0],
    ndc = _d[1];
  var lcfreq = new u16(19);
  for (var i = 0; i < lclt.length; ++i) lcfreq[lclt[i] & 31]++;
  for (var i = 0; i < lcdt.length; ++i) lcfreq[lcdt[i] & 31]++;
  var _e = hTree(lcfreq, 7),
    lct = _e[0],
    mlcb = _e[1];
  var nlcc = 19;
  for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
  var flen = bl + 5 << 3;
  var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
  var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
  if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
  var lm, ll, dm, dl;
  wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
  if (dtlen < ftlen) {
    lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
    var llm = hMap(lct, mlcb, 0);
    wbits(out, p, nlc - 257);
    wbits(out, p + 5, ndc - 1);
    wbits(out, p + 10, nlcc - 4);
    p += 14;
    for (var i = 0; i < nlcc; ++i) wbits(out, p + 3 * i, lct[clim[i]]);
    p += 3 * nlcc;
    var lcts = [lclt, lcdt];
    for (var it = 0; it < 2; ++it) {
      var clct = lcts[it];
      for (var i = 0; i < clct.length; ++i) {
        var len = clct[i] & 31;
        wbits(out, p, llm[len]), p += lct[len];
        if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
      }
    }
  } else {
    lm = flm, ll = flt, dm = fdm, dl = fdt;
  }
  for (var i = 0; i < li; ++i) {
    if (syms[i] > 255) {
      var len = syms[i] >>> 18 & 31;
      wbits16(out, p, lm[len + 257]), p += ll[len + 257];
      if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
      var dst = syms[i] & 31;
      wbits16(out, p, dm[dst]), p += dl[dst];
      if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
    } else {
      wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    }
  }
  wbits16(out, p, lm[256]);
  return p + ll[256];
};
var deo = /* @__PURE__ */new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
var dflt = function dflt(dat, lvl, plvl, pre, post, lst) {
  var s = dat.length;
  var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7e3)) + post);
  var w = o.subarray(pre, o.length - post);
  var pos = 0;
  if (!lvl || s < 8) {
    for (var i = 0; i <= s; i += 65535) {
      var e = i + 65535;
      if (e < s) {
        pos = wfblk(w, pos, dat.subarray(i, e));
      } else {
        w[i] = lst;
        pos = wfblk(w, pos, dat.subarray(i, s));
      }
    }
  } else {
    var opt = deo[lvl - 1];
    var n = opt >>> 13,
      c = opt & 8191;
    var msk_1 = (1 << plvl) - 1;
    var prev = new u16(32768),
      head = new u16(msk_1 + 1);
    var bs1_1 = Math.ceil(plvl / 3),
      bs2_1 = 2 * bs1_1;
    var hsh = function hsh(i2) {
      return (dat[i2] ^ dat[i2 + 1] << bs1_1 ^ dat[i2 + 2] << bs2_1) & msk_1;
    };
    var syms = new u32(25e3);
    var lf = new u16(288),
      df = new u16(32);
    var lc_1 = 0,
      eb = 0,
      i = 0,
      li = 0,
      wi = 0,
      bs = 0;
    for (; i < s; ++i) {
      var hv = hsh(i);
      var imod = i & 32767;
      var pimod = head[hv];
      prev[imod] = pimod;
      head[hv] = imod;
      if (wi <= i) {
        var rem = s - i;
        if ((lc_1 > 7e3 || li > 24576) && rem > 423) {
          pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
          li = lc_1 = eb = 0, bs = i;
          for (var j = 0; j < 286; ++j) lf[j] = 0;
          for (var j = 0; j < 30; ++j) df[j] = 0;
        }
        var l = 2,
          d = 0,
          ch_1 = c,
          dif = imod - pimod & 32767;
        if (rem > 2 && hv == hsh(i - dif)) {
          var maxn = Math.min(n, rem) - 1;
          var maxd = Math.min(32767, i);
          var ml = Math.min(258, rem);
          while (dif <= maxd && --ch_1 && imod != pimod) {
            if (dat[i + l] == dat[i + l - dif]) {
              var nl = 0;
              for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
              if (nl > l) {
                l = nl, d = dif;
                if (nl > maxn) break;
                var mmd = Math.min(dif, nl - 2);
                var md = 0;
                for (var j = 0; j < mmd; ++j) {
                  var ti = i - dif + j + 32768 & 32767;
                  var pti = prev[ti];
                  var cd = ti - pti + 32768 & 32767;
                  if (cd > md) md = cd, pimod = ti;
                }
              }
            }
            imod = pimod, pimod = prev[imod];
            dif += imod - pimod + 32768 & 32767;
          }
        }
        if (d) {
          syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
          var lin = revfl[l] & 31,
            din = revfd[d] & 31;
          eb += fleb[lin] + fdeb[din];
          ++lf[257 + lin];
          ++df[din];
          wi = i + l;
          ++lc_1;
        } else {
          syms[li++] = dat[i];
          ++lf[dat[i]];
        }
      }
    }
    pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
  }
  return slc(o, 0, pre + shft(pos) + post);
};
var adler = function adler() {
  var a = 1,
    b = 0;
  return {
    p: function (d) {
      var n = a,
        m = b;
      var l = d.length;
      for (var i = 0; i != l;) {
        var e = Math.min(i + 5552, l);
        for (; i < e; ++i) n += d[i], m += n;
        n %= 65521, m %= 65521;
      }
      a = n, b = m;
    },
    d: function () {
      return (a >>> 8 << 16 | (b & 255) << 8 | b >>> 8) + ((a & 255) << 23) * 2;
    }
  };
};
var dopt = function dopt(dat, opt, pre, post, st) {
  return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, true);
};
var wbytes = function wbytes(d, b, v) {
  for (; v; ++b) d[b] = v, v >>>= 8;
};
var zlh = function zlh(c, o) {
  var lv = o.level,
    fl2 = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
  c[0] = 120, c[1] = fl2 << 6 | (fl2 ? 32 - 2 * fl2 : 1);
};
function zlibSync(data, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var a = adler();
  a.p(data);
  var d = dopt(data, opts, 2, 4);
  return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
function strToU8(str, latin1) {
  var l = str.length;
  if (typeof TextEncoder != "undefined") return new TextEncoder().encode(str);
  var ar = new u8(str.length + (str.length >>> 1));
  var ai = 0;
  var w = function w(v) {
    ar[ai++] = v;
  };
  for (var i = 0; i < l; ++i) {
    if (ai + 5 > ar.length) {
      var n = new u8(ai + 8 + (l - i << 1));
      n.set(ar);
      ar = n;
    }
    var c = str.charCodeAt(i);
    if (c < 128 || latin1) w(c);else if (c < 2048) w(192 | c >>> 6), w(128 | c & 63);else if (c > 55295 && c < 57344) c = 65536 + (c & 1023 << 10) | str.charCodeAt(++i) & 1023, w(240 | c >>> 18), w(128 | c >>> 12 & 63), w(128 | c >>> 6 & 63), w(128 | c & 63);else w(224 | c >>> 12), w(128 | c >>> 6 & 63), w(128 | c & 63);
  }
  return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
  var r = "";
  for (var i = 0; i < dat.length;) {
    var c = dat[i++];
    r += String.fromCharCode(c);
  }
  return r;
}
const MARK = "v1";
const pack = event => {
  const _e = Object.assign({}, event, {
    v: MARK
  });
  return strFromU8(zlibSync(strToU8(JSON.stringify(_e))));
};

/**
 * UTF-8 byte length of `str`, matching `TextEncoder` / `new Blob([str]).size` without
 * allocating. Unpaired surrogates count as U+FFFD (3 bytes), like the platform encoder.
 */
function utf8ByteLength(str) {
  var len = str.length;
  var i = 0;
  // ASCII fast path: rrweb payloads are mostly ASCII JSON.
  for (; i < len; i++) {
    if (str.charCodeAt(i) > 0x7f) break;
  }
  if (i === len) return len;
  var bytes = i;
  for (; i < len; i++) {
    var code = str.charCodeAt(i);
    if (code <= 0x7f) {
      bytes++;
    } else if (code <= 0x7ff) {
      bytes += 2;
    } else if (code >= 0xd800 && code <= 0xdbff) {
      var next = i + 1 < len ? str.charCodeAt(i + 1) : NaN;
      if (next >= 0xdc00 && next <= 0xdfff) {
        bytes += 4;
        i++;
      } else {
        bytes += 3;
      }
    } else {
      bytes += 3;
    }
  }
  return bytes;
}
function utf8ByteLengthOf(parts) {
  var total = 0;
  for (var i = 0; i < parts.length; i++) {
    total += utf8ByteLength(parts[i]);
  }
  return total;
}
/**
 * Byte length when `str` exceeds `maxBytes`, otherwise `undefined`. A UTF-16 code unit is
 * at most 3 UTF-8 bytes, so strings with `length * 3 <= maxBytes` are not scanned at all.
 */
function utf8ByteLengthIfOver(str, maxBytes) {
  if (str.length * 3 <= maxBytes) return undefined;
  var bytes = utf8ByteLength(str);
  return bytes > maxBytes ? bytes : undefined;
}
/** Longest prefix of `str` within `maxBytes` of UTF-8, never splitting a surrogate pair. */
function truncateUtf8(str, maxBytes) {
  if (maxBytes < 0) maxBytes = 0;
  var len = str.length;
  var bytes = 0;
  var i = 0;
  for (; i < len; i++) {
    var code = str.charCodeAt(i);
    var width = 1;
    var units = 1;
    if (code <= 0x7f) {
      width = 1;
    } else if (code <= 0x7ff) {
      width = 2;
    } else if (code >= 0xd800 && code <= 0xdbff) {
      var next = i + 1 < len ? str.charCodeAt(i + 1) : NaN;
      if (next >= 0xdc00 && next <= 0xdfff) {
        width = 4;
        units = 2;
      } else {
        width = 3;
      }
    } else {
      width = 3;
    }
    if (bytes + width > maxBytes) break;
    bytes += width;
    if (units === 2) i++;
  }
  if (i >= len) return {
    value: str,
    truncated: false
  };
  return {
    value: str.slice(0, i),
    truncated: true
  };
}
var DEFAULT_TIMEOUT = 2000;
var EventCompressor = /** @class */function () {
  function EventCompressor(eventsManager, config, deviceId, workerScript, onFullSnapshotProcessed) {
    var _this = this;
    var _a;
    this.taskQueue = [];
    this.pendingQueue = [];
    this.isProcessing = false;
    this.compressEvent = function (event) {
      return JSON.stringify(pack(event));
    };
    this.addCompressedEventToManager = function (compressedEvent, sessionId) {
      var _a;
      // UTF-8 byte size, not JS char count: a 9 M-char string of CJK/emoji can be 18–27 MB
      // on the wire and would otherwise slip past a char-count guard.
      var maxEventBytes = (_a = _this.config.maxSingleEventSizeBytes) !== null && _a !== void 0 ? _a : MAX_SINGLE_EVENT_SIZE;
      var eventSizeBytes = utf8ByteLengthIfOver(compressedEvent, maxEventBytes);
      if (eventSizeBytes !== undefined) {
        _this.config.loggerProvider.warn("Session replay event dropped: serialized size ".concat(Math.round(eventSizeBytes / 1024), " KB exceeds maximum allowed event size. If this recurs, please open a GitHub issue at https://github.com/amplitude/Amplitude-TypeScript/issues or contact Amplitude support."));
        return;
      }
      if (_this.eventsManager && _this.deviceId) {
        _this.eventsManager.addEvent({
          event: {
            type: 'replay',
            data: compressedEvent
          },
          sessionId: sessionId,
          deviceId: _this.deviceId
        });
      }
    };
    this.addCompressedEvent = function (event, sessionId) {
      if (_this.worker) {
        // This indirectly compresses the event.
        try {
          _this.worker.postMessage({
            event: event,
            sessionId: sessionId
          });
        } catch (err) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          if (err.name === 'DataCloneError') {
            // fallback: serialize
            _this.worker.postMessage(JSON.stringify({
              event: event,
              sessionId: sessionId
            }));
          } else {
            _this.config.loggerProvider.warn('Unexpected error while posting message to worker:', err);
          }
        }
      } else {
        var compressedEvent = _this.compressEvent(event);
        _this.addCompressedEventToManager(compressedEvent, sessionId);
      }
    };
    /**
     * Synchronously drain all queued events. Called during page unload to prevent
     * data loss from events waiting in the requestIdleCallback queue.
     */
    this.flushQueue = function () {
      var _a;
      // Merge any events still in pendingQueue into taskQueue first.
      // Events land in pendingQueue when the idle callback hasn't fired yet;
      // without this step they would be silently lost on page unload.
      if (_this.pendingQueue.length > 0) {
        (_a = _this.taskQueue).push.apply(_a, __spreadArray([], __read$1(_this.mergeMutationTasks(_this.pendingQueue.splice(0))), false));
      }
      while (_this.taskQueue.length > 0) {
        var task = _this.taskQueue.shift();
        if (task) {
          var event_1 = task.event,
            sessionId = task.sessionId;
          // Bypass the web worker: compress synchronously on the main thread and
          // write directly to the manager. postMessage is async — during page
          // unload the worker response would never arrive and events would be
          // silently dropped. This mirrors the pattern used for full snapshots in
          // enqueueEvent().
          var compressed = _this.compressEvent(event_1);
          _this.addCompressedEventToManager(compressed, sessionId);
        }
      }
      _this.isProcessing = false;
    };
    this.terminate = function () {
      var _a;
      (_a = _this.worker) === null || _a === void 0 ? void 0 : _a.terminate();
    };
    var globalScope = getGlobalScope();
    this.canUseIdleCallback = globalScope && 'requestIdleCallback' in globalScope;
    this.eventsManager = eventsManager;
    this.config = config;
    this.deviceId = deviceId;
    this.timeout = ((_a = config.performanceConfig) === null || _a === void 0 ? void 0 : _a.timeout) || DEFAULT_TIMEOUT;
    this.onFullSnapshotProcessed = onFullSnapshotProcessed;
    if (workerScript) {
      config.loggerProvider.log('Enabling web worker for compression');
      try {
        var blob = new Blob([workerScript], {
          type: 'application/javascript'
        });
        var blobUrl = URL.createObjectURL(blob);
        var worker_1 = new Worker(blobUrl);
        worker_1.onerror = function (e) {
          e.preventDefault();
          config.loggerProvider.error("Worker failed, falling back to non-worker compression: ".concat(e.message, " (").concat(e.filename, ":").concat(e.lineno, ")"));
          worker_1.terminate();
          _this.worker = undefined;
        };
        worker_1.onmessage = function (e) {
          var _a = e.data,
            compressedEvent = _a.compressedEvent,
            sessionId = _a.sessionId;
          _this.addCompressedEventToManager(compressedEvent, sessionId);
        };
        this.worker = worker_1;
      } catch (error) {
        config.loggerProvider.error('Failed to create worker, falling back to non-worker compression:', error);
      }
    }
  }
  // Schedule processing during idle time
  EventCompressor.prototype.scheduleIdleProcessing = function () {
    var _this = this;
    if (!this.isProcessing) {
      this.isProcessing = true;
      requestIdleCallback(function (idleDeadline) {
        _this.processQueue(idleDeadline);
      }, {
        timeout: this.timeout
      });
    }
  };
  // Add an event to the task queue if idle callback is supported or compress the event directly
  EventCompressor.prototype.enqueueEvent = function (event, sessionId) {
    var e_1, _a;
    var _b, _c;
    // Full snapshot (type 2) is the most critical event — a replay cannot be played without it.
    // Process and flush immediately rather than waiting for the idle scheduler or web worker,
    // maximising the chance it is delivered before the user exits the page.
    if (event.type === EventType.FullSnapshot) {
      this.config.loggerProvider.debug('Processing full snapshot immediately.');
      // Drain any events still pending in the idle-callback queue first.
      // Those events reference the pre-snapshot DOM and must be sent before
      // the full snapshot; if we let them be processed later they'd arrive at
      // the server after the snapshot and cause "node not found" replay errors.
      if (this.taskQueue.length > 0 || this.pendingQueue.length > 0) {
        var allTasks = __spreadArray(__spreadArray([], __read$1(this.taskQueue.splice(0)), false), __read$1(this.mergeMutationTasks(this.pendingQueue.splice(0))), false);
        try {
          for (var allTasks_1 = __values$1(allTasks), allTasks_1_1 = allTasks_1.next(); !allTasks_1_1.done; allTasks_1_1 = allTasks_1.next()) {
            var task = allTasks_1_1.value;
            var compressed = this.compressEvent(task.event);
            this.addCompressedEventToManager(compressed, task.sessionId);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (allTasks_1_1 && !allTasks_1_1.done && (_a = allTasks_1.return)) _a.call(allTasks_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        this.isProcessing = false;
      }
      var compressedEvent = this.compressEvent(event);
      this.addCompressedEventToManager(compressedEvent, sessionId);
      (_b = this.onFullSnapshotProcessed) === null || _b === void 0 ? void 0 : _b.call(this);
      return;
    }
    if (this.canUseIdleCallback && ((_c = this.config.performanceConfig) === null || _c === void 0 ? void 0 : _c.enabled)) {
      this.config.loggerProvider.debug('Enqueuing event for processing during idle time.');
      this.pendingQueue.push({
        event: event,
        sessionId: sessionId
      });
      this.scheduleIdleProcessing();
    } else {
      this.config.loggerProvider.debug('Processing event without idle callback.');
      this.addCompressedEvent(event, sessionId);
    }
  };
  // Process the task queue during idle time
  EventCompressor.prototype.processQueue = function (idleDeadline) {
    var _a;
    var _this = this;
    // Merge newly-arrived pending events and append to the already-merged taskQueue.
    // Keeping them separate prevents re-merging already-merged tasks on subsequent calls,
    // which would corrupt move semantics for nodes that appear in multiple merge passes.
    if (this.pendingQueue.length > 0) {
      (_a = this.taskQueue).push.apply(_a, __spreadArray([], __read$1(this.mergeMutationTasks(this.pendingQueue.splice(0))), false));
    }
    // Process tasks while there's idle time or until the max number of tasks is reached
    while (this.taskQueue.length > 0 && (idleDeadline.timeRemaining() > 0 || idleDeadline.didTimeout)) {
      var task = this.taskQueue.shift();
      if (task) {
        var event_2 = task.event,
          sessionId = task.sessionId;
        this.addCompressedEvent(event_2, sessionId);
      }
    }
    // If there are still tasks in the queue, schedule the next idle callback
    if (this.taskQueue.length > 0 || this.pendingQueue.length > 0) {
      requestIdleCallback(function (idleDeadline) {
        _this.processQueue(idleDeadline);
      }, {
        timeout: this.timeout
      });
    } else {
      this.isProcessing = false;
    }
  };
  // Merge consecutive mutation tasks with the same sessionId before processing,
  // reducing the number of events serialized and stored without changing replay semantics.
  // Enabled by default (validated amp-on-amp perf config, SR-4646); only skipped when
  // performanceConfig.mergeMutations is explicitly set to false.
  EventCompressor.prototype.mergeMutationTasks = function (tasks) {
    return tasks;
  };
  return EventCompressor;
}();
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, event batch rejected';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Session replay event batch rejected due to exceeded retry count';
var STORAGE_FAILURE = 'Failed to store session replay events in IndexedDB';
var MISSING_DEVICE_ID_MESSAGE = 'Session replay event batch not sent due to missing device ID';
var MISSING_API_KEY_MESSAGE = 'Session replay event batch not sent due to missing api key';
var SESSION_KILLED_MESSAGE = 'Session replay event batch dropped: server signalled capture disabled or session out of valid range for this session';

// Autogenerated by `pnpm version-file`. DO NOT EDIT
var VERSION = '1.51.3';

/**
 * Gzip-compresses a JSON string using the CompressionStream API.
 * The `scope` parameter must be the global object (window or self) that
 * owns the CompressionStream constructor. The caller is responsible for
 * verifying that CompressionStream exists on that scope before calling.
 * Returns null if compression fails for any reason.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function gzipJson(jsonStr, scope) {
  return __awaiter(this, void 0, void 0, function () {
    var CS, stream, writer, reader_1, chunks_2, readPromise, totalLength, result, offset, chunks_1, chunks_1_1, chunk;
    var e_1, _b;
    var _this = this;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _c.trys.push([0, 4,, 5]);
          CS = scope.CompressionStream;
          stream = new CS('gzip');
          writer = stream.writable.getWriter();
          reader_1 = stream.readable.getReader();
          chunks_2 = [];
          readPromise = function () {
            return __awaiter(_this, void 0, void 0, function () {
              var _a, done, value;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    return [4 /*yield*/, reader_1.read()];
                  case 1:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (done) return [3 /*break*/, 3];
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    chunks_2.push(value);
                    _b.label = 2;
                  case 2:
                    return [3 /*break*/, 0];
                  case 3:
                    return [2 /*return*/];
                }
              });
            });
          }();
          return [4 /*yield*/, writer.write(new TextEncoder().encode(jsonStr))];
        case 1:
          _c.sent();
          return [4 /*yield*/, writer.close()];
        case 2:
          _c.sent();
          return [4 /*yield*/, readPromise];
        case 3:
          _c.sent();
          totalLength = chunks_2.reduce(function (sum, c) {
            return sum + c.length;
          }, 0);
          result = new Uint8Array(totalLength);
          offset = 0;
          try {
            for (chunks_1 = __values$1(chunks_2), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()) {
              chunk = chunks_1_1.value;
              result.set(chunk, offset);
              offset += chunk.length;
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          return [2 /*return*/, result];
        case 4:
          _c.sent();
          return [2 /*return*/, null];
        case 5:
          return [2 /*return*/];
      }
    });
  });
}

// Bounded so a long-lived SDK instance can't accumulate kill records indefinitely;
// sessions are time-bounded in practice, this cap is just a defensive ceiling.
var MAX_KILLED_SESSIONS = 256;
// Defensive ceiling on retained timed-out worker requests (see timedOutWorkerRequests).
// In normal operation each entry is removed when the worker's late message arrives; this
// cap only guards the pathological case of a wedged worker that never replies at all.
var MAX_TIMED_OUT_WORKER_REQUESTS = 256;
// Settles with `promise`, but rejects early with an AbortError when `signal` fires. Used to apply
// the send timeout to a custom transport whose own promise can't be cancelled: a hung transport
// then surfaces as a retryable timeout (matching the built-in fetch and worker delegation paths)
// instead of blocking the serial flush loop. The transport's promise keeps running; we just stop
// awaiting it. `signal` is always supplied with the send-timeout controller's signal.
function abortable(promise, signal) {
  return new Promise(function (resolve, reject) {
    var onAbort = function onAbort() {
      // Match how browsers reject an aborted fetch (DOMException 'AbortError'); sendOnMainThread's
      // catch keys off the name to route it through the retry budget rather than failing fatally.
      var err = new Error('Custom session replay transport aborted by send timeout');
      err.name = 'AbortError';
      reject(err);
    };
    signal.addEventListener('abort', onAbort, {
      once: true
    });
    promise.then(function (value) {
      signal.removeEventListener('abort', onAbort);
      resolve(value);
    }, function (err) {
      signal.removeEventListener('abort', onAbort);
      reject(err);
    });
  });
}
var SessionReplayTrackDestination = /** @class */function () {
  function SessionReplayTrackDestination(_a) {
    var trackServerUrl = _a.trackServerUrl,
      loggerProvider = _a.loggerProvider,
      payloadBatcher = _a.payloadBatcher,
      workerScript = _a.workerScript,
      enableTransportCompression = _a.enableTransportCompression,
      sendTimeoutMs = _a.sendTimeoutMs,
      handleSendEvents = _a.handleSendEvents;
    var _this = this;
    this.storageKey = '';
    this.retryTimeout = 1000;
    this.scheduled = null;
    this.queue = [];
    this.sendIdCounter = 0;
    this.pendingWorkerRequests = new Map();
    // Requests the main thread stopped awaiting after SEND_TIMEOUT_MS (so the serial flush
    // loop could proceed) but whose worker may still be retrying in the background. We keep
    // the context — bounded, like killedSessions — so a *late* worker complete/payload_too_large
    // can still run completeRequest and settle the store record. Without this the late message
    // is dropped (its id is gone from pendingWorkerRequests), so a successful late delivery would
    // leave the IDB/memory record behind for sendStoredEvents to re-upload as duplicate replay data.
    this.timedOutWorkerRequests = new Map();
    // Server back-pressure state, fed by the X-Session-Replay-Event-Skipped header on 200s.
    // The server uses this header (instead of 4xx) to signal a deliberate no-retry drop so SDKs
    // don't retry-storm. We honor it here by slowing or stopping our flush schedule.
    this.flushPauseUntilMs = 0;
    // Set when schedule() defers a flush because we're inside a throttle pause; consumed by
    // flush() to merge same-session contexts before sending. Throttling is enforced by request
    // count, so collapsing N queued batches into one POST directly reduces throttle pressure.
    this.mergeOnNextFlush = false;
    // Set by markCoalesceNextFlush() before the page-load backlog is enqueued; consumed by
    // flush() to coalesce the drained persisted sequences. Distinct from
    // mergeOnNextFlush so the drain isn't conflated with a throttle pause for logging.
    this.coalesceNextFlush = false;
    // Gates the merge log to once per throttle pause window — mirroring the throttle log's
    // transition-only gating — so a sustained throttle scenario doesn't spam logs every cycle.
    this.mergeLogFiredThisPause = false;
    this.killedSessions = new Set();
    this.loggerProvider = loggerProvider;
    this.payloadBatcher = payloadBatcher ? payloadBatcher : function (payload) {
      return payload;
    };
    this.trackServerUrl = trackServerUrl;
    this.enableTransportCompression = enableTransportCompression !== null && enableTransportCompression !== void 0 ? enableTransportCompression : false;
    this.sendTimeoutMs = sendTimeoutMs !== null && sendTimeoutMs !== void 0 ? sendTimeoutMs : SEND_TIMEOUT_MS;
    this.handleSendEvents = handleSendEvents;
    if (workerScript) {
      try {
        var blob = new Blob([workerScript], {
          type: 'application/javascript'
        });
        var blobUrl = URL.createObjectURL(blob);
        var worker_1 = new Worker(blobUrl);
        worker_1.onerror = function (e) {
          var e_1, _a;
          e.preventDefault();
          loggerProvider.error("Track destination worker failed, falling back to main-thread sending: ".concat(e.message, " (").concat(e.filename, ":").concat(e.lineno, ")"));
          worker_1.terminate();
          _this.worker = undefined;
          try {
            // Resolve pending promises so flush() doesn't hang. Do NOT call completeRequest
            // here — the events were never delivered, so onComplete must not fire and the
            // IDB/memory store entries must remain intact for recovery by sendStoredEvents.
            for (var _b = __values$1(_this.pendingWorkerRequests), _c = _b.next(); !_c.done; _c = _b.next()) {
              var _d = __read$1(_c.value, 2),
                pending_1 = _d[1];
              // Cancel the per-request timeout — onerror already settles every pending
              // promise, so leaving the timer armed would fire a spurious timeout warn later.
              if (pending_1.timeout) clearTimeout(pending_1.timeout);
              loggerProvider.warn("Session replay event send failed due to worker crash: ".concat(e.message));
              pending_1.resolve();
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          _this.pendingWorkerRequests.clear();
          // The worker is gone, so no late completion can arrive for timed-out requests either.
          // Drop the retained contexts to free memory; their store records stay intact (we never
          // completeRequest here) so sendStoredEvents can recover them on next init.
          _this.timedOutWorkerRequests.clear();
        };
        worker_1.onmessage = function (e) {
          var msg = e.data;
          if (msg.type === 'log') {
            loggerProvider.log(msg.message);
          } else if (msg.type === 'warn') {
            loggerProvider.warn(msg.message);
          } else if (msg.type === 'payload_too_large') {
            var pending_2 = _this.pendingWorkerRequests.get(msg.id);
            if (pending_2) {
              if (pending_2.timeout) clearTimeout(pending_2.timeout);
              _this.handlePayloadTooLargeResponse(pending_2.context, msg.isWaf);
              pending_2.resolve();
              _this.pendingWorkerRequests.delete(msg.id);
            } else {
              // Late message for a request the main thread already timed out: the worker still
              // determined the payload was too large, so split-and-retry off the original record.
              var timedOut = _this.timedOutWorkerRequests.get(msg.id);
              if (timedOut) {
                _this.timedOutWorkerRequests.delete(msg.id);
                _this.handlePayloadTooLargeResponse(timedOut, msg.isWaf);
              }
            }
          } else if (msg.type === 'complete') {
            var pending_3 = _this.pendingWorkerRequests.get(msg.id);
            if (pending_3) {
              if (pending_3.timeout) clearTimeout(pending_3.timeout);
              if (msg.skipCode !== undefined) {
                _this.applyServerDirective(pending_3.context.sessionId, msg.skipCode);
              }
              _this.completeRequest({
                context: pending_3.context
              });
              pending_3.resolve();
              _this.pendingWorkerRequests.delete(msg.id);
            } else {
              // Late completion for a request the main thread already timed out. The worker's
              // actual outcome (delivered, or retries exhausted) is authoritative, so settle the
              // store record by it rather than leaving it behind for sendStoredEvents to re-upload.
              var timedOut = _this.timedOutWorkerRequests.get(msg.id);
              if (timedOut) {
                _this.timedOutWorkerRequests.delete(msg.id);
                if (msg.skipCode !== undefined) {
                  _this.applyServerDirective(timedOut.sessionId, msg.skipCode);
                }
                _this.completeRequest({
                  context: timedOut
                });
              }
            }
          } else if (msg.type === 'fetch-request') {
            // Worker is delegating one network attempt to the custom transport (which lives on
            // the main thread). Run it and post the result back into the worker's retry loop.
            // Guard the fire-and-forget call: if posting the result back fails (e.g. the worker
            // was terminated mid-flight), surface it to the logger instead of leaving an
            // unhandled rejection.
            void _this.handleDelegatedFetch(worker_1, msg).catch(function (e) {
              loggerProvider.warn('Failed to handle delegated session replay fetch:', e);
            });
          }
        };
        this.worker = worker_1;
      } catch (error) {
        loggerProvider.error('Failed to create track destination worker, falling back to main-thread sending:', error);
      }
    }
  }
  SessionReplayTrackDestination.prototype.sendEventsList = function (destinationData) {
    this.addToQueue(_assign$(_assign$({}, destinationData), {
      attempts: 0,
      timeout: 0
    }));
  };
  /**
   * Marks the next scheduled flush to coalesce its queued contexts by destination identity.
   * Callers use this immediately before enqueuing the page-load backlog drain (many persisted
   * sequences replayed back-to-back on init via sendStoredEvents). Because those enqueues are
   * synchronous and the flush is deferred to the next tick via schedule(0), the whole backlog
   * lands in the queue before the flag is consumed — collapsing N small POSTs into far fewer
   * and avoiding the request flood observed on page load. Steady-state live capture
   * never sets this flag, so its sending behavior is unchanged.
   *
   * Schedules a flush so the flag is always consumed by the next flush, even when every
   * backlog sequence is dropped before reaching the queue (e.g. all events oversized) and no
   * enqueue schedules one itself. Otherwise the flag would stick and a later unrelated live
   * flush could coalesce live batches as if they were a page-load drain.
   */
  SessionReplayTrackDestination.prototype.markCoalesceNextFlush = function () {
    this.coalesceNextFlush = true;
    this.schedule(0);
  };
  /**
   * Sends events via navigator.sendBeacon on page exit.
   * Beacon payloads are sent as uncompressed JSON because sendBeacon does not support
   * Content-Encoding, and small incremental batches don't benefit much from compression.
   * The full snapshot has already been sent eagerly via fetch, so the beacon only needs
   * to cover the remaining incremental events since the last fetch flush.
   */
  SessionReplayTrackDestination.prototype.sendBeacon = function (_a) {
    return;
  };
  SessionReplayTrackDestination.prototype.addToQueue = function () {
    var _this = this;
    var list = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      list[_i] = arguments[_i];
    }
    var tryable = list.filter(function (context) {
      if (_this.killedSessions.has(context.sessionId)) {
        // Server has signaled capture_disabled or session_in_invalid_range for this session;
        // drop the batch (and clean up its IDB record via onComplete) instead of POSTing.
        _this.completeRequest({
          context: context,
          err: SESSION_KILLED_MESSAGE
        });
        return false;
      }
      if (context.attempts < (context.flushMaxRetries || 0)) {
        context.attempts += 1;
        return true;
      }
      _this.completeRequest({
        context: context,
        err: MAX_RETRIES_EXCEEDED_MESSAGE
      });
      return false;
    });
    tryable.forEach(function (context) {
      _this.queue = _this.queue.concat(context);
      _this.schedule(0);
    });
  };
  SessionReplayTrackDestination.prototype.schedule = function (timeout) {
    var _this = this;
    if (this.scheduled) return;
    // If the server signaled throttling on a recent 200, defer the next flush until the
    // pause window ends. This lets us keep batching events without retry-storming the server.
    var pauseRemaining = this.flushPauseUntilMs - Date.now();
    var isPaused = pauseRemaining > 0;
    var effectiveTimeout = pauseRemaining > timeout ? pauseRemaining : timeout;
    if (isPaused) {
      // Mark the upcoming flush for merge: contexts piling up during the pause should
      // be coalesced into one POST per (session, device, api, type, ...) group.
      this.mergeOnNextFlush = true;
    }
    this.scheduled = setTimeout(function () {
      void _this.flush(true).then(function () {
        if (_this.queue.length > 0) {
          _this.schedule(timeout);
        }
      });
    }, effectiveTimeout);
  };
  SessionReplayTrackDestination.prototype.flush = function (useRetry) {
    if (useRetry === void 0) {
      useRetry = false;
    }
    return __awaiter(this, void 0, void 0, function () {
      var list, list_1, list_1_1, context, e_2_1;
      var e_2, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            list = this.queue;
            this.queue = [];
            if (this.scheduled) {
              clearTimeout(this.scheduled);
              this.scheduled = null;
            }
            if (this.mergeOnNextFlush) {
              this.mergeOnNextFlush = false;
              // A throttle merge already coalesces by identity; clear the drain flag too so the
              // same backlog isn't passed through a redundant second merge on a later flush.
              this.coalesceNextFlush = false;
              list = this.mergeQueueAfterThrottle(list);
            } else if (this.coalesceNextFlush) {
              this.coalesceNextFlush = false;
              list = this.mergeDrainBacklog(list);
            }
            _b.label = 1;
          case 1:
            _b.trys.push([1, 6, 7, 8]);
            list_1 = __values$1(list), list_1_1 = list_1.next();
            _b.label = 2;
          case 2:
            if (!!list_1_1.done) return [3 /*break*/, 5];
            context = list_1_1.value;
            return [4 /*yield*/, this.send(context, useRetry)];
          case 3:
            _b.sent();
            _b.label = 4;
          case 4:
            list_1_1 = list_1.next();
            return [3 /*break*/, 2];
          case 5:
            return [3 /*break*/, 8];
          case 6:
            e_2_1 = _b.sent();
            e_2 = {
              error: e_2_1
            };
            return [3 /*break*/, 8];
          case 7:
            try {
              if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
            } finally {
              if (e_2) throw e_2.error;
            }
            return [7 /*endfinally*/];
          case 8:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Post-throttle release path: coalesce the queued contexts, then log once per pause window.
   * Delegates the actual merging to the shared coalesceByIdentity helper so the drain path
   * (mergeDrainBacklog) and this path stay byte-for-byte identical in how they merge.
   */
  SessionReplayTrackDestination.prototype.mergeQueueAfterThrottle = function (list) {
    var merged = this.coalesceByIdentity(list);
    if (merged.length < list.length && !this.mergeLogFiredThisPause) {
      this.mergeLogFiredThisPause = true;
      this.loggerProvider.log("Session replay throttle pause ended; merged ".concat(list.length, " queued batches into ").concat(merged.length, " request(s)"));
    }
    return merged;
  };
  /**
   * Page-load backlog drain path: on init the SDK replays every persisted sequence
   * from a prior session via sendStoredEvents. Enqueued back-to-back they would flush as N
   * separate POSTs — a request flood on page load that feeds volume spikes and throttling.
   * Reuses the exact same identity-grouped merge as the post-throttle path so the backlog
   * collapses into far fewer requests, with onComplete fanned out so each source IDB record
   * is still cleaned up exactly once on success.
   */
  SessionReplayTrackDestination.prototype.mergeDrainBacklog = function (list) {
    var merged = this.coalesceByIdentity(list);
    if (merged.length < list.length) {
      this.loggerProvider.log("Session replay coalesced ".concat(list.length, " persisted page-load backlog batches into ").concat(merged.length, " request(s)"));
    }
    return merged;
  };
  /**
   * Coalesces queued contexts that share the same destination identity into fewer requests.
   * Identity covers everything that affects the request URL, routing, or per-request semantics
   * — splitting on any difference keeps each merged POST indistinguishable from the source
   * contexts it replaced.
   *
   * Greedy concat with a soft byte-length cap (`MERGE_AFTER_THROTTLE_SOFT_CAP`) keeps merged
   * payloads well under the 413 ceiling; on the rare oversized merge, the existing
   * split-and-retry path still bisects safely.
   *
   * The merged context's `onComplete` fans out to every source context's callback so each
   * underlying IDB sequence record is cleaned up exactly once on success.
   */
  SessionReplayTrackDestination.prototype.coalesceByIdentity = function (list) {
    var e_3, _a, e_4, _b;
    var _c, _d, _e, _f, _g, _h, _j;
    if (list.length <= 1) return list;
    var groups = new Map();
    try {
      for (var list_2 = __values$1(list), list_2_1 = list_2.next(); !list_2_1.done; list_2_1 = list_2.next()) {
        var ctx = list_2_1.value;
        // Anything that can change the URL, headers, or backend routing must split groups.
        var key = [ctx.sessionId, (_c = ctx.deviceId) !== null && _c !== void 0 ? _c : '', (_d = ctx.apiKey) !== null && _d !== void 0 ? _d : '', ctx.type, (_e = ctx.serverZone) !== null && _e !== void 0 ? _e : '', ctx.sampleRate, (_g = (_f = ctx.version) === null || _f === void 0 ? void 0 : _f.type) !== null && _g !== void 0 ? _g : '', (_j = (_h = ctx.version) === null || _h === void 0 ? void 0 : _h.version) !== null && _j !== void 0 ? _j : ''].join('|');
        var arr = groups.get(key);
        if (arr) arr.push(ctx);else groups.set(key, [ctx]);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (list_2_1 && !list_2_1.done && (_a = list_2.return)) _a.call(list_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    var merged = [];
    var _loop_1 = function _loop_1(group) {
      var e_5, _m;
      if (group.length === 1) {
        merged.push(group[0]);
        return "continue";
      }
      var current = null;
      var currentBytes = 0;
      var currentCompletes = [];
      var flushCurrent = function flushCurrent() {
        if (current) {
          if (currentCompletes.length > 1) {
            var completes_1 = currentCompletes;
            current.onComplete = function () {
              return Promise.allSettled(completes_1.map(function (complete) {
                try {
                  return complete();
                } catch (e) {
                  return Promise.reject(e);
                }
              })).then(function () {
                return undefined;
              });
            };
          }
          merged.push(current);
        }
        current = null;
        currentBytes = 0;
        currentCompletes = [];
      };
      var _loop_2 = function _loop_2(ctx) {
        // UTF-8 byte size, matching how the events store enforces MAX_EVENT_LIST_SIZE
        // (see utils/utf8-byte-length.ts). Using char length would let a CJK/
        // emoji-heavy payload sneak past the cap.
        var ctxBytes = utf8ByteLengthOf(ctx.events);
        if (current === null) {
          // Reset attempts to 0 on the merged context so the post-throttle delivery gets a
          // full retry budget. The throttle pause has already absorbed back-pressure; the
          // alternative (Math.max of source attempts) would collapse N source budgets into
          // one and end-of-life all N IDB records on a single retry exhaustion.
          current = _assign$(_assign$({}, ctx), {
            events: __spreadArray([], __read$1(ctx.events), false),
            attempts: 0
          });
          currentBytes = ctxBytes;
          currentCompletes = [ctx.onComplete];
          return "continue";
        }
        if (currentBytes + ctxBytes > MERGE_AFTER_THROTTLE_SOFT_CAP) {
          flushCurrent();
          current = _assign$(_assign$({}, ctx), {
            events: __spreadArray([], __read$1(ctx.events), false),
            attempts: 0
          });
          currentBytes = ctxBytes;
          currentCompletes = [ctx.onComplete];
          return "continue";
        }
        current.events = current.events.concat(ctx.events);
        currentBytes += ctxBytes;
        currentCompletes.push(ctx.onComplete);
      };
      try {
        for (var group_1 = (e_5 = void 0, __values$1(group)), group_1_1 = group_1.next(); !group_1_1.done; group_1_1 = group_1.next()) {
          var ctx = group_1_1.value;
          _loop_2(ctx);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (group_1_1 && !group_1_1.done && (_m = group_1.return)) _m.call(group_1);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      flushCurrent();
    };
    try {
      for (var _k = __values$1(groups.values()), _l = _k.next(); !_l.done; _l = _k.next()) {
        var group = _l.value;
        _loop_1(group);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_l && !_l.done && (_b = _k.return)) _b.call(_k);
      } finally {
        if (e_4) throw e_4.error;
      }
    }
    return merged;
  };
  SessionReplayTrackDestination.prototype.send = function (context, useRetry) {
    if (useRetry === void 0) {
      useRetry = true;
    }
    return __awaiter(this, void 0, void 0, function () {
      var apiKey, deviceId, payload, worker;
      return __generator(this, function (_a) {
        // A kill directive can arrive between flush() snapshotting the queue and us reaching
        // each context. Re-check before hitting the network so we don't waste POSTs on a
        // session the server has already told us to stop sending for.
        if (this.killedSessions.has(context.sessionId)) {
          return [2 /*return*/, this.completeRequest({
            context: context,
            err: SESSION_KILLED_MESSAGE
          })];
        }
        apiKey = context.apiKey;
        if (!apiKey) {
          return [2 /*return*/, this.completeRequest({
            context: context,
            err: MISSING_API_KEY_MESSAGE
          })];
        }
        deviceId = context.deviceId;
        if (!deviceId) {
          return [2 /*return*/, this.completeRequest({
            context: context,
            err: MISSING_DEVICE_ID_MESSAGE
          })];
        }
        payload = this.payloadBatcher({
          version: 1,
          events: context.events
        });
        if (payload.events.length === 0) {
          this.completeRequest({
            context: context
          });
          return [2 /*return*/];
        }
        worker = this.worker;
        if (worker) {
          return [2 /*return*/, this.sendViaWorker(worker, context, payload, useRetry)];
        }
        return [2 /*return*/, this.sendOnMainThread(apiKey, deviceId, context, payload, useRetry)];
      });
    });
  };
  SessionReplayTrackDestination.prototype.sendViaWorker = function (worker, context, payload, useRetry) {
    return __awaiter(this, void 0, void 0, function () {
      var id;
      var _this = this;
      return __generator(this, function (_a) {
        id = "".concat(++this.sendIdCounter);
        return [2 /*return*/, new Promise(function (resolve) {
          var _a;
          // The worker only resolves this promise when it posts back complete/payload_too_large.
          // If the worker's own fetch hangs, no message ever arrives, so this promise — and the
          // serial flush loop awaiting it — would hang forever while pendingWorkerRequests grows
          // unbounded. On timeout we resolve so flush() proceeds, but deliberately do NOT call
          // completeRequest: like the worker-crash path above, the events were never confirmed
          // delivered, so onComplete must not fire and the IDB/memory store must stay intact for
          // recovery by sendStoredEvents.
          // sendTimeoutMs <= 0 disables the wait timer entirely: we then rely solely on the
          // worker's own complete/payload_too_large message to settle. This reintroduces the
          // hang risk this timer guards against, so it is an explicit experiment opt-out.
          var timeout = _this.sendTimeoutMs > 0 ? setTimeout(function () {
            var pending = _this.pendingWorkerRequests.get(id);
            if (!pending) return;
            _this.pendingWorkerRequests.delete(id);
            // Retain the context so a *late* worker complete/payload_too_large can still settle the
            // store record (see timedOutWorkerRequests). Without this, a worker that ultimately
            // delivers after we stopped awaiting would leave the record behind → duplicate upload.
            _this.rememberTimedOutRequest(id, pending.context);
            _this.loggerProvider.warn("Session replay worker send timed out after ".concat(_this.sendTimeoutMs, "ms; leaving events for retry"));
            pending.resolve();
          }, _this.sendTimeoutMs) : undefined;
          _this.pendingWorkerRequests.set(id, {
            context: context,
            resolve: resolve,
            timeout: timeout
          });
          worker.postMessage({
            type: 'send',
            id: id,
            payload: payload,
            useRetry: useRetry,
            // Tell the worker to delegate each network attempt back to the main thread, where the
            // custom transport callback lives (functions can't cross postMessage). Absent/false
            // keeps the worker's own internal fetch — the unchanged path for existing integrations.
            useCustomTransport: !!_this.handleSendEvents,
            context: {
              apiKey: context.apiKey,
              deviceId: context.deviceId,
              sessionId: context.sessionId,
              events: context.events,
              eventType: context.type,
              flushMaxRetries: (_a = context.flushMaxRetries) !== null && _a !== void 0 ? _a : 0,
              sampleRate: context.sampleRate,
              serverZone: context.serverZone,
              trackServerUrl: _this.trackServerUrl,
              version: context.version,
              currentUrl: getCurrentUrl(),
              sdkVersion: VERSION,
              enableTransportCompression: _this.enableTransportCompression,
              sendTimeoutMs: _this.sendTimeoutMs
            }
          });
        })];
      });
    });
  };
  SessionReplayTrackDestination.prototype.rememberTimedOutRequest = function (id, context) {
    var e_6, _a;
    this.timedOutWorkerRequests.set(id, context);
    // Bound memory: a wedged worker that never replies must not let this grow without limit.
    // Map preserves insertion order, so deleting the first key evicts the oldest entry.
    if (this.timedOutWorkerRequests.size > MAX_TIMED_OUT_WORKER_REQUESTS) {
      try {
        for (var _b = __values$1(this.timedOutWorkerRequests.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var oldest = _c.value;
          this.timedOutWorkerRequests.delete(oldest);
          break;
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_6) throw e_6.error;
        }
      }
    }
  };
  // Runs the custom transport on the main thread for a single attempt the worker delegated,
  // then posts the result back into the worker's retry loop as a 'fetch-response'. We read only
  // what the worker's status handling needs: the skip header on a 2xx and the body text on a
  // 413 (for WAF detection). A thrown/rejected transport is reported as an error so the worker
  // surfaces it the same way a thrown fetch would (no retry) — matching the main-thread path.
  SessionReplayTrackDestination.prototype.handleDelegatedFetch = function (worker, msg) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
      var requestId, url, method, headers, body, keepalive, res, status_1, skipHeader, responseBody, e_7;
      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            requestId = msg.requestId, url = msg.url, method = msg.method, headers = msg.headers, body = msg.body, keepalive = msg.keepalive;
            _e.label = 1;
          case 1:
            _e.trys.push([1, 10,, 11]);
            res = void 0;
            if (!this.handleSendEvents) return [3 /*break*/, 3];
            return [4 /*yield*/, this.handleSendEvents({
              url: url,
              method: method,
              headers: headers,
              body: body,
              keepalive: keepalive
            })];
          case 2:
            res = _e.sent();
            return [3 /*break*/, 5];
          case 3:
            // Defensive only: the worker emits 'fetch-request' solely when useCustomTransport is set,
            // so this branch shouldn't be reachable. Warn so a regression that delegates without a
            // transport is diagnosable rather than silently routing to the built-in fetch.
            this.loggerProvider.warn('Delegated session replay fetch received without a custom transport configured; falling back to built-in fetch.');
            return [4 /*yield*/, fetch(url, {
              method: method,
              headers: headers,
              body: body,
              keepalive: keepalive
            })];
          case 4:
            res = _e.sent();
            _e.label = 5;
          case 5:
            status_1 = res.status;
            skipHeader = null;
            responseBody = '';
            if (status_1 >= 200 && status_1 < 300) {
              skipHeader = (_c = (_b = (_a = res.headers) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.call(_a, EVENT_SKIPPED_HEADER)) !== null && _c !== void 0 ? _c : null;
            }
            if (!(status_1 === 413)) return [3 /*break*/, 9];
            _e.label = 6;
          case 6:
            _e.trys.push([6, 8,, 9]);
            return [4 /*yield*/, res.text()];
          case 7:
            responseBody = _e.sent();
            return [3 /*break*/, 9];
          case 8:
            _e.sent();
            return [3 /*break*/, 9];
          case 9:
            this.loggerProvider.debug("Delegated session replay fetch (request ".concat(requestId, ") returned status ").concat(status_1, "."));
            worker.postMessage({
              type: 'fetch-response',
              requestId: requestId,
              status: status_1,
              skipHeader: skipHeader,
              body: responseBody
            });
            return [3 /*break*/, 11];
          case 10:
            e_7 = _e.sent();
            this.loggerProvider.debug("Delegated session replay fetch (request ".concat(requestId, ") failed:"), e_7);
            worker.postMessage({
              type: 'fetch-response',
              requestId: requestId,
              status: 0,
              skipHeader: null,
              body: String(e_7),
              error: true
            });
            return [3 /*break*/, 11];
          case 11:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.sendOnMainThread = function (apiKey, deviceId, context, payload, useRetry) {
    var _a, _b, _c, _d, _e, _f, _g;
    return __awaiter(this, void 0, void 0, function () {
      var url, version, sampleRate, urlParams, sessionReplayLibrary, payloadJson, globalScope, gzipped, _h, payloadSize, controller_1, headers, body, keepalive, options, serverUrl, sendTimeout, res, _j, skipCode, responseBody, responseBody, e_8, isAbort;
      return __generator(this, function (_l) {
        switch (_l.label) {
          case 0:
            url = getCurrentUrl();
            version = VERSION;
            sampleRate = context.sampleRate;
            urlParams = new URLSearchParams({
              device_id: deviceId,
              session_id: "".concat(context.sessionId),
              type: "".concat(context.type)
            });
            sessionReplayLibrary = "".concat((_b = (_a = context.version) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'standalone', "/").concat((_d = (_c = context.version) === null || _c === void 0 ? void 0 : _c.version) !== null && _d !== void 0 ? _d : version);
            _l.label = 1;
          case 1:
            _l.trys.push([1, 19,, 23]);
            payloadJson = JSON.stringify(payload);
            globalScope = getGlobalScope();
            if (!(this.enableTransportCompression && globalScope && 'CompressionStream' in globalScope)) return [3 /*break*/, 3];
            return [4 /*yield*/, gzipJson(payloadJson, globalScope)];
          case 2:
            _h = _l.sent();
            return [3 /*break*/, 4];
          case 3:
            _h = null;
            _l.label = 4;
          case 4:
            gzipped = _h;
            payloadSize = gzipped ? gzipped.byteLength : utf8ByteLength(payloadJson);
            controller_1 = new AbortController();
            headers = _assign$({
              'Content-Type': 'application/json',
              Accept: '*/*',
              Authorization: "Bearer ".concat(apiKey),
              'X-Client-Version': version,
              'X-Client-Library': sessionReplayLibrary,
              'X-Client-Url': url.substring(0, MAX_URL_LENGTH),
              'X-Client-Sample-Rate': "".concat(sampleRate)
            }, gzipped ? {
              'Content-Encoding': 'gzip'
            } : {});
            body = gzipped !== null && gzipped !== void 0 ? gzipped : payloadJson;
            keepalive = payloadSize <= MAX_KEEPALIVE_BYTES;
            options = {
              headers: headers,
              body: body,
              method: 'POST',
              keepalive: keepalive,
              signal: controller_1.signal
            };
            serverUrl = "".concat(getServerUrl(context.serverZone, this.trackServerUrl), "?").concat(urlParams.toString());
            // Final defensive guard: never POST a zero-event payload. Upper layers (events-manager
            // oversize filter, send()'s post-batcher check, store-layer filters) should already
            // have caught this — but SR-4284 fleet logs show ~416 empty-body 400s/24h slipping
            // through somehow, so a cheap belt-and-braces check immediately before fetch prevents
            // any future regression from re-introducing the same server rejection.
            if (payload.events.length === 0) {
              this.completeRequest({
                context: context
              });
              return [2 /*return*/];
            }
            sendTimeout = this.sendTimeoutMs > 0 ? setTimeout(function () {
              controller_1.abort();
            }, this.sendTimeoutMs) : undefined;
            res = void 0;
            _l.label = 5;
          case 5:
            _l.trys.push([5,, 10, 11]);
            if (!this.handleSendEvents) return [3 /*break*/, 7];
            return [4 /*yield*/, abortable(this.handleSendEvents({
              url: serverUrl,
              method: 'POST',
              headers: headers,
              body: body,
              keepalive: keepalive
            }), controller_1.signal)];
          case 6:
            _j = _l.sent();
            return [3 /*break*/, 9];
          case 7:
            return [4 /*yield*/, fetch(serverUrl, options)];
          case 8:
            _j = _l.sent();
            _l.label = 9;
          case 9:
            // When a custom transport is configured, hand it the fully-formed request and let it own
            // the network call (e.g. to attach a JWT and route through a proxy). Otherwise use the
            // built-in fetch. Retry/response handling below is identical for both paths. The built-in
            // fetch cancels directly on controller.signal; the custom callback can't be cancelled, so
            // we race it against the abort — a hung/never-settling transport then rejects with an
            // AbortError (retryable, like the worker delegation path) instead of blocking the serial
            // flush loop forever. The callback's own promise keeps running; we just stop awaiting it.
            res = _j;
            return [3 /*break*/, 11];
          case 10:
            // Clear on success and on error alike so a settled request never leaves an armed
            // timer that would abort a later reused controller or fire a stray callback.
            if (sendTimeout) clearTimeout(sendTimeout);
            return [7 /*endfinally*/];
          case 11:
            if (res === null) {
              this.completeRequest({
                context: context,
                err: UNEXPECTED_ERROR_MESSAGE
              });
              return [2 /*return*/];
            }
            if (res.status >= 200 && res.status < 300) {
              skipCode = (_g = (_f = (_e = res.headers) === null || _e === void 0 ? void 0 : _e.get) === null || _f === void 0 ? void 0 : _f.call(_e, EVENT_SKIPPED_HEADER)) !== null && _g !== void 0 ? _g : null;
              this.applyServerDirective(context.sessionId, skipCode);
            }
            if (!!useRetry) return [3 /*break*/, 12];
            responseBody = '';
            try {
              responseBody = JSON.stringify(res.body, null, 2);
            } catch (_m) {
              // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
            }
            this.completeRequest({
              context: context,
              success: "".concat(res.status, ": ").concat(responseBody)
            });
            return [3 /*break*/, 18];
          case 12:
            responseBody = '';
            if (!(res.status === 413)) return [3 /*break*/, 16];
            _l.label = 13;
          case 13:
            _l.trys.push([13, 15,, 16]);
            return [4 /*yield*/, res.text()];
          case 14:
            responseBody = _l.sent();
            return [3 /*break*/, 16];
          case 15:
            _l.sent();
            return [3 /*break*/, 16];
          case 16:
            return [4 /*yield*/, this.handleReponse(res.status, context, responseBody)];
          case 17:
            _l.sent();
            _l.label = 18;
          case 18:
            return [3 /*break*/, 23];
          case 19:
            e_8 = _l.sent();
            isAbort = !!e_8 && typeof e_8 === 'object' && e_8.name === 'AbortError';
            if (!(isAbort && useRetry)) return [3 /*break*/, 21];
            return [4 /*yield*/, this.handleOtherResponse(context)];
          case 20:
            _l.sent();
            return [3 /*break*/, 22];
          case 21:
            this.completeRequest({
              context: context,
              err: e_8
            });
            _l.label = 22;
          case 22:
            return [3 /*break*/, 23];
          case 23:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.handleReponse = function (status, context, responseBody) {
    if (responseBody === void 0) {
      responseBody = '';
    }
    return __awaiter(this, void 0, void 0, function () {
      var parsedStatus, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            parsedStatus = new BaseTransport().buildStatus(status);
            _a = parsedStatus;
            switch (_a) {
              case Status.Success:
                return [3 /*break*/, 1];
              case Status.Failed:
                return [3 /*break*/, 2];
              case Status.Timeout:
                return [3 /*break*/, 2];
              case Status.RateLimit:
                return [3 /*break*/, 2];
              case Status.PayloadTooLarge:
                return [3 /*break*/, 4];
            }
            return [3 /*break*/, 5];
          case 1:
            this.handleSuccessResponse(context);
            return [3 /*break*/, 8];
          case 2:
            // 429: retry with existing backoff rather than silently dropping
            return [4 /*yield*/, this.handleOtherResponse(context)];
          case 3:
            _b.sent();
            return [3 /*break*/, 8];
          case 4:
            this.handlePayloadTooLargeResponse(context, WAF_PAYLOAD_TOO_LARGE_PATTERN.test(responseBody));
            return [3 /*break*/, 8];
          case 5:
            if (!(status === 499)) return [3 /*break*/, 7];
            return [4 /*yield*/, this.handleOtherResponse(context)];
          case 6:
            _b.sent();
            return [3 /*break*/, 8];
          case 7:
            this.completeRequest({
              context: context,
              err: UNEXPECTED_NETWORK_ERROR_MESSAGE
            });
            _b.label = 8;
          case 8:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.handlePayloadTooLargeResponse = function (context, isWaf) {
    var source = isWaf ? 'WAF (compressed payload too large)' : 'server (event too large)';
    var totalSizeKB = Math.round(context.events.reduce(function (sum, e) {
      return sum + e.length;
    }, 0) / KB_SIZE);
    if (!isWaf) {
      this.completeRequest({
        context: context,
        err: "Session replay event batch dropped: ".concat(source, " rejected payload (").concat(context.events.length, " events, ").concat(totalSizeKB, " KB) \u2014 not retrying non-WAF 413")
      });
      return;
    }
    if (context.events.length === 1) {
      this.completeRequest({
        context: context,
        err: "Session replay event dropped: single event (".concat(totalSizeKB, " KB, 1 event) rejected by ").concat(source, " \u2014 cannot split further")
      });
      return;
    }
    this.loggerProvider.warn("Session replay event batch rejected by ".concat(source, " (").concat(context.events.length, " events, ").concat(totalSizeKB, " KB total) \u2014 splitting and retrying"));
    // Clean up the original IDB record, then re-enqueue both halves as new in-memory batches.
    // For a merged-on-throttle context (mergeQueueAfterThrottle), this onComplete is the
    // fanned-out callback covering N source IDB records — they'll all be cleaned up here.
    // Halves get noop onCompletes, so a page-close between this cleanup and a half delivery
    // means up to N source sequences are lost. The merge soft cap (1.4MB chars) is well under
    // the 10MB compressed 413 ceiling, so a 413 on a merged context is exceedingly rare in
    // practice; the alternative — deferring source cleanup until both halves complete — would
    // significantly complicate the retry path for marginal benefit.
    void context.onComplete();
    var noop = function noop() {
      return Promise.resolve();
    };
    var mid = Math.floor(context.events.length / 2);
    this.sendEventsList(_assign$(_assign$({}, context), {
      events: context.events.slice(0, mid),
      onComplete: noop
    }));
    this.sendEventsList(_assign$(_assign$({}, context), {
      events: context.events.slice(mid),
      onComplete: noop
    }));
  };
  SessionReplayTrackDestination.prototype.handleSuccessResponse = function (context) {
    var sizeOfEventsList = Math.round(utf8ByteLengthOf(context.events) / KB_SIZE);
    this.completeRequest({
      context: context,
      success: "Session replay event batch tracked successfully for session id ".concat(context.sessionId, ", size of events: ").concat(sizeOfEventsList, " KB")
    });
  };
  SessionReplayTrackDestination.prototype.handleOtherResponse = function (context) {
    return __awaiter(this, void 0, void 0, function () {
      var delay;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            delay = Math.random() * context.attempts * this.retryTimeout;
            context.attempts++;
            if (context.attempts > (context.flushMaxRetries || 0)) {
              this.completeRequest({
                context: context,
                err: MAX_RETRIES_EXCEEDED_MESSAGE
              });
              return [2 /*return*/];
            }
            return [4 /*yield*/, new Promise(function (resolve) {
              return setTimeout(resolve, delay);
            })];
          case 1:
            _a.sent();
            return [4 /*yield*/, this.send(context, true)];
          case 2:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.completeRequest = function (_a) {
    var context = _a.context,
      err = _a.err,
      success = _a.success;
    void context.onComplete();
    if (err) {
      this.loggerProvider.warn(err);
    } else if (success) {
      this.loggerProvider.log(success);
    }
  };
  /**
   * Applies the server's back-pressure signal carried on a 200 response.
   *
   * - `EVENT_SKIP_CODE_THROTTLED` (server-side rate limit): pause the flush schedule
   *   for `THROTTLED_FLUSH_PAUSE_MS` so we keep batching events instead of retry-storming.
   * - `EVENT_SKIP_CODE_CAPTURE_DISABLED` / `EVENT_SKIP_CODE_INVALID_RANGE`: hard kill
   *   switch for this session — drop the queued contexts and stop accepting new ones.
   *   New sessions are unaffected.
   * - `null` (clean 200, no header): clear any throttle pause; subsequent flushes resume
   *   on the normal cadence.
   */
  SessionReplayTrackDestination.prototype.applyServerDirective = function (sessionId, skipCode) {
    if (skipCode === null) {
      this.flushPauseUntilMs = 0;
      this.mergeLogFiredThisPause = false;
      return;
    }
    if (skipCode === EVENT_SKIP_CODE_THROTTLED) {
      var wasInPause = this.flushPauseUntilMs > Date.now();
      this.flushPauseUntilMs = Date.now() + THROTTLED_FLUSH_PAUSE_MS;
      // Log only on pause-state transitions — a throttled server may reply to many
      // batches per minute, and one log per batch would flood the console.
      if (!wasInPause) {
        this.loggerProvider.log("Session replay throttled by server; pausing flush schedule for ".concat(THROTTLED_FLUSH_PAUSE_MS / 1000, "s"));
      }
      return;
    }
    if (skipCode === EVENT_SKIP_CODE_CAPTURE_DISABLED || skipCode === EVENT_SKIP_CODE_INVALID_RANGE) {
      this.killSession(sessionId, skipCode);
    }
    // Unknown skip codes are ignored — the server may add new ones, and our default
    // behavior (treat as a normal 200) preserves throughput rather than penalizing the
    // session for a code we don't recognize.
  };
  SessionReplayTrackDestination.prototype.killSession = function (sessionId, skipCode) {
    var e_9, _a, e_10, _b;
    if (this.killedSessions.has(sessionId)) return;
    this.killedSessions.add(sessionId);
    // Set preserves insertion order, so deleting the first key evicts the oldest entry.
    if (this.killedSessions.size > MAX_KILLED_SESSIONS) {
      try {
        for (var _c = __values$1(this.killedSessions), _d = _c.next(); !_d.done; _d = _c.next()) {
          var oldest = _d.value;
          this.killedSessions.delete(oldest);
          break;
        }
      } catch (e_9_1) {
        e_9 = {
          error: e_9_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_9) throw e_9.error;
        }
      }
    }
    this.loggerProvider.log("Session replay capture stopped for session ".concat(sessionId, " by server directive ").concat(skipCode, "; remaining events will be dropped"));
    // Drain any queued contexts for this session so their IDB records get cleaned up
    // via onComplete, instead of sitting in the queue waiting for a flush we'll never make.
    var remaining = [];
    try {
      for (var _e = __values$1(this.queue), _f = _e.next(); !_f.done; _f = _e.next()) {
        var queued = _f.value;
        if (queued.sessionId === sessionId) {
          this.completeRequest({
            context: queued,
            err: SESSION_KILLED_MESSAGE
          });
        } else {
          remaining.push(queued);
        }
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
      } finally {
        if (e_10) throw e_10.error;
      }
    }
    this.queue = remaining;
  };
  return SessionReplayTrackDestination;
}();
const instanceOfAny = (object, constructors) => constructors.some(c => object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey]);
}
const transactionDoneMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
  const promise = new Promise((resolve, reject) => {
    const unlisten = () => {
      request.removeEventListener('success', success);
      request.removeEventListener('error', error);
    };
    const success = () => {
      resolve(wrap(request.result));
      unlisten();
    };
    const error = () => {
      reject(request.error);
      unlisten();
    };
    request.addEventListener('success', success);
    request.addEventListener('error', error);
  });
  // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
  // is because we create many promises from a single IDBRequest.
  reverseTransformCache.set(promise, request);
  return promise;
}
function cacheDonePromiseForTransaction(tx) {
  // Early bail if we've already created a done promise for this transaction.
  if (transactionDoneMap.has(tx)) return;
  const done = new Promise((resolve, reject) => {
    const unlisten = () => {
      tx.removeEventListener('complete', complete);
      tx.removeEventListener('error', error);
      tx.removeEventListener('abort', error);
    };
    const complete = () => {
      resolve();
      unlisten();
    };
    const error = () => {
      reject(tx.error || new DOMException('AbortError', 'AbortError'));
      unlisten();
    };
    tx.addEventListener('complete', complete);
    tx.addEventListener('error', error);
    tx.addEventListener('abort', error);
  });
  // Cache it for later retrieval.
  transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
  get(target, prop, receiver) {
    if (target instanceof IDBTransaction) {
      // Special handling for transaction.done.
      if (prop === 'done') return transactionDoneMap.get(target);
      // Make tx.store return the only store in the transaction, or undefined if there are many.
      if (prop === 'store') {
        return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    }
    // Else transform whatever we get back.
    return wrap(target[prop]);
  },
  set(target, prop, value) {
    target[prop] = value;
    return true;
  },
  has(target, prop) {
    if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) {
      return true;
    }
    return prop in target;
  }
};
function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
  // Due to expected object equality (which is enforced by the caching in `wrap`), we
  // only create one new func per func.
  // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
  // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
  // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
  // with real promises, so each advance methods returns a new promise for the cursor object, or
  // undefined if the end of the cursor has been reached.
  if (getCursorAdvanceMethods().includes(func)) {
    return function (...args) {
      // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
      // the original object.
      func.apply(unwrap(this), args);
      return wrap(this.request);
    };
  }
  return function (...args) {
    // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
    // the original object.
    return wrap(func.apply(unwrap(this), args));
  };
}
function transformCachableValue(value) {
  if (typeof value === 'function') return wrapFunction(value);
  // This doesn't return, it just creates a 'done' promise for the transaction,
  // which is later returned for transaction.done (see idbObjectHandler).
  if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
  // Return the same value back if we're not going to transform it.
  return value;
}
function wrap(value) {
  // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
  // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
  if (value instanceof IDBRequest) return promisifyRequest(value);
  // If we've already transformed this value before, reuse the transformed value.
  // This is faster, but it also provides object equality.
  if (transformCache.has(value)) return transformCache.get(value);
  const newValue = transformCachableValue(value);
  // Not all types are transformed.
  // These may be primitive types, so they can't be WeakMap keys.
  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }
  return newValue;
}
const unwrap = value => reverseTransformCache.get(value);

/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, {
  blocked,
  upgrade,
  blocking,
  terminated
} = {}) {
  const request = indexedDB.open(name, version);
  const openPromise = wrap(request);
  if (upgrade) {
    request.addEventListener('upgradeneeded', event => {
      upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
    });
  }
  if (blocked) {
    request.addEventListener('blocked', event => blocked(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    event.oldVersion, event.newVersion, event));
  }
  openPromise.then(db => {
    if (terminated) db.addEventListener('close', () => terminated());
    if (blocking) {
      db.addEventListener('versionchange', event => blocking(event.oldVersion, event.newVersion, event));
    }
  }).catch(() => {});
  return openPromise;
}
const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
  if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) {
    return;
  }
  if (cachedMethods.get(prop)) return cachedMethods.get(prop);
  const targetFuncName = prop.replace(/FromIndex$/, '');
  const useIndex = prop !== targetFuncName;
  const isWrite = writeMethods.includes(targetFuncName);
  if (
  // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
  !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) {
    return;
  }
  const method = async function method(storeName, ...args) {
    // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
    const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
    let target = tx.store;
    if (useIndex) target = target.index(args.shift());
    // Must reject if op rejects.
    // If it's a write operation, must reject if tx.done rejects.
    // Must reject with op rejection first.
    // Must resolve with op value.
    // Must handle both promises (no unhandled rejections)
    return (await Promise.all([target[targetFuncName](...args), isWrite && tx.done]))[0];
  };
  cachedMethods.set(prop, method);
  return method;
}
replaceTraps(oldTraps => Object.assign({}, oldTraps, {
  get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
  has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop)
}));
const advanceMethodProps = ['continue', 'continuePrimaryKey', 'advance'];
const methodMap = {};
const advanceResults = new WeakMap();
const ittrProxiedCursorToOriginalProxy = new WeakMap();
const cursorIteratorTraps = {
  get(target, prop) {
    if (!advanceMethodProps.includes(prop)) return target[prop];
    let cachedFunc = methodMap[prop];
    if (!cachedFunc) {
      cachedFunc = methodMap[prop] = function (...args) {
        advanceResults.set(this, ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
      };
    }
    return cachedFunc;
  }
};
async function* iterate(...args) {
  // tslint:disable-next-line:no-this-assignment
  let cursor = this;
  if (!(cursor instanceof IDBCursor)) {
    cursor = await cursor.openCursor(...args);
  }
  if (!cursor) return;
  cursor = cursor;
  const proxiedCursor = new Proxy(cursor, cursorIteratorTraps);
  ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
  // Map this double-proxy back to the original, so other cursor methods work.
  reverseTransformCache.set(proxiedCursor, unwrap(cursor));
  while (cursor) {
    yield proxiedCursor;
    // If one of the advancing methods was not called, call continue().
    cursor = await (advanceResults.get(proxiedCursor) || cursor.continue());
    advanceResults.delete(proxiedCursor);
  }
}
function isIteratorProp(target, prop) {
  return prop === Symbol.asyncIterator && instanceOfAny(target, [IDBIndex, IDBObjectStore, IDBCursor]) || prop === 'iterate' && instanceOfAny(target, [IDBIndex, IDBObjectStore]);
}
replaceTraps(oldTraps => Object.assign({}, oldTraps, {
  get(target, prop, receiver) {
    if (isIteratorProp(target, prop)) return iterate;
    return oldTraps.get(target, prop, receiver);
  },
  has(target, prop) {
    return isIteratorProp(target, prop) || oldTraps.has(target, prop);
  }
}));
var BaseEventsStore = /** @class */function () {
  function BaseEventsStore(args) {
    var _this = this;
    var _a, _b, _c;
    this.minInterval = MIN_INTERVAL;
    this.maxInterval = MAX_INTERVAL;
    this.maxPersistedEventsSize = DEFAULT_MAX_PERSISTED_EVENTS_SIZE_BYTES;
    this._timeAtLastSplit = Date.now(); // Initialize this so we have a point of comparison when events are recorded
    // Running UTF-8 sizes so shouldSplitEventsList only measures newly appended events.
    // The IDB store loads a fresh array on every add, so it also keeps a per-session entry.
    this.eventsContentBytes = new WeakMap();
    this.sequenceContentBytes = new Map();
    /**
     * Determines whether to send the events list to the backend and start a new
     * empty events list, based on the size of the list as well as the last time sent
     * @param nextEventString
     * @returns boolean
     */
    this.shouldSplitEventsList = function (events, nextEventString) {
      var sizeOfEventsList = _this.getEventsArraySize(events);
      // 1–3 UTF-8 bytes per code unit: only scan the event when `length` alone cannot decide.
      var room = _this.maxPersistedEventsSize - sizeOfEventsList;
      var exceedsCap = nextEventString.length >= room;
      if (!exceedsCap && nextEventString.length * 3 >= room) {
        exceedsCap = utf8ByteLength(nextEventString) >= room;
      }
      if (exceedsCap) {
        return true;
      }
      if (Date.now() - _this.timeAtLastSplit > _this.interval && events.length) {
        _this.interval = Math.min(_this.maxInterval, _this.interval + _this.minInterval);
        _this._timeAtLastSplit = Date.now();
        return true;
      }
      return false;
    };
    this.loggerProvider = args.loggerProvider;
    this.minInterval = (_a = args.minInterval) !== null && _a !== void 0 ? _a : this.minInterval;
    this.maxInterval = (_b = args.maxInterval) !== null && _b !== void 0 ? _b : this.maxInterval;
    this.maxPersistedEventsSize = (_c = args.maxPersistedEventsSize) !== null && _c !== void 0 ? _c : this.maxPersistedEventsSize;
    this.interval = this.minInterval;
  }
  Object.defineProperty(BaseEventsStore.prototype, "timeAtLastSplit", {
    get: function () {
      return this._timeAtLastSplit;
    },
    enumerable: false,
    configurable: true
  });
  // `prev` is only reused when `events` still starts with the list it measured; the tail
  // check catches a same-length rewrite of the last element.
  BaseEventsStore.prototype.isPrefixOf = function (prev, events) {
    if (events.length < prev.length) return false;
    return prev.length === 0 || events[prev.length - 1] === prev.tail;
  };
  BaseEventsStore.prototype.measureContentBytes = function (prev, events) {
    if (prev && prev.length === events.length && this.isPrefixOf(prev, events)) return prev;
    var contentBytes = 0;
    var start = 0;
    if (prev && this.isPrefixOf(prev, events)) {
      contentBytes = prev.contentBytes;
      start = prev.length;
    }
    for (var i = start; i < events.length; i++) {
      contentBytes += utf8ByteLength(events[i]);
    }
    return {
      length: events.length,
      contentBytes: contentBytes,
      tail: events.length > 0 ? events[events.length - 1] : undefined
    };
  };
  BaseEventsStore.prototype.getEventsContentBytes = function (events) {
    var entry = this.measureContentBytes(this.eventsContentBytes.get(events), events);
    this.eventsContentBytes.set(events, entry);
    return entry.contentBytes;
  };
  /**
   * Calculates the total UTF-8 byte size of events array
   * Accounts for JSON serialization overhead when sent to backend
   */
  BaseEventsStore.prototype.getEventsArraySize = function (events) {
    var totalSize = this.getEventsContentBytes(events);
    // Approximate overhead from the array portion of the JSON payload:
    // - Array brackets: [] = 2 bytes
    // - Commas between events: events.length - 1 bytes
    // - Double quotes wrapping each event string: events.length * 2 bytes
    // Note: does not include the outer { version, events } wrapper (~22 bytes) or
    // per-event JSON-escaping of " and \ characters; the 2 MB MAX_EVENT_LIST_SIZE cap
    // stays well under the server's 10 MB decompressed split threshold even with those.
    var overhead = 2 + Math.max(0, events.length - 1) + events.length * 2;
    return totalSize + overhead;
  };
  BaseEventsStore.prototype.recallSequenceContentBytes = function (sessionId, events) {
    var cached = this.sequenceContentBytes.get(sessionId);
    if (!cached || cached.length !== events.length || !this.isPrefixOf(cached, events)) return;
    this.eventsContentBytes.set(events, cached);
  };
  BaseEventsStore.prototype.rememberSequenceContentBytes = function (sessionId, events) {
    var entry = this.measureContentBytes(this.sequenceContentBytes.get(sessionId), events);
    this.sequenceContentBytes.set(sessionId, entry);
    this.eventsContentBytes.set(events, entry);
  };
  BaseEventsStore.prototype.forgetSequenceContentBytes = function (sessionId) {
    this.sequenceContentBytes.delete(sessionId);
  };
  return BaseEventsStore;
}();

/**
 * IndexedDB can surface transient AbortErrors (internal cancellations,
 * cleanup) that are not actionable by customers. We downgrade these from
 * warn → debug to avoid triggering Sentry alerts in customer projects.
 * Duck-types on name rather than instanceof DOMException because the idb
 * wrapper library and test environments may surface plain Error objects.
 */
var isAbortError = function isAbortError(e) {
  return typeof e === 'object' && e !== null && e.name === 'AbortError';
};
/**
 * Logs an IDB error at the appropriate level: debug for transient
 * AbortErrors (to avoid customer Sentry noise), warn for everything else.
 */
var logIdbError = function logIdbError(logger, message, error) {
  if (isAbortError(error)) {
    logger.debug(message);
  } else {
    logger.warn(message);
  }
};

// crypto.randomUUID() requires a secure context (https). Fall back to a
// Math.random-based UUID for http origins or older browsers — tab IDs don't
// need to be cryptographically secure, just unique within a session.
function generateUUID() {
  try {
    return crypto.randomUUID();
  } catch (_a) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
  }
}
var currentSequenceKey = 'sessionCurrentSequence';
var sequencesToSendKey = 'sequencesToSend';
// Timeout for openDB at init.  IDB openDB can hang forever when another tab
// holds an open connection during a version upgrade, or when the DB is in a
// "closing" state (documented Chrome behaviour).  When that happens we want
// SessionReplayEventsIDBStore.new() to bail out so the caller can fall back
// to the in-memory store.
var OPEN_DB_TIMEOUT_MS = 2000;
// Timeout for per-operation tx.done settlement.  Mid-recording a readwrite
// transaction can stall (storage pressure in some browsers stalls instead of
// throwing); without a timeout, recordFailure() is never called and the
// memory fallback never triggers.  The transaction may still settle later;
// the timedOut flag prevents double-counting alongside errorLogged.
var TX_DONE_TIMEOUT_MS = 5000;
/**
 * Race a promise against a timeout.  Resolves/rejects with the original
 * promise's value when it settles first; rejects with a timeout error if
 * `ms` elapses first.  Either way the timer is cleared so we don't leak
 * pending setTimeouts.
 */
function withTimeout(promise, ms, message) {
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(function () {
      return reject(new Error("".concat(message, " after ").concat(ms, "ms")));
    }, ms);
    promise.then(function (v) {
      clearTimeout(timer);
      resolve(v);
    }, function (e) {
      clearTimeout(timer);
      reject(e);
    });
  });
}
/**
 * Arms a watchdog that fires `onTimeout` only if `tx.done` hasn't settled
 * within `ms`.  A "soft cancel" returned to the caller suppresses the timeout
 * if the synchronous operation body completes without exception — important
 * because in test environments fake timers can fire ahead of tx.done's commit
 * microtask.  Production behaviour is preserved: a genuinely stalled
 * transaction (no commit, no error, individual op promises never resolved)
 * cannot reach the soft-cancel call and the timeout fires as designed.
 *
 * Soft-cancel is only invoked once the awaits inside the operation's outer
 * try block have all returned — i.e. the IDB driver acknowledged each
 * individual put/get.  If the driver accepts a put but the underlying
 * transaction silently fails to commit (the production stall scenario),
 * tx.done still hasn't settled, and recordFailure must NOT have been
 * suppressed.  The fix for that scenario in production is the tx.done.catch
 * handler attached separately by callers, which catches the eventual abort.
 *
 * The soft-cancel pattern only suppresses the timeout for the "all puts
 * resolved successfully" case — a case where tx.done is overwhelmingly
 * likely to settle imminently in production.  If it doesn't, callers can
 * still detect the failure on the NEXT operation (which will fail to open
 * a transaction or hit the same pressure), because all three methods use
 * readwrite transactions on the same two stores, which IDB serializes:
 * if T1's tx.done never settles, T2 is blocked waiting for T1 to commit or
 * abort — T2's put/get requests never resolve, T2 never reaches its
 * soft-cancel, and T2's watchdog fires, calling recordFailure().
 */
function armTxDoneTimeout(txDone, ms, onTimeout) {
  var timer = setTimeout(onTimeout, ms);
  // Belt-and-braces: clear the timer when tx.done settles, even though the
  // primary cancel path is the caller's success-path cancel().  This covers
  // the case where tx.done settles with no caller cancellation (shouldn't
  // happen in current code paths, but cheap insurance).
  txDone.then(function () {
    return clearTimeout(timer);
  }, function () {
    return clearTimeout(timer);
  });
  return function () {
    return clearTimeout(timer);
  };
}
var defineObjectStores = function defineObjectStores(db) {
  var sequencesStore;
  var currentSequenceStore;
  if (!db.objectStoreNames.contains(currentSequenceKey)) {
    currentSequenceStore = db.createObjectStore(currentSequenceKey, {
      keyPath: 'sessionId'
    });
  }
  if (!db.objectStoreNames.contains(sequencesToSendKey)) {
    sequencesStore = db.createObjectStore(sequencesToSendKey, {
      keyPath: 'sequenceId',
      autoIncrement: true
    });
    sequencesStore.createIndex('sessionId', 'sessionId');
  }
  return {
    sequencesStore: sequencesStore,
    currentSequenceStore: currentSequenceStore
  };
};
var createStore = function createStore(dbName) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, withTimeout(openDB(dbName, 1, {
            upgrade: defineObjectStores
          }), OPEN_DB_TIMEOUT_MS, 'IDB openDB timed out')];
        case 1:
          // Wrap openDB with a timeout so a hung connection (foreign tab holding an
          // open handle during version upgrade, or "closing" DB) doesn't block the
          // SDK from initialising.  On timeout this rejects, which propagates up to
          // SessionReplayEventsIDBStore.new()'s catch block, returning undefined and
          // triggering the memory fallback.
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var SessionReplayEventsIDBStore = /** @class */function (_super) {
  __extends(SessionReplayEventsIDBStore, _super);
  function SessionReplayEventsIDBStore(args) {
    var _this = this;
    var _a;
    _this = _super.call(this, args) || this;
    _this.consecutiveFailures = 0;
    _this.hasTriggeredFallback = false;
    _this.emptyFilteredCount = 0;
    _this.getSequencesToSend = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var errorLogged, timedOut, sequences, tx, cancelTimeout, cursor, _a, sessionId, events, e_1;
        var _this = this;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              errorLogged = false;
              timedOut = false;
              _b.label = 1;
            case 1:
              _b.trys.push([1, 9,, 10]);
              sequences = [];
              tx = this.db.transaction('sequencesToSend', 'readwrite');
              // Attach a catch handler immediately so tx.done rejections (e.g. AbortError after
              // cursor traversal completes) are always handled without blocking the return path.
              // The errorLogged / timedOut flags prevent double-logging and double-recording
              // when the outer catch (or the timeout race) already fired for the same abort.
              tx.done.catch(function (e) {
                if (!errorLogged && !timedOut) {
                  logIdbError(_this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e), e);
                  _this.recordFailure();
                }
              });
              cancelTimeout = armTxDoneTimeout(tx.done, TX_DONE_TIMEOUT_MS, function () {
                if (!errorLogged && !timedOut) {
                  timedOut = true;
                  logIdbError(_this.loggerProvider, "".concat(STORAGE_FAILURE, ": transaction timed out"));
                  _this.recordFailure();
                }
              });
              return [4 /*yield*/, tx.store.openCursor()];
            case 2:
              cursor = _b.sent();
              _b.label = 3;
            case 3:
              if (!cursor) return [3 /*break*/, 8];
              _a = cursor.value, sessionId = _a.sessionId, events = _a.events;
              if (!(events.length === 0)) return [3 /*break*/, 5];
              this.maybeLogEmptyFiltered('getSequencesToSend');
              return [4 /*yield*/, cursor.delete()];
            case 4:
              _b.sent();
              return [3 /*break*/, 6];
            case 5:
              // Return all completed sequences regardless of tabId.  Filtering by tab
              // would cause event loss on page reload: a new store instance gets a
              // fresh in-memory UUID and would never see sequences written by the
              // previous instance.  Completed sequences are safe to flush by any
              // tab/instance; the server deduplicates, and cleanUpSessionEventsStore
              // on an already-deleted key is a no-op.
              sequences.push({
                events: events,
                sequenceId: cursor.key,
                sessionId: sessionId
              });
              _b.label = 6;
            case 6:
              return [4 /*yield*/, cursor.continue()];
            case 7:
              cursor = _b.sent();
              return [3 /*break*/, 3];
            case 8:
              this.recordSuccess();
              cancelTimeout();
              return [2 /*return*/, sequences];
            case 9:
              e_1 = _b.sent();
              if (!timedOut) {
                errorLogged = true;
                logIdbError(this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e_1), e_1);
                this.recordFailure();
              }
              return [3 /*break*/, 10];
            case 10:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.storeCurrentSequence = function (sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var errorLogged, timedOut, tx, cancelTimeout, currentSequenceData, sequenceId, rest, e_2;
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              errorLogged = false;
              timedOut = false;
              _a.label = 1;
            case 1:
              _a.trys.push([1, 5,, 6]);
              tx = this.db.transaction([currentSequenceKey, sequencesToSendKey], 'readwrite');
              tx.done.catch(function (e) {
                if (!errorLogged && !timedOut) {
                  logIdbError(_this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e), e);
                  _this.recordFailure();
                }
              });
              cancelTimeout = armTxDoneTimeout(tx.done, TX_DONE_TIMEOUT_MS, function () {
                if (!errorLogged && !timedOut) {
                  timedOut = true;
                  logIdbError(_this.loggerProvider, "".concat(STORAGE_FAILURE, ": transaction timed out"));
                  _this.recordFailure();
                }
              });
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).get(sessionId)];
            case 2:
              currentSequenceData = _a.sent();
              // Skip promotion if the slot is empty or owned by another tab — let the owning
              // tab promote its own events on its next addEventToCurrentSequence/storeCurrentSequence
              // call (via Bug 1's foreign-tab promotion path).
              // Don't call recordSuccess() here: no write was performed, so this is not
              // evidence the storage layer is healthy — leave the failure counter unchanged.
              if (!currentSequenceData) {
                cancelTimeout();
                return [2 /*return*/, undefined];
              }
              // Skip empty sequences — no point writing a zero-event row to sequencesToSend
              // (would later POST as an empty body and 400 on the server).
              if (currentSequenceData.events.length === 0) {
                this.maybeLogEmptyFiltered('storeCurrentSequence');
                cancelTimeout();
                return [2 /*return*/, undefined];
              }
              return [4 /*yield*/, tx.objectStore(sequencesToSendKey).put({
                sessionId: sessionId,
                events: currentSequenceData.events,
                tabId: this.tabId
              })];
            case 3:
              sequenceId = _a.sent();
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).put({
                sessionId: sessionId,
                events: [],
                tabId: this.tabId
              })];
            case 4:
              _a.sent();
              this.rememberSequenceContentBytes(sessionId, []);
              this.recordSuccess();
              cancelTimeout();
              currentSequenceData.tabId, rest = __rest(currentSequenceData, ["tabId"]);
              return [2 /*return*/, _assign$(_assign$({}, rest), {
                sessionId: sessionId,
                sequenceId: sequenceId
              })];
            case 5:
              e_2 = _a.sent();
              this.forgetSequenceContentBytes(sessionId);
              if (!timedOut) {
                errorLogged = true;
                logIdbError(this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e_2), e_2);
                this.recordFailure();
              }
              return [3 /*break*/, 6];
            case 6:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.addEventToCurrentSequence = function (sessionId, event) {
      return __awaiter(_this, void 0, void 0, function () {
        var errorLogged, timedOut, tx, cancelTimeout, sequenceEvents, nextEvents_1, ownedSequence, nextEvents_2, nextEvents_3, eventsToSend, nextEvents_4, nextEvents, sequenceId, e_3;
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              errorLogged = false;
              timedOut = false;
              _a.label = 1;
            case 1:
              _a.trys.push([1, 15,, 16]);
              tx = this.db.transaction([currentSequenceKey, sequencesToSendKey], 'readwrite');
              // Attach a catch handler immediately so tx.done rejections (e.g. AbortError after
              // put succeeds but before auto-commit) are always handled without blocking.
              // The errorLogged / timedOut flags prevent double-logging when the outer catch
              // (or the timeout) already fired for the same transaction.
              tx.done.catch(function (e) {
                if (!errorLogged && !timedOut) {
                  logIdbError(_this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e), e);
                  _this.recordFailure();
                }
              });
              cancelTimeout = armTxDoneTimeout(tx.done, TX_DONE_TIMEOUT_MS, function () {
                if (!errorLogged && !timedOut) {
                  timedOut = true;
                  logIdbError(_this.loggerProvider, "".concat(STORAGE_FAILURE, ": transaction timed out"));
                  _this.recordFailure();
                }
              });
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).get(sessionId)];
            case 2:
              sequenceEvents = _a.sent();
              return [3 /*break*/, 6];
            case 3:
              _a.sent();
              _a.label = 4;
            case 4:
              nextEvents_1 = [event];
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).put({
                sessionId: sessionId,
                events: nextEvents_1,
                tabId: this.tabId
              })];
            case 5:
              _a.sent();
              this.rememberSequenceContentBytes(sessionId, nextEvents_1);
              this.recordSuccess();
              cancelTimeout();
              return [2 /*return*/, undefined];
            case 6:
              ownedSequence = sequenceEvents;
              if (!!ownedSequence) return [3 /*break*/, 8];
              nextEvents_2 = [event];
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).put({
                sessionId: sessionId,
                events: nextEvents_2,
                tabId: this.tabId
              })];
            case 7:
              _a.sent();
              this.rememberSequenceContentBytes(sessionId, nextEvents_2);
              this.recordSuccess();
              cancelTimeout();
              return [2 /*return*/, undefined];
            case 8:
              // Freshly loaded array: seed it with the session's running size so the split check is O(1).
              this.recallSequenceContentBytes(sessionId, ownedSequence.events);
              if (!!this.shouldSplitEventsList(ownedSequence.events, event)) return [3 /*break*/, 10];
              nextEvents_3 = ownedSequence.events.concat(event);
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).put({
                sessionId: sessionId,
                events: nextEvents_3,
                tabId: this.tabId
              })];
            case 9:
              _a.sent();
              this.rememberSequenceContentBytes(sessionId, nextEvents_3);
              this.recordSuccess();
              cancelTimeout();
              return [2 /*return*/, undefined];
            case 10:
              eventsToSend = ownedSequence.events;
              if (!(eventsToSend.length === 0)) return [3 /*break*/, 12];
              this.maybeLogEmptyFiltered('addEventToCurrentSequence');
              nextEvents_4 = [event];
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).put({
                sessionId: sessionId,
                events: nextEvents_4,
                tabId: this.tabId
              })];
            case 11:
              _a.sent();
              this.rememberSequenceContentBytes(sessionId, nextEvents_4);
              this.recordSuccess();
              cancelTimeout();
              return [2 /*return*/, undefined];
            case 12:
              nextEvents = [event];
              return [4 /*yield*/, tx.objectStore(currentSequenceKey).put({
                sessionId: sessionId,
                events: nextEvents,
                tabId: this.tabId
              })];
            case 13:
              _a.sent();
              this.rememberSequenceContentBytes(sessionId, nextEvents);
              return [4 /*yield*/, tx.objectStore(sequencesToSendKey).put({
                sessionId: sessionId,
                events: eventsToSend,
                tabId: this.tabId
              })];
            case 14:
              sequenceId = _a.sent();
              this.recordSuccess();
              cancelTimeout();
              return [2 /*return*/, {
                events: eventsToSend,
                sessionId: sessionId,
                sequenceId: sequenceId
              }];
            case 15:
              e_3 = _a.sent();
              this.forgetSequenceContentBytes(sessionId);
              if (!timedOut) {
                errorLogged = true;
                logIdbError(this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e_3), e_3);
                this.recordFailure();
              }
              return [3 /*break*/, 16];
            case 16:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.storeSendingEvents = function (sessionId, events) {
      return __awaiter(_this, void 0, void 0, function () {
        var sequenceId, e_4;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);
              return [4 /*yield*/, this.db.put(sequencesToSendKey, {
                sessionId: sessionId,
                events: events,
                tabId: this.tabId
              })];
            case 1:
              sequenceId = _a.sent();
              this.recordSuccess();
              return [2 /*return*/, sequenceId];
            case 2:
              e_4 = _a.sent();
              logIdbError(this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e_4), e_4);
              this.recordFailure();
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.cleanUpSessionEventsStore = function (_sessionId, sequenceId) {
      return __awaiter(_this, void 0, void 0, function () {
        var e_5;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!sequenceId) {
                return [2 /*return*/];
              }
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4 /*yield*/, this.db.delete(sequencesToSendKey, sequenceId)];
            case 2:
              _a.sent();
              this.recordSuccess();
              return [3 /*break*/, 4];
            case 3:
              e_5 = _a.sent();
              logIdbError(this.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e_5), e_5);
              this.recordFailure();
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    _this.db = args.db;
    _this.tabId = undefined;
    _this.onPersistentFailure = args.onPersistentFailure;
    // Default threshold of 1: fall back to memory immediately on the first IDB failure.
    // Session replay correctness is far more important than persistence, and IDB errors
    // are typically the symptom of a deeper problem (storage pressure, locked DB, broken
    // browser implementation) that won't recover within a single session.  Memory store
    // is always safe — fall back early.
    _this.consecutiveFailureThreshold = (_a = args.consecutiveFailureThreshold) !== null && _a !== void 0 ? _a : 1;
    return _this;
  }
  // Sampled (1 in 100) debug log so we can observe whether the store-layer guards
  // are catching empty-batch cases that would otherwise hit the empty-body 400 path
  // on the server. Logged at debug, not warn — this is operational telemetry for
  // post-deploy verification, not a customer-actionable warning. Per-store-instance
  // counter (rather than Math.random) keeps the first hit deterministic for tests.
  SessionReplayEventsIDBStore.prototype.maybeLogEmptyFiltered = function (source) {
    if (this.emptyFilteredCount++ % 100 === 0) {
      this.loggerProvider.debug("Filtered empty session replay sequence at ".concat(source, " (idb store)"));
    }
  };
  SessionReplayEventsIDBStore.prototype.recordFailure = function () {
    var _a;
    this.consecutiveFailures++;
    if (!this.hasTriggeredFallback && this.consecutiveFailures >= this.consecutiveFailureThreshold) {
      this.hasTriggeredFallback = true;
      (_a = this.onPersistentFailure) === null || _a === void 0 ? void 0 : _a.call(this);
    }
  };
  SessionReplayEventsIDBStore.prototype.recordSuccess = function () {
    this.consecutiveFailures = 0;
  };
  SessionReplayEventsIDBStore.new = function (type, args) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      var dbSuffix, dbName, db, tabId, e_6;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);
            dbSuffix = type === 'replay' ? '' : "_".concat(type);
            dbName = "".concat(args.apiKey.substring(0, 10), "_amp_session_replay_events").concat(dbSuffix);
            return [4 /*yield*/, createStore(dbName)];
          case 1:
            db = _b.sent();
            tabId = (_a = args.tabId) !== null && _a !== void 0 ? _a : generateUUID();
            return [2 /*return*/, new SessionReplayEventsIDBStore(_assign$(_assign$({}, args), {
              db: db,
              tabId: tabId
            }))];
          case 2:
            e_6 = _b.sent();
            logIdbError(args.loggerProvider, "".concat(STORAGE_FAILURE, ": ").concat(e_6), e_6);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayEventsIDBStore.prototype.getCurrentSequenceEvents = function (sessionId) {
    return __awaiter(this, void 0, void 0, function () {
      var record, rest, allEvents, _a, _b, record, rest, e_7_1;
      var e_7, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!sessionId) return [3 /*break*/, 2];
            return [4 /*yield*/, this.db.get('sessionCurrentSequence', sessionId)];
          case 1:
            record = _d.sent();
            if (!record) {
              return [2 /*return*/, undefined];
            }
            // Only return our own tab's record (or legacy untagged records).
            if (record.tabId && record.tabId !== this.tabId) {
              return [2 /*return*/, undefined];
            }
            record.tabId, rest = __rest(record, ["tabId"]);
            return [2 /*return*/, [rest]];
          case 2:
            allEvents = [];
            _d.label = 3;
          case 3:
            _d.trys.push([3, 8, 9, 10]);
            return [4 /*yield*/, this.db.getAll('sessionCurrentSequence')];
          case 4:
            _a = __values$1.apply(void 0, [_d.sent()]), _b = _a.next();
            _d.label = 5;
          case 5:
            if (!!_b.done) return [3 /*break*/, 7];
            record = _b.value;
            if (record.tabId && record.tabId !== this.tabId) {
              return [3 /*break*/, 6];
            }
            record.tabId, rest = __rest(record, ["tabId"]);
            allEvents.push(rest);
            _d.label = 6;
          case 6:
            _b = _a.next();
            return [3 /*break*/, 5];
          case 7:
            return [3 /*break*/, 10];
          case 8:
            e_7_1 = _d.sent();
            e_7 = {
              error: e_7_1
            };
            return [3 /*break*/, 10];
          case 9:
            try {
              if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            } finally {
              if (e_7) throw e_7.error;
            }
            return [7 /*endfinally*/];
          case 10:
            return [2 /*return*/, allEvents];
        }
      });
    });
  };
  return SessionReplayEventsIDBStore;
}(BaseEventsStore);
var InMemoryEventsStore = /** @class */function (_super) {
  __extends(InMemoryEventsStore, _super);
  function InMemoryEventsStore() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.finalizedSequences = {};
    _this.sequences = {};
    _this.sequenceId = 0;
    _this.emptyFilteredCount = 0;
    return _this;
  }
  InMemoryEventsStore.prototype.resetCurrentSequence = function (sessionId) {
    this.sequences[sessionId] = [];
  };
  InMemoryEventsStore.prototype.addSequence = function (sessionId) {
    var sequenceId = this.sequenceId++;
    var events = __spreadArray([], __read$1(this.sequences[sessionId]), false);
    this.finalizedSequences[sequenceId] = {
      sessionId: sessionId,
      events: events
    };
    this.resetCurrentSequence(sessionId);
    return {
      sequenceId: sequenceId,
      events: events,
      sessionId: sessionId
    };
  };
  // Sampled (1 in 100) debug log so we can observe whether the store-layer guards
  // are actually catching cases that would otherwise hit the empty-body 400 path on
  // the server. Logged at debug, not warn — this is operational telemetry for
  // post-deploy verification, not a customer-actionable warning. Per-store-instance
  // counter rather than Math.random keeps the first hit deterministic for tests.
  InMemoryEventsStore.prototype.maybeLogEmptyFiltered = function (source) {
    if (this.emptyFilteredCount++ % 100 === 0) {
      this.loggerProvider.debug("Filtered empty session replay sequence at ".concat(source, " (in-memory store)"));
    }
  };
  InMemoryEventsStore.prototype.getSequencesToSend = function () {
    return __awaiter(this, void 0, void 0, function () {
      var result, _a, _b, _c, sequenceId, _d, sessionId, events;
      var e_1, _e;
      return __generator(this, function (_f) {
        result = [];
        try {
          for (_a = __values$1(Object.entries(this.finalizedSequences)), _b = _a.next(); !_b.done; _b = _a.next()) {
            _c = __read$1(_b.value, 2), sequenceId = _c[0], _d = _c[1], sessionId = _d.sessionId, events = _d.events;
            if (events.length === 0) {
              // Prune in-place for consistency with the IDB store: by construction we
              // never write empty sequences anymore, so any empty entry is unambiguously
              // stale residue. Without the delete, every subsequent getSequencesToSend
              // would re-iterate the empty entry and re-fire the sampled log, producing
              // repeated noise that's indistinguishable from active bug occurrences.
              this.maybeLogEmptyFiltered('getSequencesToSend');
              delete this.finalizedSequences[Number(sequenceId)];
              continue;
            }
            result.push({
              sequenceId: Number(sequenceId),
              sessionId: sessionId,
              events: events
            });
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        return [2 /*return*/, result];
      });
    });
  };
  InMemoryEventsStore.prototype.storeCurrentSequence = function (sessionId) {
    return __awaiter(this, void 0, void 0, function () {
      var buffered;
      return __generator(this, function (_a) {
        buffered = this.sequences[sessionId];
        if (!buffered) {
          return [2 /*return*/, undefined];
        }
        if (buffered.length === 0) {
          // Slot exists but is empty (e.g. drained by a prior storeCurrentSequence then
          // re-flushed before any new event landed). Don't finalize a zero-event row.
          this.maybeLogEmptyFiltered('storeCurrentSequence');
          return [2 /*return*/, undefined];
        }
        return [2 /*return*/, this.addSequence(sessionId)];
      });
    });
  };
  InMemoryEventsStore.prototype.addEventToCurrentSequence = function (sessionId, event) {
    return __awaiter(this, void 0, void 0, function () {
      var sequenceReturn;
      return __generator(this, function (_a) {
        if (!this.sequences[sessionId]) {
          this.resetCurrentSequence(sessionId);
        }
        // shouldSplitEventsList can return true with an empty buffer when a single
        // incoming event is larger than MAX_EVENT_LIST_SIZE (2 MB) — the size-constraint
        // branch fires regardless of current length. Don't finalize a zero-event sequence
        // (the SR-4284 root cause); just hold the incoming event in the buffer.
        // shouldSplitEventsList's time-elapsed branch only fires when events.length > 0
        // (see base-events-store.ts), so calling it on an empty buffer has no side effects.
        if (this.shouldSplitEventsList(this.sequences[sessionId], event)) {
          if (this.sequences[sessionId].length === 0) {
            this.maybeLogEmptyFiltered('addEventToCurrentSequence');
          } else {
            sequenceReturn = this.addSequence(sessionId);
          }
        }
        this.sequences[sessionId].push(event);
        return [2 /*return*/, sequenceReturn];
      });
    });
  };
  InMemoryEventsStore.prototype.storeSendingEvents = function (sessionId, events) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.finalizedSequences[this.sequenceId] = {
          sessionId: sessionId,
          events: events
        };
        return [2 /*return*/, this.sequenceId++];
      });
    });
  };
  InMemoryEventsStore.prototype.cleanUpSessionEventsStore = function (_sessionId, sequenceId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (sequenceId !== undefined) {
          delete this.finalizedSequences[sequenceId];
        }
        return [2 /*return*/];
      });
    });
  };
  return InMemoryEventsStore;
}(BaseEventsStore);
var createEventsManager = function createEventsManager(_a) {
  var config = _a.config,
    minInterval = _a.minInterval,
    maxInterval = _a.maxInterval,
    maxPersistedEventsSize = _a.maxPersistedEventsSize,
    type = _a.type,
    payloadBatcher = _a.payloadBatcher,
    storeType = _a.storeType,
    trackDestinationWorkerScript = _a.trackDestinationWorkerScript,
    shouldSend = _a.shouldSend;
  return __awaiter(void 0, void 0, void 0, function () {
    function flush(useRetry) {
      if (useRetry === void 0) {
        useRetry = false;
      }
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2 /*return*/, trackDestination.flush(useRetry)];
        });
      });
    }
    var maxSingleEventSize, trackDestination, getMemoryStore, lastKnownDeviceId, usingIdbStore, store, switchToMemoryStore, getIdbStoreOrFallback, _b, beaconBuffer, beaconWindowStart, advanceBeaconWindow, sendEventsList, sendCurrentSequenceEvents, sendStoredEvents, addEvent, getBeaconEvents, dropPendingBeaconEvents;
    var _c;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          maxSingleEventSize = (_c = config.maxSingleEventSizeBytes) !== null && _c !== void 0 ? _c : MAX_SINGLE_EVENT_SIZE;
          trackDestination = new SessionReplayTrackDestination(_assign$(_assign$({}, config), {
            loggerProvider: config.loggerProvider,
            payloadBatcher: payloadBatcher,
            workerScript: trackDestinationWorkerScript
          }));
          getMemoryStore = function () {
            return new InMemoryEventsStore({
              loggerProvider: config.loggerProvider,
              maxInterval: maxInterval,
              minInterval: minInterval,
              maxPersistedEventsSize: maxPersistedEventsSize
            });
          };
          usingIdbStore = false;
          switchToMemoryStore = function () {
            return __awaiter(void 0, void 0, void 0, function () {
              var sequences, _a, deviceId_1;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    if (!usingIdbStore) return [2 /*return*/];
                    usingIdbStore = false;
                    config.loggerProvider.warn('IDB store is experiencing repeated failures; falling back to in-memory event store.');
                    if (!lastKnownDeviceId) return [3 /*break*/, 2];
                    return [4 /*yield*/, store.getSequencesToSend()];
                  case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                  case 2:
                    _a = undefined;
                    _b.label = 3;
                  case 3:
                    sequences = _a;
                    if (sequences && lastKnownDeviceId) {
                      deviceId_1 = lastKnownDeviceId;
                      if (sequences.length > 1) {
                        trackDestination.markCoalesceNextFlush();
                      }
                      sequences.forEach(function (seq) {
                        sendEventsList({
                          sequenceId: seq.sequenceId,
                          events: seq.events,
                          sessionId: seq.sessionId,
                          deviceId: deviceId_1
                        });
                      });
                    }
                    store = getMemoryStore();
                    return [2 /*return*/];
                }
              });
            });
          };
          getIdbStoreOrFallback = function () {
            return __awaiter(void 0, void 0, void 0, function () {
              var idb;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, SessionReplayEventsIDBStore.new(type, {
                      loggerProvider: config.loggerProvider,
                      minInterval: minInterval,
                      maxInterval: maxInterval,
                      maxPersistedEventsSize: maxPersistedEventsSize,
                      apiKey: config.apiKey,
                      onPersistentFailure: function () {
                        void switchToMemoryStore();
                      }
                    })];
                  case 1:
                    idb = _a.sent();
                    if (!idb) {
                      config.loggerProvider.log('Failed to initialize idb store, falling back to memory store.');
                      return [2 /*return*/, getMemoryStore()];
                    }
                    usingIdbStore = true;
                    return [2 /*return*/, idb];
                }
              });
            });
          };
          if (!(storeType === 'idb')) return [3 /*break*/, 2];
          return [4 /*yield*/, getIdbStoreOrFallback()];
        case 1:
          _b = _d.sent();
          return [3 /*break*/, 3];
        case 2:
          _b = getMemoryStore();
          _d.label = 3;
        case 3:
          store = _b;
          beaconBuffer = [];
          beaconWindowStart = 0;
          advanceBeaconWindow = function (upToAbsoluteIdx) {
            if (upToAbsoluteIdx <= beaconWindowStart) return;
            var trimCount = Math.min(upToAbsoluteIdx - beaconWindowStart, beaconBuffer.length);
            if (trimCount > 0) {
              beaconBuffer.splice(0, trimCount);
              beaconWindowStart = upToAbsoluteIdx;
            }
          };
          sendEventsList = function (_a) {
            var rawEvents = _a.events,
              sessionId = _a.sessionId,
              deviceId = _a.deviceId,
              sequenceId = _a.sequenceId,
              sequenceStore = store;
            // Backstop for events that entered IDB before the per-event size guard in
            // addCompressedEventToManager (e.g. stored by a previous SDK version or via
            // storeCurrentSequence/sendStoredEvents which bypass the capture-time check).
            // Compare UTF-8 byte size, not JS char count, to match the server-side limit.
            var events = rawEvents;
            var oversizedSizes = [];
            for (var i = 0; i < rawEvents.length; i++) {
              var bytes = utf8ByteLengthIfOver(rawEvents[i], maxSingleEventSize);
              if (bytes === undefined) {
                if (events !== rawEvents) events.push(rawEvents[i]);
                continue;
              }
              if (oversizedSizes.length === 0) {
                events = rawEvents.slice(0, i);
              }
              oversizedSizes.push(bytes);
            }
            if (oversizedSizes.length > 0) {
              config.loggerProvider.warn("Dropping ".concat(oversizedSizes.length, " oversized event(s) from session replay sequence before send. Sizes: ").concat(oversizedSizes.map(function (bytes) {
                return "".concat(Math.round(bytes / 1024), " KB");
              }).join(', '), ". If this recurs, please open a GitHub issue at https://github.com/amplitude/Amplitude-TypeScript/issues or contact Amplitude support."));
            }
            if (events.length === 0) {
              sequenceStore.cleanUpSessionEventsStore(sessionId, sequenceId).catch(function (e) {
                config.loggerProvider.warn('Failed to clean up session replay events store:', e);
              });
              return;
            }
            if (config.debugMode) {
              getStorageSize().then(function (_a) {
                var totalStorageSize = _a.totalStorageSize,
                  percentOfQuota = _a.percentOfQuota,
                  usageDetails = _a.usageDetails;
                config.loggerProvider.debug("Total storage size: ".concat(totalStorageSize, " KB, percentage of quota: ").concat(percentOfQuota, "%, usage details: ").concat(usageDetails));
              }).catch(function () {
                // swallow error
              });
            }
            trackDestination.sendEventsList({
              events: events,
              sessionId: sessionId,
              flushMaxRetries: config.flushMaxRetries,
              apiKey: config.apiKey,
              deviceId: deviceId,
              sampleRate: config.sampleRate,
              serverZone: config.serverZone,
              version: config.version,
              type: type,
              onComplete: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        return [4 /*yield*/, sequenceStore.cleanUpSessionEventsStore(sessionId, sequenceId)];
                      case 1:
                        _a.sent();
                        return [2 /*return*/];
                    }
                  });
                });
              }
            });
          };
          sendCurrentSequenceEvents = function (_a) {
            var sessionId = _a.sessionId,
              deviceId = _a.deviceId;
            lastKnownDeviceId = deviceId;
            // Evaluate shouldSend synchronously before the async store read. asyncSetSessionId
            // updates sessionStartTime immediately after calling sendEvents(), so by the time
            // storeCurrentSequence resolves the start time would reflect the new session and
            // the elapsed check would compute ~0ms, silently dropping the previous session's events.
            if (shouldSend && !shouldSend()) return;
            // Snapshot the absolute end-index before the async store read so that any events
            // pushed after this point are NOT considered sent and remain in the beacon buffer.
            var snapshotAbsIdx = beaconWindowStart + beaconBuffer.length;
            store.storeCurrentSequence(sessionId).then(function (currentSequence) {
              if (currentSequence) {
                advanceBeaconWindow(snapshotAbsIdx);
                sendEventsList({
                  sequenceId: currentSequence.sequenceId,
                  events: currentSequence.events,
                  sessionId: currentSequence.sessionId,
                  deviceId: deviceId
                });
              }
            }).catch(function (e) {
              config.loggerProvider.warn('Failed to get current sequence of session replay events for session:', e);
            });
          };
          sendStoredEvents = function (_a) {
            var deviceId = _a.deviceId;
            return __awaiter(void 0, void 0, void 0, function () {
              var sequencesToSend;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    lastKnownDeviceId = deviceId;
                    return [4 /*yield*/, store.getSequencesToSend()];
                  case 1:
                    sequencesToSend = _b.sent();
                    if (!(sequencesToSend === null || sequencesToSend === void 0 ? void 0 : sequencesToSend.length)) {
                      return [2 /*return*/];
                    }
                    config.loggerProvider.log("Draining ".concat(sequencesToSend.length, " stored sequence(s) from previous session."));
                    // These persisted sequences are about to be enqueued back-to-back. Without
                    // coalescing they flush as N separate POSTs — a request flood on page load. Mark the
                    // imminent flush to merge same-identity batches (the enqueues below are synchronous, so
                    // the whole backlog lands in the queue before the deferred flush consumes the flag). Skip
                    // the single-sequence case where there's nothing to merge.
                    if (sequencesToSend.length > 1) {
                      trackDestination.markCoalesceNextFlush();
                    }
                    sequencesToSend.forEach(function (sequence) {
                      sendEventsList({
                        sequenceId: sequence.sequenceId,
                        events: sequence.events,
                        sessionId: sequence.sessionId,
                        deviceId: deviceId
                      });
                    });
                    return [2 /*return*/];
                }
              });
            });
          };
          addEvent = function (_a) {
            var event = _a.event,
              sessionId = _a.sessionId,
              deviceId = _a.deviceId;
            lastKnownDeviceId = deviceId;
            // Capture shouldSend synchronously before the async store write, for the same
            // reason as sendCurrentSequenceEvents: asyncSetSessionId updates sessionStartTime
            // synchronously, so evaluating inside the .then() would use the new session's
            // start time and compute ~0ms elapsed, silently dropping a valid batch.
            var canSend = !shouldSend || shouldSend();
            // Record the absolute index of this event in the beacon buffer before the async
            // store operation. If a batch split occurs, we advance the window up to (but not
            // including) this event so that it starts the next pending window.
            var absIdx = beaconWindowStart + beaconBuffer.length;
            beaconBuffer.push(event.data);
            store.addEventToCurrentSequence(sessionId, event.data).then(function (sequenceToSend) {
              if (sequenceToSend) {
                if (!canSend) {
                  // The split atomically moved events to sequencesToSend; without cleanup
                  // they would be unconditionally replayed on next page load via
                  // sendStoredEvents, bypassing the min session duration gate. The split
                  // batch must also be dropped from the beacon buffer so it isn't sent
                  // via sendBeacon on page unload (potentially attributed to a later session).
                  store.cleanUpSessionEventsStore(sequenceToSend.sessionId, sequenceToSend.sequenceId).catch(function (e) {
                    config.loggerProvider.warn('Failed to clean up dropped session replay sequence:', e);
                  });
                  advanceBeaconWindow(absIdx);
                  return;
                }
                // Events before absIdx belong to the split batch being sent; advance window.
                advanceBeaconWindow(absIdx);
                sendEventsList({
                  sequenceId: sequenceToSend.sequenceId,
                  events: sequenceToSend.events,
                  sessionId: sequenceToSend.sessionId,
                  deviceId: deviceId
                });
              }
            }).catch(function (e) {
              config.loggerProvider.warn('Failed to add event to session replay capture:', e);
            });
          };
          getBeaconEvents = function () {
            return __spreadArray([], __read$1(beaconBuffer), false);
          };
          dropPendingBeaconEvents = function () {
            advanceBeaconWindow(beaconWindowStart + beaconBuffer.length);
          };
          return [2 /*return*/, {
            sendCurrentSequenceEvents: sendCurrentSequenceEvents,
            addEvent: addEvent,
            sendStoredEvents: sendStoredEvents,
            flush: flush,
            getBeaconEvents: getBeaconEvents,
            dropPendingBeaconEvents: dropPendingBeaconEvents,
            trackDestination: trackDestination
          }];
      }
    });
  });
};

/**
 * "Registers" events managers internally. When an event is added this class routes the event to the correct
 * manager. For all send or flush methods this will invoke the event for all registered managers.
 */
var MultiEventManager = /** @class */function () {
  function MultiEventManager() {
    var managers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      managers[_i] = arguments[_i];
    }
    var managersMap = new Map();
    managers.forEach(function (t) {
      managersMap.set(t.name, t.manager);
    });
    this.managers = managersMap;
  }
  MultiEventManager.prototype.sendStoredEvents = function (opts) {
    return __awaiter(this, void 0, void 0, function () {
      var promises;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            promises = [];
            this.managers.forEach(function (manager) {
              promises.push(manager.sendStoredEvents(opts));
            });
            return [4 /*yield*/, Promise.all(promises)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  MultiEventManager.prototype.addEvent = function (_a) {
    var _b;
    var sessionId = _a.sessionId,
      event = _a.event,
      deviceId = _a.deviceId;
    (_b = this.managers.get(event.type)) === null || _b === void 0 ? void 0 : _b.addEvent({
      sessionId: sessionId,
      event: event,
      deviceId: deviceId
    });
  };
  MultiEventManager.prototype.sendCurrentSequenceEvents = function (_a) {
    var sessionId = _a.sessionId,
      deviceId = _a.deviceId;
    this.managers.forEach(function (manager) {
      manager.sendCurrentSequenceEvents({
        sessionId: sessionId,
        deviceId: deviceId
      });
    });
  };
  MultiEventManager.prototype.flush = function (useRetry) {
    return __awaiter(this, void 0, void 0, function () {
      var promises;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            promises = [];
            this.managers.forEach(function (manager) {
              promises.push(manager.flush(useRetry));
            });
            return [4 /*yield*/, Promise.all(promises)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  return MultiEventManager;
}();

/* istanbul ignore file */
var config;
var rootDocument;
var start$1;
function finder(input, options) {
  start$1 = new Date();
  if (input.nodeType !== Node.ELEMENT_NODE) {
    throw new Error("Can't generate CSS selector for non-element node type.");
  }
  if ('html' === input.tagName.toLowerCase()) {
    return 'html';
  }
  var defaults = {
    root: document.body,
    idName: function (_name) {
      return true;
    },
    className: function (_name) {
      return true;
    },
    tagName: function (_name) {
      return true;
    },
    attr: function (_name, _value) {
      return false;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1000,
    maxNumberOfTries: 10000,
    timeoutMs: undefined
  };
  config = _assign$(_assign$({}, defaults), options);
  rootDocument = findRootDocument(config.root, defaults);
  var path = bottomUpSearch(input, 'all', function () {
    return bottomUpSearch(input, 'two', function () {
      return bottomUpSearch(input, 'one', function () {
        return bottomUpSearch(input, 'none');
      });
    });
  });
  if (path) {
    var optimized = sort(optimize(path, input));
    if (optimized.length > 0) {
      path = optimized[0];
    }
    return selector(path);
  } else {
    throw new Error("Selector was not found.");
  }
}
function findRootDocument(rootNode, defaults) {
  if (rootNode.nodeType === Node.DOCUMENT_NODE) {
    return rootNode;
  }
  if (rootNode === defaults.root) {
    return rootNode.ownerDocument;
  }
  return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
  var path = null;
  var stack = [];
  var current = input;
  var i = 0;
  var _loop_1 = function _loop_1() {
    var e_1, _a;
    var elapsedTime = new Date().getTime() - start$1.getTime();
    if (config.timeoutMs !== undefined && elapsedTime > config.timeoutMs) {
      throw new Error("Timeout: Can't find a unique selector after ".concat(elapsedTime, "ms"));
    }
    var level = maybe(id(current)) || maybe.apply(void 0, __spreadArray([], __read$1(attr(current)), false)) || maybe.apply(void 0, __spreadArray([], __read$1(classNames(current)), false)) || maybe(tagName(current)) || [any()];
    var nth = index(current);
    if (limit == 'all') {
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'two') {
      level = level.slice(0, 1);
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'one') {
      var _b = __read$1(level = level.slice(0, 1), 1),
        node = _b[0];
      if (nth && dispensableNth(node)) {
        level = [nthChild(node, nth)];
      }
    } else if (limit == 'none') {
      level = [any()];
      if (nth) {
        level = [nthChild(level[0], nth)];
      }
    }
    try {
      for (var level_1 = (e_1 = void 0, __values$1(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()) {
        var node = level_1_1.value;
        node.level = i;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    stack.push(level);
    if (stack.length >= config.seedMinLength) {
      path = findUniquePath(stack, fallback);
      if (path) {
        return "break";
      }
    }
    current = current.parentElement;
    i++;
  };
  while (current) {
    var state_1 = _loop_1();
    if (state_1 === "break") break;
  }
  if (!path) {
    path = findUniquePath(stack, fallback);
  }
  if (!path && fallback) {
    return fallback();
  }
  return path;
}
function findUniquePath(stack, fallback) {
  var e_2, _a;
  var paths = sort(combinations(stack));
  if (paths.length > config.threshold) {
    return fallback ? fallback() : null;
  }
  try {
    for (var paths_1 = __values$1(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
      var candidate = paths_1_1.value;
      if (unique(candidate)) {
        return candidate;
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return null;
}
function selector(path) {
  var node = path[0];
  var query = node.name;
  for (var i = 1; i < path.length; i++) {
    var level = path[i].level || 0;
    if (node.level === level - 1) {
      query = "".concat(path[i].name, " > ").concat(query);
    } else {
      query = "".concat(path[i].name, " ").concat(query);
    }
    node = path[i];
  }
  return query;
}
function penalty(path) {
  return path.map(function (node) {
    return node.penalty;
  }).reduce(function (acc, i) {
    return acc + i;
  }, 0);
}
function unique(path) {
  var css = selector(path);
  switch (rootDocument.querySelectorAll(css).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(css));
    case 1:
      return true;
    default:
      return false;
  }
}
function id(input) {
  var elementId = input.getAttribute('id');
  if (elementId && config.idName(elementId)) {
    return {
      name: '#' + CSS.escape(elementId),
      penalty: 0
    };
  }
  return null;
}
function attr(input) {
  var attrs = Array.from(input.attributes).filter(function (attr) {
    return config.attr(attr.name, attr.value);
  });
  return attrs.map(function (attr) {
    return {
      name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
      penalty: 0.5
    };
  });
}
function classNames(input) {
  var names = Array.from(input.classList).filter(config.className);
  return names.map(function (name) {
    return {
      name: '.' + CSS.escape(name),
      penalty: 1
    };
  });
}
function tagName(input) {
  var name = input.tagName.toLowerCase();
  if (config.tagName(name)) {
    return {
      name: name,
      penalty: 2
    };
  }
  return null;
}
function any() {
  return {
    name: '*',
    penalty: 3
  };
}
function index(input) {
  var parent = input.parentNode;
  if (!parent) {
    return null;
  }
  var child = parent.firstChild;
  if (!child) {
    return null;
  }
  var i = 0;
  while (child) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      i++;
    }
    if (child === input) {
      break;
    }
    child = child.nextSibling;
  }
  return i;
}
function nthChild(node, i) {
  return {
    name: node.name + ":nth-child(".concat(i, ")"),
    penalty: node.penalty + 1
  };
}
function dispensableNth(node) {
  return node.name !== 'html' && !node.name.startsWith('#');
}
function maybe() {
  var level = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    level[_i] = arguments[_i];
  }
  var list = level.filter(notEmpty);
  if (list.length > 0) {
    return list;
  }
  return null;
}
function notEmpty(value) {
  return value !== null && value !== undefined;
}
function combinations(stack, path) {
  var _a, _b, node, e_3_1;
  var e_3, _c;
  if (path === void 0) {
    path = [];
  }
  return __generator(this, function (_d) {
    switch (_d.label) {
      case 0:
        if (!(stack.length > 0)) return [3 /*break*/, 9];
        _d.label = 1;
      case 1:
        _d.trys.push([1, 6, 7, 8]);
        _a = __values$1(stack[0]), _b = _a.next();
        _d.label = 2;
      case 2:
        if (!!_b.done) return [3 /*break*/, 5];
        node = _b.value;
        return [5 /*yield**/, __values$1(combinations(stack.slice(1, stack.length), path.concat(node)))];
      case 3:
        _d.sent();
        _d.label = 4;
      case 4:
        _b = _a.next();
        return [3 /*break*/, 2];
      case 5:
        return [3 /*break*/, 8];
      case 6:
        e_3_1 = _d.sent();
        e_3 = {
          error: e_3_1
        };
        return [3 /*break*/, 8];
      case 7:
        try {
          if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        } finally {
          if (e_3) throw e_3.error;
        }
        return [7 /*endfinally*/];
      case 8:
        return [3 /*break*/, 11];
      case 9:
        return [4 /*yield*/, path];
      case 10:
        _d.sent();
        _d.label = 11;
      case 11:
        return [2 /*return*/];
    }
  });
}
function sort(paths) {
  return __spreadArray([], __read$1(paths), false).sort(function (a, b) {
    return penalty(a) - penalty(b);
  });
}
function optimize(path, input, scope) {
  var i, newPath, newPathKey;
  if (scope === void 0) {
    scope = {
      counter: 0,
      visited: new Map()
    };
  }
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        if (!(path.length > 2 && path.length > config.optimizedMinLength)) return [3 /*break*/, 5];
        i = 1;
        _a.label = 1;
      case 1:
        if (!(i < path.length - 1)) return [3 /*break*/, 5];
        if (scope.counter > config.maxNumberOfTries) {
          return [2 /*return*/]; // Okay At least I tried!
        }
        scope.counter += 1;
        newPath = __spreadArray([], __read$1(path), false);
        newPath.splice(i, 1);
        newPathKey = selector(newPath);
        if (scope.visited.has(newPathKey)) {
          return [2 /*return*/];
        }
        if (!(unique(newPath) && same(newPath, input))) return [3 /*break*/, 4];
        return [4 /*yield*/, newPath];
      case 2:
        _a.sent();
        scope.visited.set(newPathKey, true);
        return [5 /*yield**/, __values$1(optimize(newPath, input, scope))];
      case 3:
        _a.sent();
        _a.label = 4;
      case 4:
        i++;
        return [3 /*break*/, 1];
      case 5:
        return [2 /*return*/];
    }
  });
}
function same(path, input) {
  return rootDocument.querySelector(selector(path)) === input;
}
var HOUR_IN_MILLISECONDS = 3600000;
var clickNonBatcher = function clickNonBatcher(_a) {
  var version = _a.version,
    events = _a.events;
  var clickEvents = [];
  events.forEach(function (evt) {
    var record = JSON.parse(evt);
    record.count = 1;
    if (record.type === 'click') {
      clickEvents.push(record);
    }
  });
  return {
    version: version,
    events: clickEvents
  };
};
var clickBatcher = function clickBatcher(_a) {
  var version = _a.version,
    events = _a.events;
  var clickEvents = [];
  events.forEach(function (evt) {
    var record = JSON.parse(evt);
    if (record.type === 'click') {
      clickEvents.push(record);
    }
  });
  var reduced = clickEvents.reduce(function (prev, curr) {
    var x = curr.x,
      y = curr.y,
      selector = curr.selector,
      timestamp = curr.timestamp;
    // round down to nearest hour.
    var hour = timestamp - timestamp % HOUR_IN_MILLISECONDS;
    var k = "".concat(x, ":").concat(y, ":").concat(selector !== null && selector !== void 0 ? selector : '', ":").concat(hour);
    if (!prev[k]) {
      prev[k] = _assign$(_assign$({}, curr), {
        timestamp: hour,
        count: 1
      });
    } else {
      prev[k].count += 1;
    }
    return prev;
  }, {});
  return {
    version: version,
    events: Object.values(reduced)
  };
};
var ClickHandler = /** @class */function () {
  function ClickHandler(logger, scrollWatcher) {
    var _this = this;
    this.createHook = function (_a) {
      var eventsManager = _a.eventsManager,
        sessionId = _a.sessionId,
        deviceIdFn = _a.deviceIdFn,
        mirror = _a.mirror,
        ugcFilterRules = _a.ugcFilterRules,
        performanceOptions = _a.performanceOptions;
      return function (e) {
        if (e.type !== MouseInteractions.Click) {
          return;
        }
        var globalScope = getGlobalScope();
        if (!globalScope) {
          return;
        }
        var location = globalScope.location,
          innerHeight = globalScope.innerHeight,
          innerWidth = globalScope.innerWidth;
        // it only makes sense to send events if a pageUrl exists
        if (!location) {
          return;
        }
        var x = e.x,
          y = e.y;
        if (x === undefined || y === undefined) {
          return;
        }
        var node = mirror.getNode(e.id);
        var selector;
        if (node) {
          try {
            selector = finder(node, performanceOptions);
          } catch (err) {
            _this.logger.debug('error resolving selector from finder');
          }
        }
        var pageUrl = getPageUrl(location.href, ugcFilterRules);
        var event = {
          x: x + _this.scrollWatcher.currentScrollX,
          y: y + _this.scrollWatcher.currentScrollY,
          selector: selector,
          viewportHeight: innerHeight,
          viewportWidth: innerWidth,
          pageUrl: pageUrl,
          timestamp: Date.now(),
          type: 'click'
        };
        var deviceId = deviceIdFn();
        if (deviceId) {
          eventsManager.addEvent({
            sessionId: sessionId,
            event: {
              type: 'interaction',
              data: JSON.stringify(event)
            },
            deviceId: deviceId
          });
        }
      };
    };
    this.logger = logger;
    this.scrollWatcher = scrollWatcher;
  }
  return ClickHandler;
}();

// These functions are not exposed in rrweb package, so we will define it here to use
// Ignoring this function since this is copied from rrweb
function getViewportHeight() {
  var globalScope = getGlobalScope();
  return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerHeight) || document.documentElement && document.documentElement.clientHeight || 0;
}
function getViewportWidth() {
  var globalScope = getGlobalScope();
  return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerWidth) || document.documentElement && document.documentElement.clientWidth || 0;
}

/**
 * For very small payloads it's preferable to use the [Beacon API](https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API).
 * While it doesn't provide 100% guarantees on sends, it greatly helps with overall reliability and page load performance. As
 * the Beacon API has a potential to fail due to size constraints we want to fall back to XHR if need be. This is mostly to
 * be used with 'pagehide' or 'beforeunload' events.
 *
 * Note there are only 3 CORS safelisted Content-Types you can send:
 *
 * - application/x-www-form-urlencoded
 * - multipart/form-data
 * - text/plain
 *
 * If we do not send one of these, some browsers like Chrome may not send this at all. Also we incur the overhead of a preflight
 * request. In our case we will add no additional content-type header. If you are trying to ping a server that requires this
 * header, you may want to use the regular fetch API or a different mechanism.
 */
var BeaconTransport = /** @class */function () {
  function BeaconTransport(context, config) {
    var globalScope = getGlobalScope();
    if (globalScope && globalScope.navigator && typeof globalScope.navigator.sendBeacon === 'function') {
      this.sendBeacon = function (pageUrl, payload) {
        try {
          if (globalScope.navigator.sendBeacon(pageUrl, JSON.stringify(payload))) {
            return true;
          }
        } catch (e) {
          // not logging error, since it would be hard to view and just adds overhead.
        }
        return false;
      };
    } else {
      this.sendBeacon = function () {
        return false;
      };
    }
    this.sendXhr = function (pageUrl, payload) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', pageUrl, true);
      xhr.setRequestHeader('Accept', '*/*');
      xhr.send(JSON.stringify(payload));
      return true;
    };
    this.basePageUrl = getServerUrl(config.serverZone, config.trackServerUrl);
    this.apiKey = config.apiKey;
    this.context = context;
    this.handleSendEvents = config.handleSendEvents;
    this.loggerProvider = config.loggerProvider;
  }
  BeaconTransport.prototype.send = function (deviceId, payload) {
    var _this = this;
    var _a;
    var _b = this.context,
      sessionId = _b.sessionId,
      type = _b.type;
    // Custom-transport path: navigator.sendBeacon/XHR cannot attach custom headers, so an
    // interaction beacon would otherwise leave unauthenticated and be rejected by an
    // authenticating proxy. When handleSendEvents is set, route the beacon through it instead —
    // a keepalive fetch (survives page unload) that carries the customer's auth. Mirrors the
    // replay page-exit path: api_key goes in the Authorization header, not the URL.
    if (this.handleSendEvents) {
      var params = new URLSearchParams({
        device_id: deviceId,
        session_id: String(sessionId),
        type: String(type)
      });
      var url = "".concat(this.basePageUrl, "?").concat(params.toString());
      var headers = {
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: "Bearer ".concat(this.apiKey)
      };
      try {
        void this.handleSendEvents({
          url: url,
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload),
          keepalive: true
        }).catch(function (e) {
          var _a;
          (_a = _this.loggerProvider) === null || _a === void 0 ? void 0 : _a.warn('Custom transport failed to send session replay interaction beacon:', e);
        });
      } catch (e) {
        (_a = this.loggerProvider) === null || _a === void 0 ? void 0 : _a.warn('Custom transport threw while sending session replay interaction beacon:', e);
      }
      return;
    }
    var urlParams = new URLSearchParams({
      device_id: deviceId,
      session_id: String(sessionId),
      type: String(type),
      api_key: this.apiKey
    });
    var pageUrl = "".concat(this.basePageUrl, "?").concat(urlParams.toString());
    // ideally send using the beacon API, but there is a chance it may fail, possibly due to a payload
    // size limit. in this case, try best effort to send using xhr.
    this.sendBeacon(pageUrl, payload) || this.sendXhr(pageUrl, payload);
  };
  return BeaconTransport;
}();

/**
 * This is intended to watch and update max scroll activity when loaded for a particular page.
 * A new instance should be created if the page URL changes, since by default it does not reset
 * it's max scroll state. It is intended to send very few and very small events utilizing the
 * Beacon API.
 * @see {@link BeaconTransport} for more details on Beacon API usage.
 */
var ScrollWatcher = /** @class */function () {
  function ScrollWatcher(transport, config) {
    var _this = this;
    this.timestamp = Date.now();
    this.hook = function (e) {
      _this.update(e);
    };
    this.send = function (deviceIdFn) {
      return function (_) {
        var _a, _b, _c, _d;
        var deviceId = deviceIdFn();
        var globalScope = getGlobalScope();
        if (globalScope && deviceId) {
          // Capture the true final scroll position directly from the window.
          // rrweb's scroll observer throttles callbacks to 100ms using setTimeout,
          // so the most recent scroll position may not have been delivered to the hook yet.
          var scrollX_1 = (_a = globalScope.scrollX) !== null && _a !== void 0 ? _a : 0;
          var scrollY_1 = (_b = globalScope.scrollY) !== null && _b !== void 0 ? _b : 0;
          if (scrollX_1 > 0 || scrollY_1 > 0) {
            // id is required by the scrollPosition type but is not used by update() —
            // only x and y are read. 1 is the conventional rrweb mirror ID for the document node.
            _this.update({
              id: 1,
              x: scrollX_1,
              y: scrollY_1
            });
          }
          _this.transport.send(deviceId, {
            version: 1,
            events: [{
              maxScrollX: _this._maxScrollX,
              maxScrollY: _this._maxScrollY,
              maxScrollWidth: _this._maxScrollWidth,
              maxScrollHeight: _this._maxScrollHeight,
              viewportHeight: getViewportHeight(),
              viewportWidth: getViewportWidth(),
              pageUrl: getPageUrl(globalScope.location.href, (_d = (_c = _this.config.interactionConfig) === null || _c === void 0 ? void 0 : _c.ugcFilterRules) !== null && _d !== void 0 ? _d : []),
              timestamp: _this.timestamp,
              type: 'scroll'
            }]
          });
        }
      };
    };
    this._maxScrollX = 0;
    this._maxScrollY = 0;
    this._currentScrollX = 0;
    this._currentScrollY = 0;
    this._maxScrollWidth = getViewportWidth();
    this._maxScrollHeight = getViewportHeight();
    this.config = config;
    this.transport = transport;
  }
  ScrollWatcher.default = function (context, config) {
    return new ScrollWatcher(new BeaconTransport(context, config), config);
  };
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollX", {
    get: function () {
      return this._maxScrollX;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollY", {
    get: function () {
      return this._maxScrollY;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollWidth", {
    get: function () {
      return this._maxScrollWidth;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollHeight", {
    get: function () {
      return this._maxScrollHeight;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "currentScrollX", {
    get: function () {
      return this._currentScrollX;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "currentScrollY", {
    get: function () {
      return this._currentScrollY;
    },
    enumerable: false,
    configurable: true
  });
  ScrollWatcher.prototype.update = function (e) {
    var now = Date.now();
    this._currentScrollX = e.x;
    this._currentScrollY = e.y;
    if (e.x > this._maxScrollX) {
      var width = getViewportWidth();
      this._maxScrollX = e.x;
      var maxScrollWidth = e.x + width;
      if (maxScrollWidth > this._maxScrollWidth) {
        this._maxScrollWidth = maxScrollWidth;
      }
      this.timestamp = now;
    }
    if (e.y > this._maxScrollY) {
      var height = getViewportHeight();
      this._maxScrollY = e.y;
      var maxScrollHeight = e.y + height;
      if (maxScrollHeight > this._maxScrollHeight) {
        this._maxScrollHeight = maxScrollHeight;
      }
      this.timestamp = now;
    }
  };
  return ScrollWatcher;
}();
var SessionIdentifiers = /** @class */function () {
  function SessionIdentifiers(_a) {
    var sessionId = _a.sessionId,
      deviceId = _a.deviceId;
    this.deviceId = deviceId;
    this.sessionId = sessionId;
    if (sessionId && deviceId) {
      this.sessionReplayId = generateSessionReplayId(sessionId, deviceId);
    }
  }
  return SessionIdentifiers;
}();

/**
 * Persists the wall-clock time at which a session's replay first began capturing,
 * keyed by sessionId. The persisted value drives the `min_session_duration_ms` gate:
 * we measure elapsed *replay* time, not just current page-load time, so a session that
 * is paused and resumed (or that crosses a page navigation) is still gated correctly.
 *
 * All storage access is wrapped in try/catch — when localStorage is unavailable (Safari
 * private mode, quota exceeded, sandboxed iframe) callers fall back to `Date.now()` so
 * the gate degrades gracefully instead of throwing.
 */
var KEY_PREFIX = 'AMP_SR_START_';
var APIKEY_FINGERPRINT_LEN = 10;
/**
 * TTL beyond which a stored start time is treated as stale and pruned on next init.
 * 24 hours covers the longest realistic single-session duration in Amplitude (default
 * inactivity timeout is 30 minutes; some configs extend sessions across resumes).
 */
var REPLAY_START_TIME_TTL_MS = 24 * 60 * 60 * 1000;
var buildKeyPrefix = function buildKeyPrefix(apiKey) {
  return "".concat(KEY_PREFIX).concat(apiKey.substring(0, APIKEY_FINGERPRINT_LEN), "_");
};
var buildKey = function buildKey(apiKey, sessionId) {
  return "".concat(buildKeyPrefix(apiKey)).concat(sessionId);
};
var getLocalStorage = function getLocalStorage() {
  try {
    var scope = getGlobalScope();
    return scope === null || scope === void 0 ? void 0 : scope.localStorage;
  } catch (_a) {
    // Accessing localStorage can throw in some sandboxed contexts.
    return undefined;
  }
};
/**
 * Returns the persisted replay start time for this sessionId if one exists and is fresh,
 * otherwise writes `now` and returns it. Returns undefined only if storage is unavailable
 * — callers should fall back to a transient `Date.now()` in that case.
 */
var getOrInitReplayStartTime = function getOrInitReplayStartTime(apiKey, sessionId, now, logger) {
  var storage = getLocalStorage();
  if (!storage) return undefined;
  var key = buildKey(apiKey, sessionId);
  try {
    var raw = storage.getItem(key);
    if (raw !== null) {
      var parsed = Number(raw);
      // Treat NaN, non-finite, future-dated, and stale entries as missing.
      if (Number.isFinite(parsed) && parsed > 0 && parsed <= now && now - parsed < REPLAY_START_TIME_TTL_MS) {
        return parsed;
      }
    }
    storage.setItem(key, String(now));
    return now;
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.debug("Failed to read/write replay start time from storage: ".concat(String(e)));
    return undefined;
  }
};
var setReplayStartTime = function setReplayStartTime(apiKey, sessionId, startTime, logger) {
  var storage = getLocalStorage();
  if (!storage) return;
  try {
    storage.setItem(buildKey(apiKey, sessionId), String(startTime));
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.debug("Failed to write replay start time to storage: ".concat(String(e)));
  }
};
var removeReplayStartTime = function removeReplayStartTime(apiKey, sessionId, logger) {
  var storage = getLocalStorage();
  if (!storage) return;
  try {
    storage.removeItem(buildKey(apiKey, sessionId));
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.debug("Failed to remove replay start time from storage: ".concat(String(e)));
  }
};
/**
 * Drops stored start times older than {@link REPLAY_START_TIME_TTL_MS}. Cheap best-effort
 * sweep called on init — keeps localStorage from accumulating dead entries when sessions
 * end without a clean transition (browser close, crash). Scoped to this API key's keys
 * so multi-tenant pages don't churn through each other's entries.
 */
var pruneStaleReplayStartTimes = function pruneStaleReplayStartTimes(apiKey, now, logger) {
  var e_1, _a;
  var storage = getLocalStorage();
  if (!storage) return;
  var prefix = buildKeyPrefix(apiKey);
  try {
    // Collect first; localStorage indices shift as we remove.
    var stale = [];
    for (var i = 0; i < storage.length; i++) {
      var key = storage.key(i);
      if (!key || !key.startsWith(prefix)) continue;
      var raw = storage.getItem(key);
      if (raw === null) continue;
      var parsed = Number(raw);
      if (!Number.isFinite(parsed) || parsed <= 0 || now - parsed >= REPLAY_START_TIME_TTL_MS) {
        stale.push(key);
      }
    }
    try {
      for (var stale_1 = __values$1(stale), stale_1_1 = stale_1.next(); !stale_1_1.done; stale_1_1 = stale_1.next()) {
        var key = stale_1_1.value;
        storage.removeItem(key);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (stale_1_1 && !stale_1_1.done && (_a = stale_1.return)) _a.call(stale_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.debug("Failed to prune stale replay start times: ".concat(String(e)));
  }
};
var MAX_IDB_STORAGE_LENGTH = 1000 * 60 * 60 * 24 * 2; // 2 days
var TargetingIDBStore = /** @class */function () {
  function TargetingIDBStore() {
    var _this = this;
    this.dbs = {};
    this.createStore = function (dbName) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, openDB(dbName, 1, {
                upgrade: function (db) {
                  if (!db.objectStoreNames.contains('sessionTargetingMatch')) {
                    db.createObjectStore('sessionTargetingMatch', {
                      keyPath: 'sessionId'
                    });
                  }
                }
              })];
            case 1:
              return [2 /*return*/, _a.sent()];
          }
        });
      });
    };
    this.openOrCreateDB = function (apiKey) {
      return __awaiter(_this, void 0, void 0, function () {
        var dbName, db;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (this.dbs && this.dbs[apiKey]) {
                return [2 /*return*/, this.dbs[apiKey]];
              }
              dbName = "".concat(apiKey.substring(0, 10), "_amp_session_replay_targeting");
              return [4 /*yield*/, this.createStore(dbName)];
            case 1:
              db = _a.sent();
              this.dbs[apiKey] = db;
              return [2 /*return*/, db];
          }
        });
      });
    };
    this.getTargetingMatchForSession = function (_a) {
      var loggerProvider = _a.loggerProvider,
        apiKey = _a.apiKey,
        sessionId = _a.sessionId;
      return __awaiter(_this, void 0, void 0, function () {
        var db, sessionIdStr, targetingMatchForSession, e_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 3,, 4]);
              return [4 /*yield*/, this.openOrCreateDB(apiKey)];
            case 1:
              db = _b.sent();
              sessionIdStr = String(sessionId);
              return [4 /*yield*/, db.get('sessionTargetingMatch', sessionIdStr)];
            case 2:
              targetingMatchForSession = _b.sent();
              return [2 /*return*/, targetingMatchForSession === null || targetingMatchForSession === void 0 ? void 0 : targetingMatchForSession.targetingMatch];
            case 3:
              e_1 = _b.sent();
              logIdbError(loggerProvider, "Failed to get targeting match for session id ".concat(sessionId, ": ").concat(e_1), e_1);
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.storeTargetingMatchForSession = function (_a) {
      var loggerProvider = _a.loggerProvider,
        apiKey = _a.apiKey,
        sessionId = _a.sessionId,
        targetingMatch = _a.targetingMatch;
      return __awaiter(_this, void 0, void 0, function () {
        var db, sessionIdStr, targetingMatchForSession, e_2;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 3,, 4]);
              return [4 /*yield*/, this.openOrCreateDB(apiKey)];
            case 1:
              db = _b.sent();
              sessionIdStr = String(sessionId);
              return [4 /*yield*/, db.put('sessionTargetingMatch', {
                targetingMatch: targetingMatch,
                sessionId: sessionIdStr,
                lastUpdated: Date.now()
              })];
            case 2:
              targetingMatchForSession = _b.sent();
              return [2 /*return*/, targetingMatchForSession];
            case 3:
              e_2 = _b.sent();
              logIdbError(loggerProvider, "Failed to store targeting match for session id ".concat(sessionId, ": ").concat(e_2), e_2);
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.clearStoreOfOldSessions = function (_a) {
      var loggerProvider = _a.loggerProvider,
        apiKey = _a.apiKey,
        currentSessionId = _a.currentSessionId;
      return __awaiter(_this, void 0, void 0, function () {
        var db, currentSessionIdStr, tx, allTargetingMatchObjs, i, targetingMatchObj, amountOfTimeSinceSession, e_3;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 8,, 9]);
              return [4 /*yield*/, this.openOrCreateDB(apiKey)];
            case 1:
              db = _b.sent();
              currentSessionIdStr = String(currentSessionId);
              tx = db.transaction('sessionTargetingMatch', 'readwrite');
              return [4 /*yield*/, tx.store.getAll()];
            case 2:
              allTargetingMatchObjs = _b.sent();
              i = 0;
              _b.label = 3;
            case 3:
              if (!(i < allTargetingMatchObjs.length)) return [3 /*break*/, 6];
              targetingMatchObj = allTargetingMatchObjs[i];
              amountOfTimeSinceSession = Date.now() - targetingMatchObj.lastUpdated;
              if (!(targetingMatchObj.sessionId !== currentSessionIdStr && amountOfTimeSinceSession > MAX_IDB_STORAGE_LENGTH)) return [3 /*break*/, 5];
              return [4 /*yield*/, tx.store.delete(targetingMatchObj.sessionId)];
            case 4:
              _b.sent();
              _b.label = 5;
            case 5:
              i++;
              return [3 /*break*/, 3];
            case 6:
              return [4 /*yield*/, tx.done];
            case 7:
              _b.sent();
              return [3 /*break*/, 9];
            case 8:
              e_3 = _b.sent();
              logIdbError(loggerProvider, "Failed to clear old targeting matches for sessions: ".concat(e_3), e_3);
              return [3 /*break*/, 9];
            case 9:
              return [2 /*return*/];
          }
        });
      });
    };
  }
  return TargetingIDBStore;
}();
var targetingIDBStore = new TargetingIDBStore();
var evaluateTargetingAndStore = function evaluateTargetingAndStore(_a) {
  var sessionId = _a.sessionId,
    targetingConfig = _a.targetingConfig,
    loggerProvider = _a.loggerProvider,
    apiKey = _a.apiKey,
    targetingParams = _a.targetingParams,
    _b = _a.urlChange,
    urlChange = _b === void 0 ? false : _b;
  return __awaiter(void 0, void 0, void 0, function () {
    var idbTargetingMatch, sessionTargetingMatch, evaluateTargetingPackage, params, targetingResult, err_1, knownError;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4 /*yield*/, targetingIDBStore.clearStoreOfOldSessions({
            loggerProvider: loggerProvider,
            apiKey: apiKey,
            currentSessionId: sessionId
          })];
        case 1:
          _c.sent();
          return [4 /*yield*/, targetingIDBStore.getTargetingMatchForSession({
            loggerProvider: loggerProvider,
            apiKey: apiKey,
            sessionId: sessionId
          })];
        case 2:
          idbTargetingMatch = _c.sent();
          // Skip IDB cache when re-evaluating with a new page (e.g. URL change); otherwise we'd never
          // re-evaluate and would keep returning true after navigating to a non-matching page.
          if (idbTargetingMatch === true && !urlChange) {
            return [2 /*return*/, true];
          }
          sessionTargetingMatch = true;
          _c.label = 3;
        case 3:
          _c.trys.push([3, 6,, 7]);
          return [4 /*yield*/, import('./index-BN79egE9.js')];
        case 4:
          evaluateTargetingPackage = _c.sent().evaluateTargeting;
          params = _assign$(_assign$({}, targetingParams), {
            flag: targetingConfig,
            sessionId: typeof sessionId === 'string' ? parseInt(sessionId, 10) : sessionId,
            apiKey: apiKey,
            loggerProvider: loggerProvider
          });
          return [4 /*yield*/, evaluateTargetingPackage(params)];
        case 5:
          targetingResult = _c.sent();
          if (targetingResult && targetingResult.sr_targeting_config) {
            sessionTargetingMatch = targetingResult.sr_targeting_config.key === 'on';
          }
          void targetingIDBStore.storeTargetingMatchForSession({
            loggerProvider: loggerProvider,
            apiKey: apiKey,
            sessionId: sessionId,
            targetingMatch: sessionTargetingMatch
          });
          return [3 /*break*/, 7];
        case 6:
          err_1 = _c.sent();
          knownError = err_1;
          loggerProvider.warn(knownError.message);
          return [3 /*break*/, 7];
        case 7:
          return [2 /*return*/, sessionTargetingMatch];
      }
    });
  });
};
function isSessionInSample(sessionId, sampleRate) {
  return isTimestampInSample(sessionId, sampleRate);
}

/** Patch detection marker to prevent double-patching */
var PATCH_MARKER = '__amplitude_url_tracking_patched__';
/** Per-globalScope subscription state; persists to avoid wrapper stacking across re-subscribe cycles */
var urlChangeSubscriptionsByScope = new WeakMap();
/**
 * Single helper for URL change detection. Supports:
 * - History API (pushState/replaceState) + popstate + hashchange (shared patch per scope)
 * - Optional polling (setInterval on location.href)
 *
 * Used by session-replay targeting (re-evaluate on URL change) and the URL tracking plugin
 * (emit rrweb events). Call the returned function to unsubscribe.
 *
 * @param globalScope - window (or equivalent); no-op if undefined
 * @param onUrlChange - called when the URL changes, with the new href
 * @param options - optional polling (default: event-based only)
 * @returns cleanup function to remove this subscription
 */
function subscribeToUrlChanges(globalScope, onUrlChange, options) {
  if (options === void 0) {
    options = {};
  }
  if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.location)) {
    return function () {
      return;
    };
  }
  var _a = options.enablePolling,
    enablePolling = _a === void 0 ? false : _a,
    _b = options.pollingInterval,
    pollingInterval = _b === void 0 ? DEFAULT_URL_CHANGE_POLLING_INTERVAL : _b;
  if (enablePolling) {
    var getHref_1 = function getHref_1() {
      var _a;
      return (_a = globalScope.location.href) !== null && _a !== void 0 ? _a : '';
    };
    var lastHref_1 = getHref_1();
    var id_1 = globalScope.setInterval(function () {
      var href = getHref_1();
      if (href === lastHref_1) {
        return;
      }
      lastHref_1 = href;
      onUrlChange(href);
    }, pollingInterval);
    return function () {
      if (id_1 != null) {
        globalScope.clearInterval(id_1);
      }
    };
  }
  var subscriptionState = urlChangeSubscriptionsByScope.get(globalScope);
  if (!subscriptionState) {
    var lastHref_2 = undefined;
    var callbacks_1 = new Set();
    var getHref_2 = function getHref_2() {
      var _a;
      return (_a = globalScope.location.href) !== null && _a !== void 0 ? _a : '';
    };
    var notify_1 = function notify_1() {
      var href = getHref_2();
      if (lastHref_2 !== undefined && href === lastHref_2) return;
      lastHref_2 = href;
      callbacks_1.forEach(function (c) {
        return c(href);
      });
    };
    /**
     * Creates a patched version of history methods (pushState/replaceState)
     * that calls the original method and then emits a URL change event.
     */
    var createHistoryMethodPatch = function createHistoryMethodPatch(originalMethod) {
      var patchedMethod = function patchedMethod() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var result = originalMethod.apply(this, args);
        // Read from location.href after history call so we always notify with resolved absolute URL.
        notify_1();
        return result;
      };
      patchedMethod[PATCH_MARKER] = true;
      return patchedMethod;
    };
    var history_1 = globalScope.history;
    if (history_1 === null || history_1 === void 0 ? void 0 : history_1.pushState) {
      var pushState = Reflect.get(history_1, 'pushState');
      if (!pushState[PATCH_MARKER]) {
        history_1.pushState = createHistoryMethodPatch(pushState);
      }
    }
    if (history_1 === null || history_1 === void 0 ? void 0 : history_1.replaceState) {
      var replaceState = Reflect.get(history_1, 'replaceState');
      if (!replaceState[PATCH_MARKER]) {
        history_1.replaceState = createHistoryMethodPatch(replaceState);
      }
    }
    subscriptionState = {
      callbacks: callbacks_1,
      notify: notify_1,
      onPopStateOrHashChange: function () {
        return notify_1();
      },
      listenersAttached: false
    };
    urlChangeSubscriptionsByScope.set(globalScope, subscriptionState);
  }
  var state = subscriptionState;
  if (!state.listenersAttached) {
    globalScope.addEventListener('popstate', state.onPopStateOrHashChange);
    globalScope.addEventListener('hashchange', state.onPopStateOrHashChange);
    state.listenersAttached = true;
  }
  state.callbacks.add(onUrlChange);
  return function () {
    state.callbacks.delete(onUrlChange);
    if (state.callbacks.size === 0) {
      // Do not restore history methods: we are not aware of patches applied by other scripts.
      if (state.listenersAttached) {
        globalScope.removeEventListener('popstate', state.onPopStateOrHashChange);
        globalScope.removeEventListener('hashchange', state.onPopStateOrHashChange);
        state.listenersAttached = false;
      }
    }
  };
}
/**
 * Creates a URL tracking plugin for rrweb record function
 *
 * This plugin monitors URL changes in the browser and emits events when the URL changes.
 * It supports three tracking modes:
 * 1. Polling (if explicitly enabled) - periodically checks for URL changes
 * 2. History API + Hash routing (default) - patches pushState/replaceState, listens to popstate and hashchange
 * 3. Hash routing only (fallback) - listens to hashchange events when History API is unavailable
 *
 * The plugin handles edge cases gracefully:
 * - Missing or null location objects
 * - Undefined, null, or empty location.href values
 * - Temporal dead zone issues with variable declarations
 * - Consistent URL normalization across all code paths
 *
 * @param options Configuration options for URL tracking
 * @returns RecordPlugin instance that can be used with rrweb
 */
function createUrlTrackingPlugin(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'amplitude/url-tracking@1',
    observer: function (cb, globalScope, pluginOptions) {
      var _a, _b, _c;
      // Merge options with plugin-level options taking precedence over constructor options
      var config = _assign$(_assign$({}, options), pluginOptions);
      var ugcFilterRules = config.ugcFilterRules || [];
      var enablePolling = (_a = config.enablePolling) !== null && _a !== void 0 ? _a : false;
      var pollingInterval = (_b = config.pollingInterval) !== null && _b !== void 0 ? _b : DEFAULT_URL_CHANGE_POLLING_INTERVAL;
      var captureDocumentTitle = (_c = config.captureDocumentTitle) !== null && _c !== void 0 ? _c : false;
      // Early return if no global scope is available
      if (!globalScope) {
        return function () {
          // No cleanup needed if no global scope available
        };
      }
      // Track the last URL to prevent duplicate events
      // Initialize to undefined to ensure first call always emits an event
      var lastTrackedUrl = undefined;
      // Helper functions
      /**
       * Gets the current URL with proper normalization
       * Handles edge cases where location.href might be undefined, null, or empty
       * Ensures consistent behavior across all code paths
       * @returns Normalized URL string (empty string if location unavailable)
       */
      var getCurrentUrl = function getCurrentUrl() {
        if (!globalScope.location) return '';
        return globalScope.location.href || '';
      };
      /**
       * Creates a URL change event with current page information
       * Applies UGC filtering if rules are configured
       * Uses getCurrentUrl() for consistent URL normalization
       * @returns URLChangeEvent with current page state
       */
      var createUrlChangeEvent = function createUrlChangeEvent() {
        var innerHeight = globalScope.innerHeight,
          innerWidth = globalScope.innerWidth,
          document = globalScope.document;
        var currentUrl = getCurrentUrl();
        var currentTitle = '';
        if (captureDocumentTitle) {
          currentTitle = (document === null || document === void 0 ? void 0 : document.title) || '';
        }
        // Apply UGC filtering if rules are provided, otherwise use original URL
        var filteredUrl = ugcFilterRules.length > 0 ? getPageUrl(currentUrl, ugcFilterRules) : currentUrl;
        return {
          href: filteredUrl,
          title: currentTitle,
          viewportHeight: innerHeight,
          viewportWidth: innerWidth,
          type: 'url-change-event'
        };
      };
      /**
       * Emits a URL change event if the URL has actually changed
       * Always emits on first call (when lastTrackedUrl is undefined)
       */
      var emitUrlChange = function emitUrlChange() {
        var currentUrl = getCurrentUrl();
        if (lastTrackedUrl === undefined || currentUrl !== lastTrackedUrl) {
          lastTrackedUrl = currentUrl;
          var event_1 = createUrlChangeEvent();
          cb(event_1);
        }
      };
      // Single helper: history + popstate + hashchange, or polling when enabled
      var unsubscribe = subscribeToUrlChanges(globalScope, function () {
        return emitUrlChange();
      }, enablePolling ? {
        enablePolling: true,
        pollingInterval: pollingInterval
      } : {});
      emitUrlChange();
      return function () {
        return unsubscribe();
      };
    },
    options: options
  };
}
/**
 * Default URL tracking plugin instance with default options
 * Can be used directly without custom configuration
 */
createUrlTrackingPlugin();
function isInIframe() {
  try {
    var globalScope = getGlobalScope();
    if (!globalScope) {
      return false;
    }
    return globalScope.parent !== globalScope;
  } catch (_a) {
    // SecurityError accessing window.parent in some sandboxed environments
    return true;
  }
}
/**
 * Manages the parent side of cross-origin iframe recording coordination.
 *
 * When the parent starts recording, it sends a start signal to all current child
 * iframes and watches for dynamically added iframes via MutationObserver. When the
 * parent stops, it sends a stop signal.
 */
var CrossOriginIframeCoordinator = /** @class */function () {
  function CrossOriginIframeCoordinator() {
    // Tracks pending load listeners for dynamically added iframes so stop() can cancel them.
    this.pendingLoadListeners = new Map();
  }
  CrossOriginIframeCoordinator.prototype.start = function () {
    var _this = this;
    var _a;
    (_a = this.mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect(); // guard against double-start
    var globalScope = getGlobalScope();
    if (!globalScope) {
      return;
    }
    this.sendToAllIframes({
      type: CROSS_ORIGIN_IFRAME_MESSAGE_TYPE,
      action: 'start'
    });
    this.mutationObserver = new MutationObserver(function (mutations) {
      var e_1, _a, e_2, _b, e_3, _c;
      try {
        for (var mutations_1 = __values$1(mutations), mutations_1_1 = mutations_1.next(); !mutations_1_1.done; mutations_1_1 = mutations_1.next()) {
          var mutation = mutations_1_1.value;
          try {
            for (var _d = (e_2 = void 0, __values$1(Array.from(mutation.addedNodes))), _e = _d.next(); !_e.done; _e = _d.next()) {
              var node = _e.value;
              if (node instanceof HTMLIFrameElement) {
                // Send the start signal after the child page has loaded, not at insertion
                // time. At insertion the contentWindow is still about:blank; the message
                // sent there is discarded when the iframe navigates to its src, and the
                // child SDK never receives it.
                _this.sendToIframeAfterLoad(node);
              } else if (node instanceof Element) {
                // A container element (e.g. a React-rendered div) may already have
                // iframe descendants when it is inserted. These iframes do NOT appear
                // in addedNodes — only the container does. Query the subtree so we
                // don't miss them.
                node.querySelectorAll('iframe').forEach(function (iframe) {
                  _this.sendToIframeAfterLoad(iframe);
                });
              }
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
          try {
            for (var _f = (e_3 = void 0, __values$1(Array.from(mutation.removedNodes))), _g = _f.next(); !_g.done; _g = _f.next()) {
              var node = _g.value;
              if (node instanceof HTMLIFrameElement) {
                var listener = _this.pendingLoadListeners.get(node);
                if (listener) {
                  node.removeEventListener('load', listener);
                  _this.pendingLoadListeners.delete(node);
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (mutations_1_1 && !mutations_1_1.done && (_a = mutations_1.return)) _a.call(mutations_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    });
    this.mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };
  CrossOriginIframeCoordinator.prototype.stop = function () {
    var _a;
    (_a = this.mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    this.mutationObserver = undefined;
    // Cancel any start signals that were waiting for a pending iframe load.
    this.pendingLoadListeners.forEach(function (listener, iframe) {
      iframe.removeEventListener('load', listener);
    });
    this.pendingLoadListeners.clear();
    this.sendToAllIframes({
      type: CROSS_ORIGIN_IFRAME_MESSAGE_TYPE,
      action: 'stop'
    });
  };
  CrossOriginIframeCoordinator.prototype.sendToIframeAfterLoad = function (iframe) {
    var _this = this;
    var sendStart = function sendStart() {
      _this.pendingLoadListeners.delete(iframe);
      _this.sendToIframe(iframe, {
        type: CROSS_ORIGIN_IFRAME_MESSAGE_TYPE,
        action: 'start'
      });
    };
    this.pendingLoadListeners.set(iframe, sendStart);
    iframe.addEventListener('load', sendStart, {
      once: true
    });
  };
  CrossOriginIframeCoordinator.prototype.sendToAllIframes = function (message) {
    var _this = this;
    var iframes = document.querySelectorAll('iframe');
    iframes.forEach(function (iframe) {
      return _this.sendToIframe(iframe, message);
    });
  };
  CrossOriginIframeCoordinator.prototype.sendToIframe = function (iframe, message) {
    var _a;
    try {
      (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(message, '*');
    } catch (_b) {
      // Cross-origin postMessage can throw in some sandboxed environments; ignore.
    }
  };
  return CrossOriginIframeCoordinator;
}();
/**
 * Listens for start/stop signals from the parent page and invokes the provided
 * callbacks. Only messages from `window.parent` are accepted.
 *
 * Returns a cleanup function that removes the message listener.
 */
function listenForParentSignals(callbacks) {
  var globalScope = getGlobalScope();
  if (!globalScope) {
    return function () {
      return undefined;
    };
  }
  var parentFrame = globalScope.parent;
  function handler(event) {
    // Only accept messages from the direct parent frame.
    if (event.source !== parentFrame) {
      return;
    }
    var data = event.data;
    if ((data === null || data === void 0 ? void 0 : data.type) !== CROSS_ORIGIN_IFRAME_MESSAGE_TYPE) {
      return;
    }
    if (data.action === 'start') {
      callbacks.onStart();
    } else if (data.action === 'stop') {
      callbacks.onStop();
    }
  }
  globalScope.addEventListener('message', handler);
  return function () {
    return globalScope.removeEventListener('message', handler);
  };
}
var SessionReplay = /** @class */function () {
  function SessionReplay() {
    var _this = this;
    this.name = '@amplitude/session-replay-browser';
    this.recordCancelCallback = null;
    this.eventCount = 0;
    this.sessionTargetingMatch = false;
    // Public on purpose. `pageLeaveFns` is iterated by `pageLeaveListener`,
    // `rrwebEventManager` is dereferenced in `asyncSetSessionId` to drop the beacon buffer
    // at a session boundary, and `sessionStartTime` drives `isBelowMinSessionDuration()`.
    // Tests also stub/inspect these — privatizing them would break both production callers
    // and the gate's test coverage.
    this.pageLeaveFns = [];
    /**
     * Count of sendEvents() calls suppressed by the min-session-duration gate for the
     * current session. Drives the REPLAY_GATE_DECISION rrweb event on first send-after-pass.
     */
    this.suppressedSendCount = 0;
    /** True once REPLAY_GATE_DECISION has been emitted for the current session. */
    this.hasEmittedGateDecision = false;
    // Cache the dynamically imported record function
    this.recordFunction = null;
    this.recordEventsInFlight = false;
    /**
     * When false, capture is paused by a customer `stop()` (or `shutdown()`) call.
     * Focus/targeting/session-change paths still invoke `recordEvents()`, but
     * `getShouldRecord()` will refuse to start rrweb until `start()` or a new `init()`.
     */
    this.recordingEnabled = true;
    /**
     * Bumped by `stop()` / `shutdown()` so an in-flight `_recordEvents()` that already
     * passed `getShouldRecord()` cannot start rrweb after capture was paused.
     */
    this.recordingGeneration = 0;
    /**
     * Set by customer `start()` so coordinated child iframes self-start instead of
     * waiting for a parent signal that may never be resent. Kept until recording
     * actually starts so a gated `start()` (targeting, sampling, remote capture)
     * still self-starts when those gates later pass.
     */
    this.startChildRecordingOnSetup = false;
    this.pendingEmitEvents = [];
    /** Current page URL, kept in sync with SPA navigations for URL-based masking */
    this.currentPageUrl = '';
    this.recordEventsPendingShouldLogMetadata = null;
    /** Cleanup for URL change listener used to re-evaluate targeting on SPA route changes */
    this.urlChangeCleanup = null;
    this.crossOriginIframeCoordinator = null;
    this.crossOriginParentSignalCleanup = null;
    /** Monotonic counter to ignore stale URL-change targeting results */
    this.latestUrlChangeTargetingEvaluationId = 0;
    this.teardownEventListeners = function (teardown) {
      var globalScope = getGlobalScope();
      if (globalScope) {
        globalScope.removeEventListener('blur', _this.blurListener);
        globalScope.removeEventListener('focus', _this.focusListener);
        !teardown && globalScope.addEventListener('blur', _this.blurListener);
        !teardown && globalScope.addEventListener('focus', _this.focusListener);
        // prefer pagehide to unload events, this is the standard going forward. it is not
        // 100% reliable, but is bfcache-compatible.
        if (globalScope.self && 'onpagehide' in globalScope.self) {
          globalScope.removeEventListener('pagehide', _this.pageLeaveListener);
          !teardown && globalScope.addEventListener('pagehide', _this.pageLeaveListener);
        } else {
          // this has performance implications, but is the only way we can reliably send events
          // in browser that don't support pagehide.
          globalScope.removeEventListener('beforeunload', _this.pageLeaveListener);
          !teardown && globalScope.addEventListener('beforeunload', _this.pageLeaveListener);
        }
      }
    };
    this.blurListener = function () {
      _this.sendEvents();
    };
    this.focusListener = function () {
      var _a;
      if (!_this.recordingEnabled) {
        return;
      }
      if (_this.recordCancelCallback && _this.recordFunction) {
        // Recording is already active. The on-focus full snapshot is tunable: when
        // `captureFullSnapshotOnFocus` is false we skip it entirely so high focus-churn pages
        // don't generate a full snapshot (and, with eager send, a network request) per focus.
        if (((_a = _this.config) === null || _a === void 0 ? void 0 : _a.captureFullSnapshotOnFocus) === false) {
          return;
        }
        try {
          _this.recordFunction.takeFullSnapshot(true);
        } catch (error) {
          _this.loggerProvider.warn('Failed to take full snapshot on focus:', error);
        }
      } else if (!_this.recordEventsInFlight) {
        void _this.recordEvents(false);
      }
    };
    /**
     * This is an instance member so that if init is called multiple times
     * it doesn't add another listener to the page leave event. This is to
     * prevent duplicate listener actions from firing.
     */
    this.pageLeaveListener = function (e) {
      var _a;
      // Synchronously drain any events still queued in the requestIdleCallback
      // pipeline so they are available to send before the page unloads.
      (_a = _this.eventCompressor) === null || _a === void 0 ? void 0 : _a.flushQueue();
      _this.sendEvents();
      _this.pageLeaveFns.forEach(function (fn) {
        fn(e);
      });
    };
    this.evaluateTargetingAndCapture = function (targetingParams, isInit, forceRestart, forceTargetingReevaluation) {
      if (isInit === void 0) {
        isInit = false;
      }
      if (forceRestart === void 0) {
        forceRestart = false;
      }
      if (forceTargetingReevaluation === void 0) {
        forceTargetingReevaluation = false;
      }
      return __awaiter(_this, void 0, void 0, function () {
        var targetingConfig, shouldReEvaluate, urlChangeEvaluationId, eventForTargeting, pageUrl, pageForTargeting, targetingMatch;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
          switch (_g.label) {
            case 0:
              if (!this.identifiers || !this.identifiers.sessionId || !this.config) {
                if (this.identifiers && !this.identifiers.sessionId) {
                  this.loggerProvider.log('Session ID has not been set yet, cannot evaluate targeting for Session Replay.');
                } else {
                  this.loggerProvider.warn('Session replay init has not been called, cannot evaluate targeting.');
                }
                return [2 /*return*/];
              }
              // Handle cases where there's no targeting config
              if (!this.config.targetingConfig) {
                if (isInit) {
                  this.loggerProvider.log('Targeting config has not been set yet, cannot evaluate targeting.');
                } else {
                  this.loggerProvider.log('No targeting config set, skipping initialization/recording for event.');
                  return [2 /*return*/];
                }
              }
              // Store targeting parameters for use in getShouldRecord
              this.lastTargetingParams = targetingParams;
              targetingConfig = this.config.targetingConfig;
              shouldReEvaluate = targetingConfig && !this.sessionTargetingMatch;
              if (!shouldReEvaluate) return [3 /*break*/, 2];
              urlChangeEvaluationId = forceTargetingReevaluation ? this.latestUrlChangeTargetingEvaluationId : undefined;
              eventForTargeting = targetingParams.event;
              if (eventForTargeting && Object.values(SpecialEventType).includes(eventForTargeting.event_type)) {
                eventForTargeting = undefined;
              }
              pageUrl = (_e = (_b = (_a = targetingParams.page) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : (_d = (_c = getGlobalScope()) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.href) !== null && _e !== void 0 ? _e : '';
              pageForTargeting = (_f = targetingParams.page) !== null && _f !== void 0 ? _f : pageUrl !== '' ? {
                url: pageUrl
              } : undefined;
              return [4 /*yield*/, evaluateTargetingAndStore({
                sessionId: this.identifiers.sessionId,
                targetingConfig: targetingConfig,
                loggerProvider: this.loggerProvider,
                apiKey: this.config.apiKey,
                targetingParams: {
                  userProperties: targetingParams.userProperties,
                  event: eventForTargeting,
                  page: pageForTargeting
                },
                urlChange: forceTargetingReevaluation
              })];
            case 1:
              targetingMatch = _g.sent();
              if (forceTargetingReevaluation && urlChangeEvaluationId !== undefined && urlChangeEvaluationId !== this.latestUrlChangeTargetingEvaluationId) {
                this.loggerProvider.debug("Ignoring stale URL-change targeting result #".concat(urlChangeEvaluationId, "; latest is #").concat(this.latestUrlChangeTargetingEvaluationId, "."));
                return [2 /*return*/];
              }
              // Keep targeting match monotonic within a session: once true, always true.
              // This avoids races where an older in-flight evaluation resolves false after
              // a newer evaluation already resolved true.
              this.sessionTargetingMatch = this.sessionTargetingMatch || targetingMatch;
              this.loggerProvider.debug(JSON.stringify({
                name: 'targeted replay capture config',
                sessionTargetingMatch: this.sessionTargetingMatch,
                event: eventForTargeting,
                targetingParams: targetingParams
              }, null, 2));
              _g.label = 2;
            case 2:
              if (!isInit) return [3 /*break*/, 3];
              void this.initialize(true);
              return [3 /*break*/, 5];
            case 3:
              if (!(forceRestart || !this.recordCancelCallback)) return [3 /*break*/, 5];
              this.loggerProvider.log('Recording events for session due to forceRestart or no ongoing recording.');
              return [4 /*yield*/, this.recordEvents()];
            case 4:
              _g.sent();
              _g.label = 5;
            case 5:
              return [2 /*return*/];
          }
        });
      });
    };
    this.addCustomRRWebEvent = function (eventName, eventData, addStorageInfo) {
      if (eventData === void 0) {
        eventData = {};
      }
      if (addStorageInfo === void 0) {
        addStorageInfo = true;
      }
      return __awaiter(_this, void 0, void 0, function () {
        var debugInfo, config, storageSizeData, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 3,, 4]);
              debugInfo = undefined;
              config = this.config;
              if (!(config && eventName !== CustomRRwebEvent.METADATA)) return [3 /*break*/, 2];
              debugInfo = {
                config: getDebugConfig(config),
                version: VERSION
              };
              if (!addStorageInfo) return [3 /*break*/, 2];
              return [4 /*yield*/, getStorageSize()];
            case 1:
              storageSizeData = _a.sent();
              debugInfo = _assign$(_assign$({}, storageSizeData), debugInfo);
              _a.label = 2;
            case 2:
              // Check first to ensure we are recording
              if (this.recordCancelCallback && this.recordFunction) {
                this.recordFunction.addCustomEvent(eventName, _assign$(_assign$({}, eventData), debugInfo));
              } else {
                this.loggerProvider.debug("Not able to add custom replay capture event ".concat(eventName, " due to no ongoing recording."));
              }
              return [3 /*break*/, 4];
            case 3:
              e_1 = _a.sent();
              this.loggerProvider.debug('Error while adding custom replay capture event: ', e_1);
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    this.stopRecordingEvents = function () {
      var _a, _b, _c;
      try {
        _this.loggerProvider.log('Session Replay capture stopping.');
        _this.recordCancelCallback && _this.recordCancelCallback();
        _this.recordCancelCallback = null;
        (_a = _this.networkObservers) === null || _a === void 0 ? void 0 : _a.stop();
        (_b = _this.crossOriginIframeCoordinator) === null || _b === void 0 ? void 0 : _b.stop();
        _this.crossOriginIframeCoordinator = null;
        // Remove the child-mode parent signal listener so a later mode change
        // (e.g. crossOriginIframes disabled) does not leave a stale listener.
        (_c = _this.crossOriginParentSignalCleanup) === null || _c === void 0 ? void 0 : _c.call(_this);
        _this.crossOriginParentSignalCleanup = null;
      } catch (error) {
        var typedError = error;
        _this.loggerProvider.warn("Error occurred while stopping replay capture: ".concat(typedError.toString()));
      }
    };
    this.loggerProvider = new SafeLoggerProvider(new Logger());
  }
  SessionReplay.prototype.init = function (apiKey, options) {
    return returnWrapper(this._init(apiKey, options));
  };
  /**
   * Subscribes to SPA URL changes via the URL tracking plugin. Always keeps
   * `currentPageUrl` in sync (needed for URL-based masking). When a targeting
   * config is present it also re-evaluates targeting on every navigation.
   */
  SessionReplay.prototype.setupUrlChangeListener = function () {
    var _this = this;
    var _a, _b;
    // If init() runs multiple times, remove the previous URL-change subscription first
    // so we don't leak callbacks and trigger duplicate targeting evaluations.
    (_a = this.urlChangeCleanup) === null || _a === void 0 ? void 0 : _a.call(this);
    var globalScope = getGlobalScope();
    if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.location)) {
      return;
    }
    var hasTargeting = !!((_b = this.config) === null || _b === void 0 ? void 0 : _b.targetingConfig);
    var onUrlChange = function onUrlChange(href) {
      _this.currentPageUrl = href;
      if (hasTargeting) {
        var evaluationId = ++_this.latestUrlChangeTargetingEvaluationId;
        void _this.evaluateTargetingAndCapture({
          userProperties: {},
          event: undefined,
          page: {
            url: href
          }
        }, false, false, true);
        _this.loggerProvider.debug("Queued URL-change targeting re-evaluation #".concat(evaluationId, " for ").concat(href, "."));
      }
    };
    var unsubscribe = subscribeToUrlChanges(globalScope, onUrlChange);
    this.urlChangeCleanup = function () {
      unsubscribe();
      _this.urlChangeCleanup = null;
    };
  };
  /**
   * Single source of truth for the min_session_duration_ms gate. Returns true when the
   * current session has not yet reached the configured threshold (and we have both a
   * configured value and a recorded start time). Returns false when there's no
   * threshold, no recorded start time, or the threshold has been met — i.e. it
   * answers "should this batch be suppressed?".
   *
   * Centralizing the check means future changes (clock-skew tolerance, switching to
   * performance.now(), etc.) are one-line edits.
   */
  SessionReplay.prototype.isBelowMinSessionDuration = function () {
    var _a;
    var minSessionDurationMs = (_a = this.config) === null || _a === void 0 ? void 0 : _a.minSessionDurationMs;
    if (minSessionDurationMs === undefined || this.sessionStartTime === undefined) {
      return false;
    }
    return Date.now() - this.sessionStartTime < minSessionDurationMs;
  };
  SessionReplay.prototype.getCurrentPageForTargeting = function () {
    var _a, _b;
    var currentUrl = (_b = (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.href;
    return currentUrl != null ? {
      url: currentUrl
    } : undefined;
  };
  SessionReplay.prototype._init = function (apiKey, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _m, _o, _p;
    return __awaiter(this, void 0, void 0, function () {
      var now, _q, _r, joinedConfig, localConfig, remoteConfig, scrollWatcher, managers, storeType, compressionWorkerScript, trackDestinationWorkerScript, globalScope, _s, compressionScript, trackDestinationScript, rrwebEventManager, error_1, typedError, payloadBatcher, interactionEventManager, error_2, typedError, onFullSnapshotProcessed, pending_2, pending_1, pending_1_1, _t, event_1, sessionId, needsUrlTracking;
      var e_2, _u;
      var _this = this;
      return __generator(this, function (_v) {
        switch (_v.label) {
          case 0:
            // Re-init should always tear down any previous URL-change subscription, even when the
            // next config has no targeting config and we don't subscribe again.
            (_a = this.urlChangeCleanup) === null || _a === void 0 ? void 0 : _a.call(this);
            // A new init always allows capture again. `stop()` only pauses the current instance.
            this.recordingEnabled = true;
            this.startChildRecordingOnSetup = false;
            this.loggerProvider = new SafeLoggerProvider(options.loggerProvider || new Logger());
            Object.prototype.hasOwnProperty.call(options, 'logLevel') && this.loggerProvider.enable(options.logLevel);
            this.currentPageUrl = getCurrentUrl();
            this.identifiers = new SessionIdentifiers({
              sessionId: options.sessionId,
              deviceId: options.deviceId
            });
            now = Date.now();
            pruneStaleReplayStartTimes(apiKey, now, this.loggerProvider);
            this.sessionStartTime = options.sessionId !== undefined ? (_b = getOrInitReplayStartTime(apiKey, options.sessionId, now, this.loggerProvider)) !== null && _b !== void 0 ? _b : now : now;
            _q = this;
            return [4 /*yield*/, createSessionReplayJoinedConfigGenerator(apiKey, options)];
          case 1:
            _q.joinedConfigGenerator = _v.sent();
            return [4 /*yield*/, this.joinedConfigGenerator.generateJoinedConfig()];
          case 2:
            _r = _v.sent(), joinedConfig = _r.joinedConfig, localConfig = _r.localConfig, remoteConfig = _r.remoteConfig;
            this.config = joinedConfig;
            this.setMetadata(options.sessionId, joinedConfig, localConfig, remoteConfig, (_c = options.version) === null || _c === void 0 ? void 0 : _c.version, VERSION, (_d = options.version) === null || _d === void 0 ? void 0 : _d.type);
            this.pageLeaveFns = [];
            if (options.sessionId && ((_e = this.config.interactionConfig) === null || _e === void 0 ? void 0 : _e.enabled)) {
              scrollWatcher = ScrollWatcher.default({
                sessionId: options.sessionId,
                type: 'interaction'
              }, this.config);
              this.pageLeaveFns = [scrollWatcher.send(this.getDeviceId.bind(this)).bind(scrollWatcher)];
              this.scrollHook = scrollWatcher.hook.bind(scrollWatcher);
              this.clickHandler = new ClickHandler(this.loggerProvider, scrollWatcher);
            }
            managers = [];
            storeType = this.config.storeType;
            if (storeType === 'idb' && !((_f = getGlobalScope()) === null || _f === void 0 ? void 0 : _f.indexedDB)) {
              storeType = 'memory';
              this.loggerProvider.warn('Could not use preferred indexedDB storage, reverting to in memory option.');
            }
            this.loggerProvider.log("Using ".concat(storeType, " for event storage."));
            globalScope = getGlobalScope();
            if (!(this.config.useWebWorker && globalScope && globalScope.Worker)) return [3 /*break*/, 4];
            return [4 /*yield*/, import('./index-lZzS62gh.js')];
          case 3:
            _s = _v.sent(), compressionScript = _s.compressionScript, trackDestinationScript = _s.trackDestinationScript;
            compressionWorkerScript = compressionScript;
            trackDestinationWorkerScript = trackDestinationScript;
            _v.label = 4;
          case 4:
            _v.trys.push([4, 6,, 7]);
            return [4 /*yield*/, createEventsManager({
              config: this.config,
              type: 'replay',
              minInterval: (_g = this.config.flushIntervalConfig) === null || _g === void 0 ? void 0 : _g.minIntervalMs,
              maxInterval: (_h = this.config.flushIntervalConfig) === null || _h === void 0 ? void 0 : _h.maxIntervalMs,
              maxPersistedEventsSize: this.config.maxPersistedEventsSizeBytes,
              storeType: storeType,
              trackDestinationWorkerScript: trackDestinationWorkerScript,
              shouldSend: function () {
                return !_this.isBelowMinSessionDuration();
              }
            })];
          case 5:
            rrwebEventManager = _v.sent();
            this.rrwebEventManager = rrwebEventManager;
            managers.push({
              name: 'replay',
              manager: rrwebEventManager
            });
            return [3 /*break*/, 7];
          case 6:
            error_1 = _v.sent();
            typedError = error_1;
            this.loggerProvider.warn("Error occurred while creating replay events manager: ".concat(typedError.toString()));
            return [3 /*break*/, 7];
          case 7:
            if (!((_j = this.config.interactionConfig) === null || _j === void 0 ? void 0 : _j.enabled)) return [3 /*break*/, 11];
            payloadBatcher = this.config.interactionConfig.batch ? clickBatcher : clickNonBatcher;
            _v.label = 8;
          case 8:
            _v.trys.push([8, 10,, 11]);
            return [4 /*yield*/, createEventsManager({
              config: this.config,
              type: 'interaction',
              minInterval: (_k = this.config.interactionConfig.trackEveryNms) !== null && _k !== void 0 ? _k : INTERACTION_MIN_INTERVAL,
              maxInterval: INTERACTION_MAX_INTERVAL,
              maxPersistedEventsSize: this.config.maxPersistedEventsSizeBytes,
              payloadBatcher: payloadBatcher,
              storeType: storeType,
              trackDestinationWorkerScript: trackDestinationWorkerScript
            })];
          case 9:
            interactionEventManager = _v.sent();
            managers.push({
              name: 'interaction',
              manager: interactionEventManager
            });
            return [3 /*break*/, 11];
          case 10:
            error_2 = _v.sent();
            typedError = error_2;
            this.loggerProvider.warn("Error occurred while creating interaction events manager: ".concat(typedError.toString()));
            return [3 /*break*/, 11];
          case 11:
            this.eventsManager = new (MultiEventManager.bind.apply(MultiEventManager, __spreadArray([void 0], __read$1(managers), false)))();
            // To prevent too many threads.
            if (this.eventCompressor) {
              this.eventCompressor.terminate();
            }
            onFullSnapshotProcessed = this.config.eagerFullSnapshotSend === true ? function () {
              return _this.sendEvents();
            } : undefined;
            this.eventCompressor = new EventCompressor(this.eventsManager, this.config, this.getDeviceId(), compressionWorkerScript, onFullSnapshotProcessed);
            // Flush any events that arrived while eventCompressor was not yet ready
            // (e.g. a concurrent setSessionId() call that raced _init()'s async setup).
            if (this.pendingEmitEvents.length > 0) {
              pending_2 = this.pendingEmitEvents.splice(0);
              try {
                for (pending_1 = __values$1(pending_2), pending_1_1 = pending_1.next(); !pending_1_1.done; pending_1_1 = pending_1.next()) {
                  _t = pending_1_1.value, event_1 = _t.event, sessionId = _t.sessionId;
                  this.eventCompressor.enqueueEvent(event_1, sessionId);
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (pending_1_1 && !pending_1_1.done && (_u = pending_1.return)) _u.call(pending_1);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }
            }
            // Register beacon fallback for page exit. sendBeacon survives page unload
            // and delivers any incremental events that haven't been flushed via fetch yet.
            //
            // Known cross-session race: if asyncSetSessionId fired and its async
            // storeCurrentSequence hasn't resolved before unload, the beacon buffer can still
            // hold previous-session events. The gate below reads the *new* session's
            // sessionStartTime, so legitimately-sendable old-session events get suppressed.
            // Follow-up: track start time per buffered batch instead of globally.
            this.pageLeaveFns = __spreadArray(__spreadArray([], __read$1(this.pageLeaveFns), false), [function () {
              var _a;
              if (!_this.config || !((_a = _this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId) || !rrwebEventManager) return;
              var events = rrwebEventManager.getBeaconEvents();
              if (!events.length) return;
              var deviceId = _this.getDeviceId();
              if (!deviceId) return;
              if (_this.isBelowMinSessionDuration()) return;
              rrwebEventManager.trackDestination.sendBeacon({
                events: events,
                sessionId: _this.identifiers.sessionId,
                deviceId: deviceId,
                apiKey: _this.config.apiKey,
                serverZone: _this.config.serverZone
              });
            }], false);
            return [4 /*yield*/, this.initializeNetworkObservers()];
          case 12:
            _v.sent();
            this.loggerProvider.log('Installing @amplitude/session-replay-browser.');
            this.teardownEventListeners(false);
            return [4 /*yield*/, this.evaluateTargetingAndCapture({
              userProperties: options.userProperties,
              page: this.getCurrentPageForTargeting()
            }, true)];
          case 13:
            _v.sent();
            needsUrlTracking = this.config.targetingConfig || ((_p = (_o = (_m = this.config.privacyConfig) === null || _m === void 0 ? void 0 : _m.urlMaskLevels) === null || _o === void 0 ? void 0 : _o.length) !== null && _p !== void 0 ? _p : 0) > 0;
            if (needsUrlTracking) {
              this.setupUrlChangeListener();
            }
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.setSessionId = function (sessionId, deviceId) {
    return returnWrapper(this.asyncSetSessionId(sessionId, deviceId));
  };
  SessionReplay.prototype.asyncSetSessionId = function (sessionId, deviceId, options) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
      var previousSessionId, currentDeviceId, isSessionChange, deviceIdForReplayId, joinedConfig;
      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            previousSessionId = (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
            currentDeviceId = this.getDeviceId();
            // Standalone SDK callers may poll setSessionId with a stable bucket id (e.g. hour-aligned
            // timestamps) and only need a no-op when the bucket hasn't rolled. Without this guard,
            // the rest of asyncSetSessionId still runs: sendEvents, targeting reset, config refetch,
            // and recordEvents (stop + restart rrweb). Proceed when deviceId changes or
            // non-empty userProperties are passed so targeting can re-evaluate on Identify.
            if (previousSessionId !== undefined && previousSessionId === sessionId && (deviceId === undefined || deviceId === currentDeviceId) && ((options === null || options === void 0 ? void 0 : options.userProperties) === undefined || Object.keys(options.userProperties).length === 0)) {
              return [2 /*return*/];
            }
            // Invalidate any in-flight URL-change re-evaluations from the previous session.
            this.latestUrlChangeTargetingEvaluationId++;
            this.sessionTargetingMatch = false;
            this.lastShouldRecordDecision = undefined; // Reset targeting decision for new session
            if (previousSessionId) {
              this.sendEvents(previousSessionId);
            }
            isSessionChange = previousSessionId !== sessionId;
            // Drop any beacon-buffered events from the previous session BEFORE installing the
            // new identifiers / start time. Otherwise the page-leave beacon path could attribute
            // old-session events to the new session id, and the gate (using the new start time)
            // would compute the wrong elapsed duration. Skip on a redundant same-sessionId call —
            // the buffer belongs to the *continuing* session and should ship via beacon as normal.
            if (isSessionChange) {
              (_b = this.rrwebEventManager) === null || _b === void 0 ? void 0 : _b.dropPendingBeaconEvents();
            }
            deviceIdForReplayId = deviceId || this.getDeviceId();
            this.identifiers = new SessionIdentifiers({
              sessionId: sessionId,
              deviceId: deviceIdForReplayId
            });
            // Gate state and persisted start time only get reset on an actual session boundary.
            // A redundant setSessionId(currentId) call would otherwise overwrite both the in-memory
            // and stored start time with a fresh Date.now() — restarting the gate clock for what is
            // supposed to be a continuing session.
            if (isSessionChange) {
              this.sessionStartTime = Date.now();
              this.suppressedSendCount = 0;
              this.hasEmittedGateDecision = false;
              if ((_c = this.config) === null || _c === void 0 ? void 0 : _c.apiKey) {
                setReplayStartTime(this.config.apiKey, sessionId, this.sessionStartTime, this.loggerProvider);
                if (previousSessionId !== undefined) {
                  removeReplayStartTime(this.config.apiKey, previousSessionId, this.loggerProvider);
                }
              }
            }
            if (!(this.joinedConfigGenerator && previousSessionId)) return [3 /*break*/, 2];
            return [4 /*yield*/, this.joinedConfigGenerator.generateJoinedConfig()];
          case 1:
            joinedConfig = _e.sent().joinedConfig;
            this.config = joinedConfig;
            _e.label = 2;
          case 2:
            if (!((_d = this.config) === null || _d === void 0 ? void 0 : _d.targetingConfig)) return [3 /*break*/, 4];
            return [4 /*yield*/, this.evaluateTargetingAndCapture({
              userProperties: options === null || options === void 0 ? void 0 : options.userProperties,
              page: this.getCurrentPageForTargeting()
            }, false, true)];
          case 3:
            _e.sent();
            return [3 /*break*/, 6];
          case 4:
            return [4 /*yield*/, this.recordEvents()];
          case 5:
            _e.sent();
            _e.label = 6;
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.getSessionReplayProperties = function () {
    var _a;
    var config = this.config;
    var identifiers = this.identifiers;
    if (!config || !identifiers) {
      this.loggerProvider.warn('Session replay init has not been called, cannot get session replay properties.');
      return {};
    }
    var shouldRecord = this.getShouldRecord();
    var eventProperties = {};
    if (shouldRecord) {
      eventProperties = (_a = {}, _a[DEFAULT_SESSION_REPLAY_PROPERTY] = identifiers.sessionReplayId ? identifiers.sessionReplayId : null, _a);
      if (config.debugMode) {
        eventProperties[SESSION_REPLAY_DEBUG_PROPERTY] = JSON.stringify({
          appHash: generateHashCode(config.apiKey).toString()
        });
      }
    }
    void this.addCustomRRWebEvent(CustomRRwebEvent.GET_SR_PROPS, {
      shouldRecord: shouldRecord,
      eventProperties: eventProperties
    }, this.eventCount === 10);
    if (this.eventCount === 10) {
      this.eventCount = 0;
    }
    this.eventCount++;
    return eventProperties;
  };
  SessionReplay.prototype.sendEvents = function (sessionId) {
    var _a, _b;
    var sessionIdToSend = sessionId || ((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId);
    var deviceId = this.getDeviceId();
    if (this.eventsManager && sessionIdToSend && deviceId) {
      if (this.isBelowMinSessionDuration()) {
        // Safe to dereference: isBelowMinSessionDuration() only returns true when both
        // this.config and this.sessionStartTime are defined.
        var startTime = this.sessionStartTime;
        var minMs = this.config.minSessionDurationMs;
        this.loggerProvider.log("Session ".concat(sessionIdToSend, " not sent: duration ").concat(Date.now() - startTime, "ms is below minimum ").concat(minMs, "ms."));
        // We deliberately do NOT clear the beacon buffer here. Blur/visibility-change
        // can call sendEvents() mid-session; if the session later crosses the threshold
        // those buffered events are legitimately sendable via beacon on page exit.
        // Cross-session leak is prevented in asyncSetSessionId, which drops the buffer
        // at the session transition. The page-leave path also gates independently.
        this.suppressedSendCount++;
        return;
      }
      // On the first send-after-pass for the session, emit a custom rrweb event so the
      // payload itself carries the gate verdict. Lets backend ingestion diff intended
      // vs actual replay counts to spot start-time-tracking regressions.
      //
      // Gate on recording being active too: addCustomRRWebEvent is a no-op when
      // recordCancelCallback/recordFunction aren't set yet (e.g. a blur-listener-fired
      // sendEvents reaches us before _recordEvents() activates on a reloaded long-lived
      // session). Tripping hasEmittedGateDecision unconditionally would lose the signal
      // for that session's first real send.
      if (!this.hasEmittedGateDecision && ((_b = this.config) === null || _b === void 0 ? void 0 : _b.minSessionDurationMs) !== undefined && this.recordCancelCallback && this.recordFunction) {
        this.hasEmittedGateDecision = true;
        var elapsedMs = this.sessionStartTime !== undefined ? Date.now() - this.sessionStartTime : undefined;
        void this.addCustomRRWebEvent(CustomRRwebEvent.REPLAY_GATE_DECISION, {
          sessionId: sessionIdToSend,
          suppressedSendCount: this.suppressedSendCount,
          elapsedMs: elapsedMs,
          minSessionDurationMs: this.config.minSessionDurationMs
        }, false);
      }
      this.eventsManager.sendCurrentSequenceEvents({
        sessionId: sessionIdToSend,
        deviceId: deviceId
      });
    }
  };
  SessionReplay.prototype.initialize = function (shouldSendStoredEvents) {
    var _a;
    if (shouldSendStoredEvents === void 0) {
      shouldSendStoredEvents = false;
    }
    return __awaiter(this, void 0, void 0, function () {
      var deviceId;
      return __generator(this, function (_b) {
        if (!((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId)) {
          this.loggerProvider.log("Session is not being recorded due to lack of session id.");
          return [2 /*return*/, Promise.resolve()];
        }
        deviceId = this.getDeviceId();
        if (!deviceId) {
          this.loggerProvider.log("Session is not being recorded due to lack of device id.");
          return [2 /*return*/, Promise.resolve()];
        }
        this.eventsManager && shouldSendStoredEvents && void this.eventsManager.sendStoredEvents({
          deviceId: deviceId
        });
        return [2 /*return*/, this.recordEvents()];
      });
    });
  };
  SessionReplay.prototype.shouldOptOut = function () {
    var _a, _b;
    var identityStoreOptOut;
    if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceName) {
      var identityStore = getAnalyticsConnector(this.config.instanceName).identityStore;
      identityStoreOptOut = identityStore.getIdentity().optOut;
    }
    return identityStoreOptOut !== undefined ? identityStoreOptOut : (_b = this.config) === null || _b === void 0 ? void 0 : _b.optOut;
  };
  SessionReplay.prototype.getShouldRecord = function () {
    if (!this.identifiers || !this.config || !this.identifiers.sessionId) {
      this.loggerProvider.warn("Session is not being recorded due to lack of config, please call sessionReplay.init.");
      return false;
    }
    if (!this.recordingEnabled) {
      this.loggerProvider.log("Session ".concat(this.identifiers.sessionId, " not being captured because recording was stopped."));
      return false;
    }
    if (!this.config.captureEnabled) {
      this.loggerProvider.log("Session ".concat(this.identifiers.sessionId, " not being captured due to capture being disabled for project or because the remote config could not be fetched."));
      return false;
    }
    if (this.shouldOptOut()) {
      this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to optOut config."));
      return false;
    }
    var shouldRecord = false;
    var message = '';
    var matched = false;
    // If targetingConfig exists, we'll use the sessionTargetingMatch to determine whether to record
    // Otherwise, we'll evaluate the session against the overall sample rate
    if (this.config.targetingConfig) {
      if (!this.sessionTargetingMatch) {
        message = "Not capturing replays for session ".concat(this.identifiers.sessionId, " due to not matching targeting conditions.");
        this.loggerProvider.log(message);
        shouldRecord = false;
        matched = false;
      } else {
        message = "Capturing replays for session ".concat(this.identifiers.sessionId, " due to matching targeting conditions.");
        this.loggerProvider.log(message);
        shouldRecord = true;
        matched = true;
      }
    } else {
      var isInSample = isSessionInSample(this.identifiers.sessionId, this.config.sampleRate);
      if (!isInSample) {
        message = "Opting session ".concat(this.identifiers.sessionId, " out of recording due to sample rate.");
        this.loggerProvider.log(message);
        shouldRecord = false;
        matched = false;
      } else {
        shouldRecord = true;
        matched = true;
      }
    }
    // Only send custom rrweb event for targeting decision when the decision changes
    if (this.lastShouldRecordDecision !== shouldRecord && this.config.targetingConfig) {
      void this.addCustomRRWebEvent(CustomRRwebEvent.TARGETING_DECISION, {
        message: message,
        sessionId: this.identifiers.sessionId,
        matched: matched,
        targetingParams: this.lastTargetingParams
      });
      this.lastShouldRecordDecision = shouldRecord;
    }
    return shouldRecord;
  };
  SessionReplay.prototype.getBlockSelectors = function () {
    var _a;
    return getBlockSelectors((_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig);
  };
  SessionReplay.prototype.getMaskTextSelectors = function () {
    var _a;
    return getMaskTextSelectors((_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig, this.currentPageUrl);
  };
  SessionReplay.prototype.getRecordingPlugins = function (loggingConfig) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
      var plugins, urlTrackingPlugin, getRecordConsolePlugin, error_3;
      return __generator(this, function (_g) {
        switch (_g.label) {
          case 0:
            plugins = [];
            // Add URL tracking plugin
            try {
              urlTrackingPlugin = createUrlTrackingPlugin({
                ugcFilterRules: ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.interactionConfig) === null || _b === void 0 ? void 0 : _b.ugcFilterRules) || [],
                enablePolling: ((_c = this.config) === null || _c === void 0 ? void 0 : _c.enableUrlChangePolling) || false,
                pollingInterval: (_d = this.config) === null || _d === void 0 ? void 0 : _d.urlChangePollingInterval,
                captureDocumentTitle: (_e = this.config) === null || _e === void 0 ? void 0 : _e.captureDocumentTitle
              });
              plugins.push(urlTrackingPlugin);
            } catch (error) {
              this.loggerProvider.warn('Failed to create URL tracking plugin:', error);
            }
            if (!((_f = loggingConfig === null || loggingConfig === void 0 ? void 0 : loggingConfig.console) === null || _f === void 0 ? void 0 : _f.enabled)) return [3 /*break*/, 4];
            _g.label = 1;
          case 1:
            _g.trys.push([1, 3,, 4]);
            return [4 /*yield*/, import('./rrweb-plugin-console-record-CltwTtdf.js')];
          case 2:
            getRecordConsolePlugin = _g.sent().getRecordConsolePlugin;
            plugins.push(getRecordConsolePlugin({
              level: loggingConfig.console.levels
            }));
            return [3 /*break*/, 4];
          case 3:
            error_3 = _g.sent();
            this.loggerProvider.warn('Failed to load console plugin:', error_3);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/, plugins.length > 0 ? plugins : undefined];
        }
      });
    });
  };
  SessionReplay.prototype.getRecordFunction = function () {
    return __awaiter(this, void 0, void 0, function () {
      var record, error_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.recordFunction) {
              return [2 /*return*/, this.recordFunction];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, import('./rrweb-record-CJLiy8br.js')];
          case 2:
            record = _a.sent().record;
            this.recordFunction = record;
            return [2 /*return*/, record];
          case 3:
            error_4 = _a.sent();
            this.loggerProvider.warn('Failed to load rrweb-record module:', error_4);
            return [2 /*return*/, null];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.recordEvents = function (shouldLogMetadata) {
    if (shouldLogMetadata === void 0) {
      shouldLogMetadata = true;
    }
    return __awaiter(this, void 0, void 0, function () {
      var pendingArgs;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.recordEventsInFlight) {
              this.recordEventsPendingShouldLogMetadata = shouldLogMetadata;
              return [2 /*return*/];
            }
            this.recordEventsInFlight = true;
            _a.label = 1;
          case 1:
            _a.trys.push([1,, 6, 7]);
            return [4 /*yield*/, this._recordEvents(shouldLogMetadata)];
          case 2:
            _a.sent();
            _a.label = 3;
          case 3:
            if (!(this.recordEventsPendingShouldLogMetadata !== null)) return [3 /*break*/, 5];
            pendingArgs = this.recordEventsPendingShouldLogMetadata;
            this.recordEventsPendingShouldLogMetadata = null;
            return [4 /*yield*/, this._recordEvents(pendingArgs)];
          case 4:
            _a.sent();
            return [3 /*break*/, 3];
          case 5:
            return [3 /*break*/, 7];
          case 6:
            this.recordEventsInFlight = false;
            this.recordEventsPendingShouldLogMetadata = null;
            return [7 /*endfinally*/];
          case 7:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.shouldAbandonRecordStart = function (generation) {
    return !this.recordingEnabled || generation !== this.recordingGeneration;
  };
  SessionReplay.prototype._recordEvents = function (shouldLogMetadata) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (shouldLogMetadata === void 0) {
      shouldLogMetadata = true;
    }
    return __awaiter(this, void 0, void 0, function () {
      var config, shouldRecord, sessionId, generation, recordFunction, networkLoggingConfig, trackUrl, ignoredUrls, interactionConfig, loggingConfig, hooks, ugcFilterRules, crossOriginIframesEnabled, coordinateChildren, childMode, plugins, error_5;
      var _this = this;
      return __generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            config = this.config;
            shouldRecord = this.getShouldRecord();
            sessionId = (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
            if (!shouldRecord || !sessionId || !config) {
              return [2 /*return*/];
            }
            this.stopRecordingEvents();
            generation = this.recordingGeneration;
            return [4 /*yield*/, this.getRecordFunction()];
          case 1:
            recordFunction = _j.sent();
            // May be undefined if cannot import rrweb-record
            if (!recordFunction || this.shouldAbandonRecordStart(generation)) {
              return [2 /*return*/];
            }
            return [4 /*yield*/, this.initializeNetworkObservers()];
          case 2:
            _j.sent();
            if (this.shouldAbandonRecordStart(generation)) {
              return [2 /*return*/];
            }
            networkLoggingConfig = (_b = config.loggingConfig) === null || _b === void 0 ? void 0 : _b.network;
            trackUrl = getServerUrl(config.serverZone, config.trackServerUrl);
            ignoredUrls = [SESSION_REPLAY_SERVER_URL, SESSION_REPLAY_EU_URL, SESSION_REPLAY_STAGING_URL, trackUrl];
            (_c = this.networkObservers) === null || _c === void 0 ? void 0 : _c.start(function (event) {
              if (ignoredUrls.some(function (url) {
                return event.url.startsWith(url);
              })) return;
              void _this.addCustomRRWebEvent(CustomRRwebEvent.FETCH_REQUEST, event);
            }, networkLoggingConfig);
            interactionConfig = config.interactionConfig, loggingConfig = config.loggingConfig;
            hooks = (interactionConfig === null || interactionConfig === void 0 ? void 0 : interactionConfig.enabled) ? {
              mouseInteraction: this.eventsManager && ((_d = this.clickHandler) === null || _d === void 0 ? void 0 : _d.createHook({
                eventsManager: this.eventsManager,
                sessionId: sessionId,
                deviceIdFn: this.getDeviceId.bind(this),
                mirror: recordFunction.mirror,
                ugcFilterRules: (_e = interactionConfig.ugcFilterRules) !== null && _e !== void 0 ? _e : [],
                performanceOptions: (_f = config.performanceConfig) === null || _f === void 0 ? void 0 : _f.interaction
              })),
              scroll: this.scrollHook
            } : {};
            ugcFilterRules = (interactionConfig === null || interactionConfig === void 0 ? void 0 : interactionConfig.enabled) && interactionConfig.ugcFilterRules ? interactionConfig.ugcFilterRules : [];
            this.loggerProvider.log("Session Replay capture beginning for ".concat(sessionId, "."));
            _j.label = 3;
          case 3:
            _j.trys.push([3, 5,, 6]);
            crossOriginIframesEnabled = !!((_g = config.crossOriginIframes) === null || _g === void 0 ? void 0 : _g.enabled);
            coordinateChildren = ((_h = config.crossOriginIframes) === null || _h === void 0 ? void 0 : _h.coordinateChildren) !== false;
            childMode = crossOriginIframesEnabled && isInIframe();
            if (childMode && coordinateChildren) {
              // Child mode: don't self-start; wait for a start signal from the parent.
              // (The previous listener, if any, was already removed by stopRecordingEvents above.)
              this.crossOriginParentSignalCleanup = listenForParentSignals({
                onStart: function () {
                  if (!_this.recordingEnabled) {
                    return;
                  }
                  _this._recordEventsInChildMode(recordFunction, sessionId, config, hooks);
                },
                onStop: function () {
                  try {
                    // Only cancel the rrweb recording — do NOT call stopRecordingEvents() here,
                    // which would clear crossOriginParentSignalCleanup and make the child deaf
                    // to subsequent start/stop cycles from the parent.
                    _this.recordCancelCallback && _this.recordCancelCallback();
                    _this.recordCancelCallback = null;
                  } catch (error) {
                    var typedError = error;
                    _this.loggerProvider.warn("Error occurred while stopping child iframe replay capture: ".concat(typedError.toString()));
                  }
                }
              });
              // Customer start() must not wait for a parent signal: the parent may already
              // be recording and will not send another start. Init still waits.
              if (this.startChildRecordingOnSetup) {
                this.startChildRecordingOnSetup = false;
                this._recordEventsInChildMode(recordFunction, sessionId, config, hooks);
              }
              return [2 /*return*/];
            }
            this.startChildRecordingOnSetup = false;
            return [4 /*yield*/, this.getRecordingPlugins(loggingConfig)];
          case 4:
            plugins = _j.sent();
            if (this.shouldAbandonRecordStart(generation)) {
              return [2 /*return*/];
            }
            this.recordCancelCallback = recordFunction(_assign$(_assign$({}, this.buildRRWebRecordOptions(config, hooks, function (event) {
              if (_this.shouldOptOut() || !_this.recordingEnabled) {
                _this.loggerProvider.log(_this.shouldOptOut() ? "Opting session ".concat(sessionId, " out of recording due to optOut config.") : "Session Replay capture stopping for ".concat(sessionId, "."));
                _this.stopRecordingEvents();
                _this.sendEvents();
                return;
              }
              if (event.type === EventType.Meta) {
                event.data.href = getPageUrl(event.data.href, ugcFilterRules);
              }
              if (_this.eventCompressor) {
                // Schedule processing during idle time if the browser supports requestIdleCallback
                _this.eventCompressor.enqueueEvent(event, sessionId);
              } else {
                // eventCompressor is not yet ready (concurrent call racing _init()).
                // Buffer the event so it can be flushed once the compressor is initialized.
                _this.pendingEmitEvents.push({
                  event: event,
                  sessionId: sessionId
                });
              }
            }, 'Error while capturing replay: ')), {
              plugins: plugins,
              recordCrossOriginIframes: crossOriginIframesEnabled
            }));
            if (crossOriginIframesEnabled && !childMode && coordinateChildren) {
              if (!this.crossOriginIframeCoordinator) {
                this.crossOriginIframeCoordinator = new CrossOriginIframeCoordinator();
              }
              this.crossOriginIframeCoordinator.start();
            }
            void this.addCustomRRWebEvent(CustomRRwebEvent.DEBUG_INFO);
            if (shouldLogMetadata) {
              void this.addCustomRRWebEvent(CustomRRwebEvent.METADATA, this.metadata);
            }
            return [3 /*break*/, 6];
          case 5:
            error_5 = _j.sent();
            this.loggerProvider.warn('Failed to initialize session replay:', error_5);
            return [3 /*break*/, 6];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.buildRRWebRecordOptions = function (config, hooks, emit, errorLogPrefix) {
    var _this = this;
    var privacyConfig = config.privacyConfig;
    return _assign$(_assign$(_assign$(_assign$({
      emit: emit,
      inlineStylesheet: config.shouldInlineStylesheet,
      inlineImages: config.inlineImages,
      hooks: hooks
    }, createPrivacyRecorderOptions(privacyConfig, function () {
      return _this.currentPageUrl;
    })), {
      applyBackgroundColorToBlockedElements: config.applyBackgroundColorToBlockedElements
    }), config.fullSnapshotIntervalMs !== undefined && {
      checkoutEveryNms: config.fullSnapshotIntervalMs
    }), {
      recordCanvas: false,
      captureAdoptedStyleSheets: config.captureAdoptedStyleSheets,
      // Strip nodes that are never rendered by the rrweb replay player.
      // None of these affect visual fidelity; omitting them reduces snapshot size.
      slimDOMOptions: {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
      },
      errorHandler: function (error) {
        var typedError = error;
        // styled-components relies on this error being thrown and bubbled up, rrweb is otherwise suppressing it
        if (typedError.message.includes('insertRule') && typedError.message.includes('CSSStyleSheet')) {
          throw typedError;
        }
        // rrweb monkey-patches window functions like CSSStyleSheet.insertRule; errors from external callers
        // (e.g. styled-components) must be re-thrown so they aren't silently swallowed.
        if (typedError._external_) {
          throw typedError;
        }
        _this.loggerProvider.warn(errorLogPrefix, typedError.toString());
        // Return true so that we don't clutter user's consoles with internal rrweb errors
        return true;
      }
    });
  };
  SessionReplay.prototype._recordEventsInChildMode = function (recordFunction, sessionId, config, hooks) {
    // In child mode, rrweb detects window.parent !== window and routes events via
    // postMessage to the parent instead of calling emit. The emit callback is unused.
    // Note: recording plugins (URL tracking, console capture) are intentionally omitted
    // here — the child's events are merged into the parent stream, so URL changes inside
    // the iframe should not be recorded as parent page-view events.
    try {
      // Stop only the previous rrweb recording. Do NOT call stopRecordingEvents() here:
      // that would clear crossOriginParentSignalCleanup — the very listener that invoked
      // this method — making the child permanently deaf to subsequent stop/start cycles.
      this.recordCancelCallback && this.recordCancelCallback();
      this.recordCancelCallback = null;
      this.recordCancelCallback = recordFunction(_assign$(_assign$({}, this.buildRRWebRecordOptions(config, hooks, function () {
        // no-op: child events are forwarded to parent via postMessage by rrweb
      }, 'Error while capturing replay (child iframe): ')), {
        recordCrossOriginIframes: true
      }));
      this.loggerProvider.log("Session Replay child iframe capture beginning for session ".concat(sessionId, "."));
    } catch (error) {
      this.loggerProvider.warn('Failed to initialize session replay in child iframe mode:', error);
    }
  };
  SessionReplay.prototype.getDeviceId = function () {
    var _a;
    return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.deviceId;
  };
  SessionReplay.prototype.getSessionId = function () {
    var _a;
    return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
  };
  SessionReplay.prototype.start = function () {
    return returnWrapper(this._start());
  };
  SessionReplay.prototype._start = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.recordingEnabled = true;
            this.startChildRecordingOnSetup = true;
            return [4 /*yield*/, this.recordEvents()];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.stop = function () {
    this.recordingEnabled = false;
    this.startChildRecordingOnSetup = false;
    this.recordingGeneration++;
    this.stopRecordingEvents();
    this.sendEvents();
  };
  SessionReplay.prototype.flush = function (useRetry) {
    var _a;
    if (useRetry === void 0) {
      useRetry = false;
    }
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_b) {
        // Intentionally not gated on min_session_duration_ms. flush() forwards payloads
        // already queued in trackDestination, and every code path that queues into it —
        // sendCurrentSequenceEvents, addEvent's batch-split path, sendStoredEvents reading
        // sequencesToSend from IDB — has already passed the gate at the time of queuing.
        // A duplicate gate here would be unreachable.
        return [2 /*return*/, (_a = this.eventsManager) === null || _a === void 0 ? void 0 : _a.flush(useRetry)];
      });
    });
  };
  SessionReplay.prototype.shutdown = function () {
    var _a, _b;
    this.recordingEnabled = false;
    this.startChildRecordingOnSetup = false;
    this.recordingGeneration++;
    (_a = this.urlChangeCleanup) === null || _a === void 0 ? void 0 : _a.call(this);
    (_b = this.crossOriginParentSignalCleanup) === null || _b === void 0 ? void 0 : _b.call(this);
    this.crossOriginParentSignalCleanup = null;
    this.teardownEventListeners(true);
    this.stopRecordingEvents();
    this.sendEvents();
  };
  SessionReplay.prototype.mapSDKType = function (sdkType) {
    if (sdkType === 'plugin') {
      return '@amplitude/plugin-session-replay-browser';
    }
    if (sdkType === 'segment') {
      return '@amplitude/segment-session-replay-plugin';
    }
    return null;
  };
  SessionReplay.prototype.setMetadata = function (sessionId, joinedConfig, localConfig, remoteConfig, replaySDKVersion, standaloneSDKVersion, sdkType) {
    var hashValue = (sessionId === null || sessionId === void 0 ? void 0 : sessionId.toString()) ? generateHashCode(sessionId.toString()) : undefined;
    this.metadata = {
      joinedConfig: joinedConfig,
      localConfig: localConfig,
      remoteConfig: remoteConfig,
      sessionId: sessionId,
      hashValue: hashValue,
      sampleRate: joinedConfig.sampleRate,
      replaySDKType: this.mapSDKType(sdkType),
      replaySDKVersion: replaySDKVersion,
      standaloneSDKType: '@amplitude/session-replay-browser',
      standaloneSDKVersion: standaloneSDKVersion
    };
  };
  SessionReplay.prototype.initializeNetworkObservers = function () {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
      var NetworkObserversClass, error_6;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!(((_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.loggingConfig) === null || _b === void 0 ? void 0 : _b.network) === null || _c === void 0 ? void 0 : _c.enabled) && !this.networkObservers)) return [3 /*break*/, 4];
            _d.label = 1;
          case 1:
            _d.trys.push([1, 3,, 4]);
            return [4 /*yield*/, import('./observers-DasJBi_w.js')];
          case 2:
            NetworkObserversClass = _d.sent().NetworkObservers;
            this.networkObservers = new NetworkObserversClass();
            return [3 /*break*/, 4];
          case 3:
            error_6 = _d.sent();
            this.loggerProvider.warn('Failed to import or instantiate NetworkObservers:', error_6);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  return SessionReplay;
}();
var getLogConfig = function getLogConfig(sessionReplay) {
  return function () {
    var config = sessionReplay.config;
    var _a = config || getDefaultConfig(),
      logger = _a.loggerProvider,
      logLevel = _a.logLevel;
    return {
      logger: logger,
      logLevel: logLevel
    };
  };
};
var createInstance = function createInstance() {
  var sessionReplay = new SessionReplay();
  return {
    init: debugWrapper(sessionReplay.init.bind(sessionReplay), 'init', getLogConfig(sessionReplay)),
    evaluateTargetingAndCapture: debugWrapper(sessionReplay.evaluateTargetingAndCapture.bind(sessionReplay), 'evaluateTargetingAndRecord', getLogConfig(sessionReplay)),
    setSessionId: debugWrapper(sessionReplay.setSessionId.bind(sessionReplay), 'setSessionId', getLogConfig(sessionReplay)),
    getSessionId: debugWrapper(sessionReplay.getSessionId.bind(sessionReplay), 'getSessionId', getLogConfig(sessionReplay)),
    getSessionReplayProperties: debugWrapper(sessionReplay.getSessionReplayProperties.bind(sessionReplay), 'getSessionReplayProperties', getLogConfig(sessionReplay)),
    flush: debugWrapper(sessionReplay.flush.bind(sessionReplay), 'flush', getLogConfig(sessionReplay)),
    start: debugWrapper(sessionReplay.start.bind(sessionReplay), 'start', getLogConfig(sessionReplay)),
    stop: debugWrapper(sessionReplay.stop.bind(sessionReplay), 'stop', getLogConfig(sessionReplay)),
    shutdown: debugWrapper(sessionReplay.shutdown.bind(sessionReplay), 'shutdown', getLogConfig(sessionReplay))
  };
};
var sessionReplay = createInstance();
var init = sessionReplay.init,
  setSessionId = sessionReplay.setSessionId,
  getSessionId = sessionReplay.getSessionId,
  getSessionReplayProperties = sessionReplay.getSessionReplayProperties,
  flush = sessionReplay.flush,
  start = sessionReplay.start,
  stop = sessionReplay.stop,
  shutdown = sessionReplay.shutdown,
  evaluateTargetingAndCapture = sessionReplay.evaluateTargetingAndCapture;
export { SafeLoggerProvider as S, __values$1 as _, __spreadArray as a, __read$1 as b, __awaiter as c, __generator as d, _assign$ as e, getSessionId as f, getGlobalScope as g, getSessionReplayProperties as h, init as i, flush as j, start as k, stop as l, shutdown as m, evaluateTargetingAndCapture as n, openDB as o, setSessionId as s, truncateUtf8 as t };